/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedStripeConnectRouteImport } from './routes/_authenticated/stripe-connect'
import { Route as AuthenticatedOrgIdRouteImport } from './routes/_authenticated/$orgId'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedOrgIdWebsiteRouteImport } from './routes/_authenticated/$orgId/website'
import { Route as AuthenticatedOrgIdNoticationsCenterRouteImport } from './routes/_authenticated/$orgId/notications-center'
import { Route as AuthenticatedOrgIdMoneyRouteImport } from './routes/_authenticated/$orgId/money'
import { Route as AuthenticatedOrgIdImportsRouteImport } from './routes/_authenticated/$orgId/imports'
import { Route as AuthenticatedOrgIdAdminRouteImport } from './routes/_authenticated/$orgId/admin'
import { Route as AuthenticatedOrgIdActivityRouteImport } from './routes/_authenticated/$orgId/activity'
import { Route as authResetPasswordTokenRouteImport } from './routes/(auth)/reset-password.$token'
import { Route as AuthenticatedOrgIdWhatsNewIndexRouteImport } from './routes/_authenticated/$orgId/whats-new/index'
import { Route as AuthenticatedOrgIdWebsiteIndexRouteImport } from './routes/_authenticated/$orgId/website/index'
import { Route as AuthenticatedOrgIdUsersIndexRouteImport } from './routes/_authenticated/$orgId/users/index'
import { Route as AuthenticatedOrgIdSubscriptionsIndexRouteImport } from './routes/_authenticated/$orgId/subscriptions/index'
import { Route as AuthenticatedOrgIdStockImagesIndexRouteImport } from './routes/_authenticated/$orgId/stock-images/index'
import { Route as AuthenticatedOrgIdSettingsIndexRouteImport } from './routes/_authenticated/$orgId/settings/index'
import { Route as AuthenticatedOrgIdSeasonalContentIndexRouteImport } from './routes/_authenticated/$orgId/seasonal-content/index'
import { Route as AuthenticatedOrgIdSalesOrdersIndexRouteImport } from './routes/_authenticated/$orgId/sales-orders/index'
import { Route as AuthenticatedOrgIdReportsIndexRouteImport } from './routes/_authenticated/$orgId/reports/index'
import { Route as AuthenticatedOrgIdProductsIndexRouteImport } from './routes/_authenticated/$orgId/products/index'
import { Route as AuthenticatedOrgIdPricingIndexRouteImport } from './routes/_authenticated/$orgId/pricing/index'
import { Route as AuthenticatedOrgIdOrganizationsIndexRouteImport } from './routes/_authenticated/$orgId/organizations/index'
import { Route as AuthenticatedOrgIdMoneyIndexRouteImport } from './routes/_authenticated/$orgId/money/index'
import { Route as AuthenticatedOrgIdMessagesIndexRouteImport } from './routes/_authenticated/$orgId/messages/index'
import { Route as AuthenticatedOrgIdMarketingIndexRouteImport } from './routes/_authenticated/$orgId/marketing/index'
import { Route as AuthenticatedOrgIdImportsIndexRouteImport } from './routes/_authenticated/$orgId/imports/index'
import { Route as AuthenticatedOrgIdDesignsIndexRouteImport } from './routes/_authenticated/$orgId/designs/index'
import { Route as AuthenticatedOrgIdCustomersIndexRouteImport } from './routes/_authenticated/$orgId/customers/index'
import { Route as AuthenticatedOrgIdCustomerReviewsIndexRouteImport } from './routes/_authenticated/$orgId/customer-reviews/index'
import { Route as AuthenticatedOrgIdContractsIndexRouteImport } from './routes/_authenticated/$orgId/contracts/index'
import { Route as AuthenticatedOrgIdAvailabilityIndexRouteImport } from './routes/_authenticated/$orgId/availability/index'
import { Route as AuthenticatedOrgIdApiTokensIndexRouteImport } from './routes/_authenticated/$orgId/api-tokens/index'
import { Route as AuthenticatedOrgIdWhatsNewCreateRouteImport } from './routes/_authenticated/$orgId/whats-new/create'
import { Route as AuthenticatedOrgIdWhatsNewAppUpdateIdRouteImport } from './routes/_authenticated/$orgId/whats-new/$appUpdateId'
import { Route as AuthenticatedOrgIdWebsiteOverviewRouteImport } from './routes/_authenticated/$orgId/website/overview'
import { Route as AuthenticatedOrgIdWebsiteDomainLaunchRouteImport } from './routes/_authenticated/$orgId/website/domain-launch'
import { Route as AuthenticatedOrgIdWebsiteBuilderRouteImport } from './routes/_authenticated/$orgId/website/builder'
import { Route as AuthenticatedOrgIdUsersCreateRouteImport } from './routes/_authenticated/$orgId/users/create'
import { Route as AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRouteImport } from './routes/_authenticated/$orgId/subscriptions/$flowerSubscriptionId'
import { Route as AuthenticatedOrgIdStockImagesCreateRouteImport } from './routes/_authenticated/$orgId/stock-images/create'
import { Route as AuthenticatedOrgIdStockImagesStockImageIdRouteImport } from './routes/_authenticated/$orgId/stock-images/$stockImageId'
import { Route as AuthenticatedOrgIdSettingsIntegrationsRouteImport } from './routes/_authenticated/$orgId/settings/integrations'
import { Route as AuthenticatedOrgIdSeasonalContentCreateRouteImport } from './routes/_authenticated/$orgId/seasonal-content/create'
import { Route as AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRouteImport } from './routes/_authenticated/$orgId/seasonal-content/$seasonalDesignId'
import { Route as AuthenticatedOrgIdSalesOrdersWireInRouteImport } from './routes/_authenticated/$orgId/sales-orders/wire-in'
import { Route as AuthenticatedOrgIdSalesOrdersDraftsRouteImport } from './routes/_authenticated/$orgId/sales-orders/drafts'
import { Route as AuthenticatedOrgIdSalesOrdersCreateRouteImport } from './routes/_authenticated/$orgId/sales-orders/create'
import { Route as AuthenticatedOrgIdSalesOrdersSalesOrderIdRouteImport } from './routes/_authenticated/$orgId/sales-orders/$salesOrderId'
import { Route as AuthenticatedOrgIdReportsWiredOrdersRouteImport } from './routes/_authenticated/$orgId/reports/wired-orders'
import { Route as AuthenticatedOrgIdReportsSalesTaxRouteImport } from './routes/_authenticated/$orgId/reports/sales-tax'
import { Route as AuthenticatedOrgIdReportsSalesStatisticsRouteImport } from './routes/_authenticated/$orgId/reports/sales-statistics'
import { Route as AuthenticatedOrgIdReportsPlatformLedgerRouteImport } from './routes/_authenticated/$orgId/reports/platform-ledger'
import { Route as AuthenticatedOrgIdReportsPhoneClicksRouteImport } from './routes/_authenticated/$orgId/reports/phone-clicks'
import { Route as AuthenticatedOrgIdReportsExternalOrdersRouteImport } from './routes/_authenticated/$orgId/reports/external-orders'
import { Route as AuthenticatedOrgIdReportsDepositsRouteImport } from './routes/_authenticated/$orgId/reports/deposits'
import { Route as AuthenticatedOrgIdReportsCustomerBalancesRouteImport } from './routes/_authenticated/$orgId/reports/customer-balances'
import { Route as AuthenticatedOrgIdReportsClosedDaysRouteImport } from './routes/_authenticated/$orgId/reports/closed-days'
import { Route as AuthenticatedOrgIdReportsCashDrawerRouteImport } from './routes/_authenticated/$orgId/reports/cash-drawer'
import { Route as AuthenticatedOrgIdReportsAccountingJournalRouteImport } from './routes/_authenticated/$orgId/reports/accounting-journal'
import { Route as AuthenticatedOrgIdProductsInventoryRouteImport } from './routes/_authenticated/$orgId/products/inventory'
import { Route as AuthenticatedOrgIdProductsCreateRouteImport } from './routes/_authenticated/$orgId/products/create'
import { Route as AuthenticatedOrgIdProductsCatalogBuilderRouteImport } from './routes/_authenticated/$orgId/products/catalog-builder'
import { Route as AuthenticatedOrgIdProductsAllProductsRouteImport } from './routes/_authenticated/$orgId/products/all-products'
import { Route as AuthenticatedOrgIdProductsProductIdRouteImport } from './routes/_authenticated/$orgId/products/$productId'
import { Route as AuthenticatedOrgIdPricingCreateRouteImport } from './routes/_authenticated/$orgId/pricing/create'
import { Route as AuthenticatedOrgIdOrganizationsCreateRouteImport } from './routes/_authenticated/$orgId/organizations/create'
import { Route as AuthenticatedOrgIdOrganizationsOrganizationIdRouteImport } from './routes/_authenticated/$orgId/organizations/$organizationId'
import { Route as AuthenticatedOrgIdMoneyCustomerBalancesRouteImport } from './routes/_authenticated/$orgId/money/customer-balances'
import { Route as AuthenticatedOrgIdMoneyCashDrawerBalancingRouteImport } from './routes/_authenticated/$orgId/money/cash-drawer-balancing'
import { Route as AuthenticatedOrgIdMessagesCreateRouteImport } from './routes/_authenticated/$orgId/messages/create'
import { Route as AuthenticatedOrgIdMessagesMessageIdRouteImport } from './routes/_authenticated/$orgId/messages/$messageId'
import { Route as AuthenticatedOrgIdImportsProductImportRouteImport } from './routes/_authenticated/$orgId/imports/product-import'
import { Route as AuthenticatedOrgIdImportsFsnImportRouteImport } from './routes/_authenticated/$orgId/imports/fsn-import'
import { Route as AuthenticatedOrgIdImportsCustomerImportRouteImport } from './routes/_authenticated/$orgId/imports/customer-import'
import { Route as AuthenticatedOrgIdDesignsCreateRouteImport } from './routes/_authenticated/$orgId/designs/create'
import { Route as AuthenticatedOrgIdDesignsDesignIdRouteImport } from './routes/_authenticated/$orgId/designs/$designId'
import { Route as AuthenticatedOrgIdCustomersCreateRouteImport } from './routes/_authenticated/$orgId/customers/create'
import { Route as AuthenticatedOrgIdCustomersCustomerIdRouteImport } from './routes/_authenticated/$orgId/customers/$customerId'
import { Route as AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRouteImport } from './routes/_authenticated/$orgId/customer-reviews/$customerReviewId'
import { Route as AuthenticatedOrgIdContractsCreateRouteImport } from './routes/_authenticated/$orgId/contracts/create'
import { Route as AuthenticatedOrgIdWebsiteUrlRedirectsIndexRouteImport } from './routes/_authenticated/$orgId/website/url-redirects/index'
import { Route as AuthenticatedOrgIdWebsiteDomainsIndexRouteImport } from './routes/_authenticated/$orgId/website/domains/index'
import { Route as AuthenticatedOrgIdWebsiteCustomPagesIndexRouteImport } from './routes/_authenticated/$orgId/website/custom-pages/index'
import { Route as AuthenticatedOrgIdUsersUserIdIndexRouteImport } from './routes/_authenticated/$orgId/users/$userId/index'
import { Route as AuthenticatedOrgIdSettingsTerminalsIndexRouteImport } from './routes/_authenticated/$orgId/settings/terminals/index'
import { Route as AuthenticatedOrgIdSettingsTaxesIndexRouteImport } from './routes/_authenticated/$orgId/settings/taxes/index'
import { Route as AuthenticatedOrgIdSettingsSuperticketsIndexRouteImport } from './routes/_authenticated/$orgId/settings/supertickets/index'
import { Route as AuthenticatedOrgIdSettingsSubscriptionsIndexRouteImport } from './routes/_authenticated/$orgId/settings/subscriptions/index'
import { Route as AuthenticatedOrgIdSettingsStripeIndexRouteImport } from './routes/_authenticated/$orgId/settings/stripe/index'
import { Route as AuthenticatedOrgIdSettingsSnapdragonIndexRouteImport } from './routes/_authenticated/$orgId/settings/snapdragon/index'
import { Route as AuthenticatedOrgIdSettingsNotificationsIndexRouteImport } from './routes/_authenticated/$orgId/settings/notifications/index'
import { Route as AuthenticatedOrgIdSettingsLocationsIndexRouteImport } from './routes/_authenticated/$orgId/settings/locations/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/index'
import { Route as AuthenticatedOrgIdSettingsFsnNetworkIndexRouteImport } from './routes/_authenticated/$orgId/settings/fsn-network/index'
import { Route as AuthenticatedOrgIdSettingsFeesIndexRouteImport } from './routes/_authenticated/$orgId/settings/fees/index'
import { Route as AuthenticatedOrgIdSettingsEmailMarketingIndexRouteImport } from './routes/_authenticated/$orgId/settings/email-marketing/index'
import { Route as AuthenticatedOrgIdSettingsDomainsIndexRouteImport } from './routes/_authenticated/$orgId/settings/domains/index'
import { Route as AuthenticatedOrgIdSettingsCondolencesIndexRouteImport } from './routes/_authenticated/$orgId/settings/condolences/index'
import { Route as AuthenticatedOrgIdSettingsCheckoutIndexRouteImport } from './routes/_authenticated/$orgId/settings/checkout/index'
import { Route as AuthenticatedOrgIdSettingsCashDrawerIndexRouteImport } from './routes/_authenticated/$orgId/settings/cash-drawer/index'
import { Route as AuthenticatedOrgIdSettingsBillingIndexRouteImport } from './routes/_authenticated/$orgId/settings/billing/index'
import { Route as AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRouteImport } from './routes/_authenticated/$orgId/sales-orders/delivery-routes/index'
import { Route as AuthenticatedOrgIdReportsTipsIndexRouteImport } from './routes/_authenticated/$orgId/reports/tips/index'
import { Route as AuthenticatedOrgIdReportsSalesIndexRouteImport } from './routes/_authenticated/$orgId/reports/sales/index'
import { Route as AuthenticatedOrgIdReportsSalesTaxIndexRouteImport } from './routes/_authenticated/$orgId/reports/sales-tax/index'
import { Route as AuthenticatedOrgIdReportsSalesSummaryIndexRouteImport } from './routes/_authenticated/$orgId/reports/sales-summary/index'
import { Route as AuthenticatedOrgIdReportsSalesStatisticsIndexRouteImport } from './routes/_authenticated/$orgId/reports/sales-statistics/index'
import { Route as AuthenticatedOrgIdReportsPlatformLedgerIndexRouteImport } from './routes/_authenticated/$orgId/reports/platform-ledger/index'
import { Route as AuthenticatedOrgIdReportsPhoneClicksIndexRouteImport } from './routes/_authenticated/$orgId/reports/phone-clicks/index'
import { Route as AuthenticatedOrgIdReportsFloristPerformanceIndexRouteImport } from './routes/_authenticated/$orgId/reports/florist-performance/index'
import { Route as AuthenticatedOrgIdReportsDepositsIndexRouteImport } from './routes/_authenticated/$orgId/reports/deposits/index'
import { Route as AuthenticatedOrgIdReportsClosedDaysIndexRouteImport } from './routes/_authenticated/$orgId/reports/closed-days/index'
import { Route as AuthenticatedOrgIdReportsCashDrawerIndexRouteImport } from './routes/_authenticated/$orgId/reports/cash-drawer/index'
import { Route as AuthenticatedOrgIdReportsAccountingJournalIndexRouteImport } from './routes/_authenticated/$orgId/reports/accounting-journal/index'
import { Route as AuthenticatedOrgIdProductsPriceChangesIndexRouteImport } from './routes/_authenticated/$orgId/products/price-changes/index'
import { Route as AuthenticatedOrgIdProductsCollectionsIndexRouteImport } from './routes/_authenticated/$orgId/products/collections/index'
import { Route as AuthenticatedOrgIdProductsAddOnsIndexRouteImport } from './routes/_authenticated/$orgId/products/add-ons/index'
import { Route as AuthenticatedOrgIdProductsAddOnSetsIndexRouteImport } from './routes/_authenticated/$orgId/products/add-on-sets/index'
import { Route as AuthenticatedOrgIdOrganizationsOrganizationIdIndexRouteImport } from './routes/_authenticated/$orgId/organizations/$organizationId/index'
import { Route as AuthenticatedOrgIdMoneyStatementsIndexRouteImport } from './routes/_authenticated/$orgId/money/statements/index'
import { Route as AuthenticatedOrgIdMoneySalesIndexRouteImport } from './routes/_authenticated/$orgId/money/sales/index'
import { Route as AuthenticatedOrgIdMoneyCustomerBalancesIndexRouteImport } from './routes/_authenticated/$orgId/money/customer-balances/index'
import { Route as AuthenticatedOrgIdMarketingDiscountsIndexRouteImport } from './routes/_authenticated/$orgId/marketing/discounts/index'
import { Route as AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRouteImport } from './routes/_authenticated/$orgId/website/url-redirects/flower-shop-network'
import { Route as AuthenticatedOrgIdWebsiteDomainsCreateRouteImport } from './routes/_authenticated/$orgId/website/domains/create'
import { Route as AuthenticatedOrgIdWebsiteDomainsDomainIdRouteImport } from './routes/_authenticated/$orgId/website/domains/$domainId'
import { Route as AuthenticatedOrgIdWebsiteCustomPagesCreateRouteImport } from './routes/_authenticated/$orgId/website/custom-pages/create'
import { Route as AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRouteImport } from './routes/_authenticated/$orgId/website/custom-pages/$customPageId'
import { Route as AuthenticatedOrgIdUsersUserIdHistoryRouteImport } from './routes/_authenticated/$orgId/users/$userId/history'
import { Route as AuthenticatedOrgIdSettingsTerminalsCreateRouteImport } from './routes/_authenticated/$orgId/settings/terminals/create'
import { Route as AuthenticatedOrgIdSettingsTerminalsTerminalIdRouteImport } from './routes/_authenticated/$orgId/settings/terminals/$terminalId'
import { Route as AuthenticatedOrgIdSettingsTaxesHistoryRouteImport } from './routes/_authenticated/$orgId/settings/taxes/history'
import { Route as AuthenticatedOrgIdSettingsStripeUpgradeRouteImport } from './routes/_authenticated/$orgId/settings/stripe/upgrade'
import { Route as AuthenticatedOrgIdSettingsStripePayoutsRouteImport } from './routes/_authenticated/$orgId/settings/stripe/payouts'
import { Route as AuthenticatedOrgIdSettingsStripePaymentsRouteImport } from './routes/_authenticated/$orgId/settings/stripe/payments'
import { Route as AuthenticatedOrgIdSettingsStripePaymentMethodsRouteImport } from './routes/_authenticated/$orgId/settings/stripe/payment-methods'
import { Route as AuthenticatedOrgIdSettingsStripeOnboardingRouteImport } from './routes/_authenticated/$orgId/settings/stripe/onboarding'
import { Route as AuthenticatedOrgIdSettingsStripeDisputesRouteImport } from './routes/_authenticated/$orgId/settings/stripe/disputes'
import { Route as AuthenticatedOrgIdSettingsStripeCardReadersRouteImport } from './routes/_authenticated/$orgId/settings/stripe/card-readers'
import { Route as AuthenticatedOrgIdSettingsStripeAccountManagementRouteImport } from './routes/_authenticated/$orgId/settings/stripe/account-management'
import { Route as AuthenticatedOrgIdSettingsNotificationsCreateRouteImport } from './routes/_authenticated/$orgId/settings/notifications/create'
import { Route as AuthenticatedOrgIdSettingsNotificationsRecipientIdRouteImport } from './routes/_authenticated/$orgId/settings/notifications/$recipientId'
import { Route as AuthenticatedOrgIdSettingsLocationsCreateRouteImport } from './routes/_authenticated/$orgId/settings/locations/create'
import { Route as AuthenticatedOrgIdSettingsLocationsLocationIdRouteImport } from './routes/_authenticated/$orgId/settings/locations/$locationId'
import { Route as AuthenticatedOrgIdSettingsFeesHistoryRouteImport } from './routes/_authenticated/$orgId/settings/fees/history'
import { Route as AuthenticatedOrgIdSettingsDomainsCreateRouteImport } from './routes/_authenticated/$orgId/settings/domains/create'
import { Route as AuthenticatedOrgIdSettingsDomainsDomainIdRouteImport } from './routes/_authenticated/$orgId/settings/domains/$domainId'
import { Route as AuthenticatedOrgIdSettingsCashDrawerHistoryRouteImport } from './routes/_authenticated/$orgId/settings/cash-drawer/history'
import { Route as AuthenticatedOrgIdSettingsBillingHistoryRouteImport } from './routes/_authenticated/$orgId/settings/billing/history'
import { Route as AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRouteImport } from './routes/_authenticated/$orgId/sales-orders/delivery-routes/create'
import { Route as AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteImport } from './routes/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId'
import { Route as AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRouteImport } from './routes/_authenticated/$orgId/sales-orders/$salesOrderId_.journal'
import { Route as AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRouteImport } from './routes/_authenticated/$orgId/sales-orders/$salesOrderId_.history'
import { Route as AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRouteImport } from './routes/_authenticated/$orgId/sales-orders/$salesOrderId_.edit'
import { Route as AuthenticatedOrgIdReportsSalesDateRouteImport } from './routes/_authenticated/$orgId/reports/sales/$date'
import { Route as AuthenticatedOrgIdReportsSalesSummaryDateRouteImport } from './routes/_authenticated/$orgId/reports/sales-summary/$date'
import { Route as AuthenticatedOrgIdReportsDepositsDepositIdRouteImport } from './routes/_authenticated/$orgId/reports/deposits/$depositId'
import { Route as AuthenticatedOrgIdProductsPriceChangesCreateRouteImport } from './routes/_authenticated/$orgId/products/price-changes/create'
import { Route as AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRouteImport } from './routes/_authenticated/$orgId/products/price-changes/$priceAdjustmentId'
import { Route as AuthenticatedOrgIdProductsCollectionsImportRouteImport } from './routes/_authenticated/$orgId/products/collections/import'
import { Route as AuthenticatedOrgIdProductsCollectionsCreateRouteImport } from './routes/_authenticated/$orgId/products/collections/create'
import { Route as AuthenticatedOrgIdProductsCollectionsCollectionIdRouteImport } from './routes/_authenticated/$orgId/products/collections/$collectionId'
import { Route as AuthenticatedOrgIdProductsAddOnsCreateRouteImport } from './routes/_authenticated/$orgId/products/add-ons/create'
import { Route as AuthenticatedOrgIdProductsAddOnsAddOnIdRouteImport } from './routes/_authenticated/$orgId/products/add-ons/$addOnId'
import { Route as AuthenticatedOrgIdProductsAddOnSetsCreateRouteImport } from './routes/_authenticated/$orgId/products/add-on-sets/create'
import { Route as AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRouteImport } from './routes/_authenticated/$orgId/products/add-on-sets/$addOnSetId'
import { Route as AuthenticatedOrgIdProductsProductIdHistoryRouteImport } from './routes/_authenticated/$orgId/products/$productId_.history'
import { Route as AuthenticatedOrgIdMoneySalesDateRouteImport } from './routes/_authenticated/$orgId/money/sales/$date'
import { Route as AuthenticatedOrgIdGalleryAlbumCreateRouteImport } from './routes/_authenticated/$orgId/gallery/album/create'
import { Route as AuthenticatedOrgIdGalleryAlbumAlbumIdRouteImport } from './routes/_authenticated/$orgId/gallery/album/$albumId'
import { Route as AuthenticatedOrgIdDesignsDesignIdHistoryRouteImport } from './routes/_authenticated/$orgId/designs/$designId_.history'
import { Route as AuthenticatedOrgIdCustomersCustomerIdHistoryRouteImport } from './routes/_authenticated/$orgId/customers/$customerId_.history'
import { Route as AuthenticatedOrgIdSettingsLocationsLocationIdIndexRouteImport } from './routes/_authenticated/$orgId/settings/locations/$locationId/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/snapdragon/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/meta-pixel/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/google-tag-manager/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/google-analytics/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/fsn-network/index'
import { Route as AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRouteImport } from './routes/_authenticated/$orgId/settings/integrations/condolences/index'
import { Route as AuthenticatedOrgIdUsersUserIdRolesRoleIdRouteImport } from './routes/_authenticated/$orgId/users/$userId/roles/$roleId'
import { Route as AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRouteImport } from './routes/_authenticated/$orgId/settings/locations/$locationId/history'
import { Route as AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRouteImport } from './routes/_authenticated/$orgId/settings/integrations/snapdragon/history'
import { Route as AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRouteImport } from './routes/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId.edit'
import { Route as AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRouteImport } from './routes/_authenticated/$orgId/settings/locations/$locationId/hours/index'
import { Route as AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRouteImport } from './routes/_authenticated/$orgId/settings/locations/$locationId/deliveries/index'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedStripeConnectRoute =
  AuthenticatedStripeConnectRouteImport.update({
    id: '/stripe-connect',
    path: '/stripe-connect',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgIdRoute = AuthenticatedOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrgIdWebsiteRoute =
  AuthenticatedOrgIdWebsiteRouteImport.update({
    id: '/website',
    path: '/website',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdNoticationsCenterRoute =
  AuthenticatedOrgIdNoticationsCenterRouteImport.update({
    id: '/notications-center',
    path: '/notications-center',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMoneyRoute = AuthenticatedOrgIdMoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => AuthenticatedOrgIdRoute,
} as any)
const AuthenticatedOrgIdImportsRoute =
  AuthenticatedOrgIdImportsRouteImport.update({
    id: '/imports',
    path: '/imports',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdAdminRoute = AuthenticatedOrgIdAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedOrgIdRoute,
} as any)
const AuthenticatedOrgIdActivityRoute =
  AuthenticatedOrgIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const authResetPasswordTokenRoute = authResetPasswordTokenRouteImport.update({
  id: '/(auth)/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrgIdWhatsNewIndexRoute =
  AuthenticatedOrgIdWhatsNewIndexRouteImport.update({
    id: '/whats-new/',
    path: '/whats-new/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWebsiteIndexRoute =
  AuthenticatedOrgIdWebsiteIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdUsersIndexRoute =
  AuthenticatedOrgIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSubscriptionsIndexRoute =
  AuthenticatedOrgIdSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdStockImagesIndexRoute =
  AuthenticatedOrgIdStockImagesIndexRouteImport.update({
    id: '/stock-images/',
    path: '/stock-images/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsIndexRoute =
  AuthenticatedOrgIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSeasonalContentIndexRoute =
  AuthenticatedOrgIdSeasonalContentIndexRouteImport.update({
    id: '/seasonal-content/',
    path: '/seasonal-content/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersIndexRoute =
  AuthenticatedOrgIdSalesOrdersIndexRouteImport.update({
    id: '/sales-orders/',
    path: '/sales-orders/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsIndexRoute =
  AuthenticatedOrgIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsIndexRoute =
  AuthenticatedOrgIdProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdPricingIndexRoute =
  AuthenticatedOrgIdPricingIndexRouteImport.update({
    id: '/pricing/',
    path: '/pricing/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdOrganizationsIndexRoute =
  AuthenticatedOrgIdOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMoneyIndexRoute =
  AuthenticatedOrgIdMoneyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdMessagesIndexRoute =
  AuthenticatedOrgIdMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMarketingIndexRoute =
  AuthenticatedOrgIdMarketingIndexRouteImport.update({
    id: '/marketing/',
    path: '/marketing/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdImportsIndexRoute =
  AuthenticatedOrgIdImportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdImportsRoute,
  } as any)
const AuthenticatedOrgIdDesignsIndexRoute =
  AuthenticatedOrgIdDesignsIndexRouteImport.update({
    id: '/designs/',
    path: '/designs/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomersIndexRoute =
  AuthenticatedOrgIdCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomerReviewsIndexRoute =
  AuthenticatedOrgIdCustomerReviewsIndexRouteImport.update({
    id: '/customer-reviews/',
    path: '/customer-reviews/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdContractsIndexRoute =
  AuthenticatedOrgIdContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdAvailabilityIndexRoute =
  AuthenticatedOrgIdAvailabilityIndexRouteImport.update({
    id: '/availability/',
    path: '/availability/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdApiTokensIndexRoute =
  AuthenticatedOrgIdApiTokensIndexRouteImport.update({
    id: '/api-tokens/',
    path: '/api-tokens/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWhatsNewCreateRoute =
  AuthenticatedOrgIdWhatsNewCreateRouteImport.update({
    id: '/whats-new/create',
    path: '/whats-new/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWhatsNewAppUpdateIdRoute =
  AuthenticatedOrgIdWhatsNewAppUpdateIdRouteImport.update({
    id: '/whats-new/$appUpdateId',
    path: '/whats-new/$appUpdateId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWebsiteOverviewRoute =
  AuthenticatedOrgIdWebsiteOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteDomainLaunchRoute =
  AuthenticatedOrgIdWebsiteDomainLaunchRouteImport.update({
    id: '/domain-launch',
    path: '/domain-launch',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteBuilderRoute =
  AuthenticatedOrgIdWebsiteBuilderRouteImport.update({
    id: '/builder',
    path: '/builder',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdUsersCreateRoute =
  AuthenticatedOrgIdUsersCreateRouteImport.update({
    id: '/users/create',
    path: '/users/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute =
  AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRouteImport.update({
    id: '/subscriptions/$flowerSubscriptionId',
    path: '/subscriptions/$flowerSubscriptionId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdStockImagesCreateRoute =
  AuthenticatedOrgIdStockImagesCreateRouteImport.update({
    id: '/stock-images/create',
    path: '/stock-images/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdStockImagesStockImageIdRoute =
  AuthenticatedOrgIdStockImagesStockImageIdRouteImport.update({
    id: '/stock-images/$stockImageId',
    path: '/stock-images/$stockImageId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsRoute =
  AuthenticatedOrgIdSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSeasonalContentCreateRoute =
  AuthenticatedOrgIdSeasonalContentCreateRouteImport.update({
    id: '/seasonal-content/create',
    path: '/seasonal-content/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute =
  AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRouteImport.update({
    id: '/seasonal-content/$seasonalDesignId',
    path: '/seasonal-content/$seasonalDesignId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersWireInRoute =
  AuthenticatedOrgIdSalesOrdersWireInRouteImport.update({
    id: '/sales-orders/wire-in',
    path: '/sales-orders/wire-in',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersDraftsRoute =
  AuthenticatedOrgIdSalesOrdersDraftsRouteImport.update({
    id: '/sales-orders/drafts',
    path: '/sales-orders/drafts',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersCreateRoute =
  AuthenticatedOrgIdSalesOrdersCreateRouteImport.update({
    id: '/sales-orders/create',
    path: '/sales-orders/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute =
  AuthenticatedOrgIdSalesOrdersSalesOrderIdRouteImport.update({
    id: '/sales-orders/$salesOrderId',
    path: '/sales-orders/$salesOrderId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsWiredOrdersRoute =
  AuthenticatedOrgIdReportsWiredOrdersRouteImport.update({
    id: '/reports/wired-orders',
    path: '/reports/wired-orders',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesTaxRoute =
  AuthenticatedOrgIdReportsSalesTaxRouteImport.update({
    id: '/reports/sales-tax',
    path: '/reports/sales-tax',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesStatisticsRoute =
  AuthenticatedOrgIdReportsSalesStatisticsRouteImport.update({
    id: '/reports/sales-statistics',
    path: '/reports/sales-statistics',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsPlatformLedgerRoute =
  AuthenticatedOrgIdReportsPlatformLedgerRouteImport.update({
    id: '/reports/platform-ledger',
    path: '/reports/platform-ledger',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsPhoneClicksRoute =
  AuthenticatedOrgIdReportsPhoneClicksRouteImport.update({
    id: '/reports/phone-clicks',
    path: '/reports/phone-clicks',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsExternalOrdersRoute =
  AuthenticatedOrgIdReportsExternalOrdersRouteImport.update({
    id: '/reports/external-orders',
    path: '/reports/external-orders',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsDepositsRoute =
  AuthenticatedOrgIdReportsDepositsRouteImport.update({
    id: '/reports/deposits',
    path: '/reports/deposits',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsCustomerBalancesRoute =
  AuthenticatedOrgIdReportsCustomerBalancesRouteImport.update({
    id: '/reports/customer-balances',
    path: '/reports/customer-balances',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsClosedDaysRoute =
  AuthenticatedOrgIdReportsClosedDaysRouteImport.update({
    id: '/reports/closed-days',
    path: '/reports/closed-days',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsCashDrawerRoute =
  AuthenticatedOrgIdReportsCashDrawerRouteImport.update({
    id: '/reports/cash-drawer',
    path: '/reports/cash-drawer',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsAccountingJournalRoute =
  AuthenticatedOrgIdReportsAccountingJournalRouteImport.update({
    id: '/reports/accounting-journal',
    path: '/reports/accounting-journal',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsInventoryRoute =
  AuthenticatedOrgIdProductsInventoryRouteImport.update({
    id: '/products/inventory',
    path: '/products/inventory',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCreateRoute =
  AuthenticatedOrgIdProductsCreateRouteImport.update({
    id: '/products/create',
    path: '/products/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCatalogBuilderRoute =
  AuthenticatedOrgIdProductsCatalogBuilderRouteImport.update({
    id: '/products/catalog-builder',
    path: '/products/catalog-builder',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAllProductsRoute =
  AuthenticatedOrgIdProductsAllProductsRouteImport.update({
    id: '/products/all-products',
    path: '/products/all-products',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsProductIdRoute =
  AuthenticatedOrgIdProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdPricingCreateRoute =
  AuthenticatedOrgIdPricingCreateRouteImport.update({
    id: '/pricing/create',
    path: '/pricing/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdOrganizationsCreateRoute =
  AuthenticatedOrgIdOrganizationsCreateRouteImport.update({
    id: '/organizations/create',
    path: '/organizations/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdOrganizationsOrganizationIdRoute =
  AuthenticatedOrgIdOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMoneyCustomerBalancesRoute =
  AuthenticatedOrgIdMoneyCustomerBalancesRouteImport.update({
    id: '/customer-balances',
    path: '/customer-balances',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdMoneyCashDrawerBalancingRoute =
  AuthenticatedOrgIdMoneyCashDrawerBalancingRouteImport.update({
    id: '/cash-drawer-balancing',
    path: '/cash-drawer-balancing',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdMessagesCreateRoute =
  AuthenticatedOrgIdMessagesCreateRouteImport.update({
    id: '/messages/create',
    path: '/messages/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMessagesMessageIdRoute =
  AuthenticatedOrgIdMessagesMessageIdRouteImport.update({
    id: '/messages/$messageId',
    path: '/messages/$messageId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdImportsProductImportRoute =
  AuthenticatedOrgIdImportsProductImportRouteImport.update({
    id: '/product-import',
    path: '/product-import',
    getParentRoute: () => AuthenticatedOrgIdImportsRoute,
  } as any)
const AuthenticatedOrgIdImportsFsnImportRoute =
  AuthenticatedOrgIdImportsFsnImportRouteImport.update({
    id: '/fsn-import',
    path: '/fsn-import',
    getParentRoute: () => AuthenticatedOrgIdImportsRoute,
  } as any)
const AuthenticatedOrgIdImportsCustomerImportRoute =
  AuthenticatedOrgIdImportsCustomerImportRouteImport.update({
    id: '/customer-import',
    path: '/customer-import',
    getParentRoute: () => AuthenticatedOrgIdImportsRoute,
  } as any)
const AuthenticatedOrgIdDesignsCreateRoute =
  AuthenticatedOrgIdDesignsCreateRouteImport.update({
    id: '/designs/create',
    path: '/designs/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdDesignsDesignIdRoute =
  AuthenticatedOrgIdDesignsDesignIdRouteImport.update({
    id: '/designs/$designId',
    path: '/designs/$designId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomersCreateRoute =
  AuthenticatedOrgIdCustomersCreateRouteImport.update({
    id: '/customers/create',
    path: '/customers/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomersCustomerIdRoute =
  AuthenticatedOrgIdCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute =
  AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRouteImport.update({
    id: '/customer-reviews/$customerReviewId',
    path: '/customer-reviews/$customerReviewId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdContractsCreateRoute =
  AuthenticatedOrgIdContractsCreateRouteImport.update({
    id: '/contracts/create',
    path: '/contracts/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute =
  AuthenticatedOrgIdWebsiteUrlRedirectsIndexRouteImport.update({
    id: '/url-redirects/',
    path: '/url-redirects/',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteDomainsIndexRoute =
  AuthenticatedOrgIdWebsiteDomainsIndexRouteImport.update({
    id: '/domains/',
    path: '/domains/',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteCustomPagesIndexRoute =
  AuthenticatedOrgIdWebsiteCustomPagesIndexRouteImport.update({
    id: '/custom-pages/',
    path: '/custom-pages/',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdUsersUserIdIndexRoute =
  AuthenticatedOrgIdUsersUserIdIndexRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsTerminalsIndexRoute =
  AuthenticatedOrgIdSettingsTerminalsIndexRouteImport.update({
    id: '/settings/terminals/',
    path: '/settings/terminals/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsTaxesIndexRoute =
  AuthenticatedOrgIdSettingsTaxesIndexRouteImport.update({
    id: '/settings/taxes/',
    path: '/settings/taxes/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsSuperticketsIndexRoute =
  AuthenticatedOrgIdSettingsSuperticketsIndexRouteImport.update({
    id: '/settings/supertickets/',
    path: '/settings/supertickets/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsSubscriptionsIndexRoute =
  AuthenticatedOrgIdSettingsSubscriptionsIndexRouteImport.update({
    id: '/settings/subscriptions/',
    path: '/settings/subscriptions/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeIndexRoute =
  AuthenticatedOrgIdSettingsStripeIndexRouteImport.update({
    id: '/settings/stripe/',
    path: '/settings/stripe/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsSnapdragonIndexRoute =
  AuthenticatedOrgIdSettingsSnapdragonIndexRouteImport.update({
    id: '/settings/snapdragon/',
    path: '/settings/snapdragon/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsNotificationsIndexRoute =
  AuthenticatedOrgIdSettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsIndexRoute =
  AuthenticatedOrgIdSettingsLocationsIndexRouteImport.update({
    id: '/settings/locations/',
    path: '/settings/locations/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSettingsFsnNetworkIndexRoute =
  AuthenticatedOrgIdSettingsFsnNetworkIndexRouteImport.update({
    id: '/settings/fsn-network/',
    path: '/settings/fsn-network/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsFeesIndexRoute =
  AuthenticatedOrgIdSettingsFeesIndexRouteImport.update({
    id: '/settings/fees/',
    path: '/settings/fees/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsEmailMarketingIndexRoute =
  AuthenticatedOrgIdSettingsEmailMarketingIndexRouteImport.update({
    id: '/settings/email-marketing/',
    path: '/settings/email-marketing/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsDomainsIndexRoute =
  AuthenticatedOrgIdSettingsDomainsIndexRouteImport.update({
    id: '/settings/domains/',
    path: '/settings/domains/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsCondolencesIndexRoute =
  AuthenticatedOrgIdSettingsCondolencesIndexRouteImport.update({
    id: '/settings/condolences/',
    path: '/settings/condolences/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsCheckoutIndexRoute =
  AuthenticatedOrgIdSettingsCheckoutIndexRouteImport.update({
    id: '/settings/checkout/',
    path: '/settings/checkout/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsCashDrawerIndexRoute =
  AuthenticatedOrgIdSettingsCashDrawerIndexRouteImport.update({
    id: '/settings/cash-drawer/',
    path: '/settings/cash-drawer/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsBillingIndexRoute =
  AuthenticatedOrgIdSettingsBillingIndexRouteImport.update({
    id: '/settings/billing/',
    path: '/settings/billing/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute =
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRouteImport.update({
    id: '/sales-orders/delivery-routes/',
    path: '/sales-orders/delivery-routes/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsTipsIndexRoute =
  AuthenticatedOrgIdReportsTipsIndexRouteImport.update({
    id: '/reports/tips/',
    path: '/reports/tips/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesIndexRoute =
  AuthenticatedOrgIdReportsSalesIndexRouteImport.update({
    id: '/reports/sales/',
    path: '/reports/sales/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesTaxIndexRoute =
  AuthenticatedOrgIdReportsSalesTaxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsSalesTaxRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesSummaryIndexRoute =
  AuthenticatedOrgIdReportsSalesSummaryIndexRouteImport.update({
    id: '/reports/sales-summary/',
    path: '/reports/sales-summary/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesStatisticsIndexRoute =
  AuthenticatedOrgIdReportsSalesStatisticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsSalesStatisticsRoute,
  } as any)
const AuthenticatedOrgIdReportsPlatformLedgerIndexRoute =
  AuthenticatedOrgIdReportsPlatformLedgerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsPlatformLedgerRoute,
  } as any)
const AuthenticatedOrgIdReportsPhoneClicksIndexRoute =
  AuthenticatedOrgIdReportsPhoneClicksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsPhoneClicksRoute,
  } as any)
const AuthenticatedOrgIdReportsFloristPerformanceIndexRoute =
  AuthenticatedOrgIdReportsFloristPerformanceIndexRouteImport.update({
    id: '/reports/florist-performance/',
    path: '/reports/florist-performance/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsDepositsIndexRoute =
  AuthenticatedOrgIdReportsDepositsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsDepositsRoute,
  } as any)
const AuthenticatedOrgIdReportsClosedDaysIndexRoute =
  AuthenticatedOrgIdReportsClosedDaysIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsClosedDaysRoute,
  } as any)
const AuthenticatedOrgIdReportsCashDrawerIndexRoute =
  AuthenticatedOrgIdReportsCashDrawerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsCashDrawerRoute,
  } as any)
const AuthenticatedOrgIdReportsAccountingJournalIndexRoute =
  AuthenticatedOrgIdReportsAccountingJournalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdReportsAccountingJournalRoute,
  } as any)
const AuthenticatedOrgIdProductsPriceChangesIndexRoute =
  AuthenticatedOrgIdProductsPriceChangesIndexRouteImport.update({
    id: '/products/price-changes/',
    path: '/products/price-changes/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCollectionsIndexRoute =
  AuthenticatedOrgIdProductsCollectionsIndexRouteImport.update({
    id: '/products/collections/',
    path: '/products/collections/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnsIndexRoute =
  AuthenticatedOrgIdProductsAddOnsIndexRouteImport.update({
    id: '/products/add-ons/',
    path: '/products/add-ons/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnSetsIndexRoute =
  AuthenticatedOrgIdProductsAddOnSetsIndexRouteImport.update({
    id: '/products/add-on-sets/',
    path: '/products/add-on-sets/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute =
  AuthenticatedOrgIdOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdOrganizationsOrganizationIdRoute,
  } as any)
const AuthenticatedOrgIdMoneyStatementsIndexRoute =
  AuthenticatedOrgIdMoneyStatementsIndexRouteImport.update({
    id: '/statements/',
    path: '/statements/',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdMoneySalesIndexRoute =
  AuthenticatedOrgIdMoneySalesIndexRouteImport.update({
    id: '/sales/',
    path: '/sales/',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute =
  AuthenticatedOrgIdMoneyCustomerBalancesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdMoneyCustomerBalancesRoute,
  } as any)
const AuthenticatedOrgIdMarketingDiscountsIndexRoute =
  AuthenticatedOrgIdMarketingDiscountsIndexRouteImport.update({
    id: '/marketing/discounts/',
    path: '/marketing/discounts/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute =
  AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRouteImport.update({
    id: '/url-redirects/flower-shop-network',
    path: '/url-redirects/flower-shop-network',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteDomainsCreateRoute =
  AuthenticatedOrgIdWebsiteDomainsCreateRouteImport.update({
    id: '/domains/create',
    path: '/domains/create',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteDomainsDomainIdRoute =
  AuthenticatedOrgIdWebsiteDomainsDomainIdRouteImport.update({
    id: '/domains/$domainId',
    path: '/domains/$domainId',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteCustomPagesCreateRoute =
  AuthenticatedOrgIdWebsiteCustomPagesCreateRouteImport.update({
    id: '/custom-pages/create',
    path: '/custom-pages/create',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute =
  AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRouteImport.update({
    id: '/custom-pages/$customPageId',
    path: '/custom-pages/$customPageId',
    getParentRoute: () => AuthenticatedOrgIdWebsiteRoute,
  } as any)
const AuthenticatedOrgIdUsersUserIdHistoryRoute =
  AuthenticatedOrgIdUsersUserIdHistoryRouteImport.update({
    id: '/users/$userId/history',
    path: '/users/$userId/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsTerminalsCreateRoute =
  AuthenticatedOrgIdSettingsTerminalsCreateRouteImport.update({
    id: '/settings/terminals/create',
    path: '/settings/terminals/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute =
  AuthenticatedOrgIdSettingsTerminalsTerminalIdRouteImport.update({
    id: '/settings/terminals/$terminalId',
    path: '/settings/terminals/$terminalId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsTaxesHistoryRoute =
  AuthenticatedOrgIdSettingsTaxesHistoryRouteImport.update({
    id: '/settings/taxes/history',
    path: '/settings/taxes/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeUpgradeRoute =
  AuthenticatedOrgIdSettingsStripeUpgradeRouteImport.update({
    id: '/settings/stripe/upgrade',
    path: '/settings/stripe/upgrade',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripePayoutsRoute =
  AuthenticatedOrgIdSettingsStripePayoutsRouteImport.update({
    id: '/settings/stripe/payouts',
    path: '/settings/stripe/payouts',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripePaymentsRoute =
  AuthenticatedOrgIdSettingsStripePaymentsRouteImport.update({
    id: '/settings/stripe/payments',
    path: '/settings/stripe/payments',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripePaymentMethodsRoute =
  AuthenticatedOrgIdSettingsStripePaymentMethodsRouteImport.update({
    id: '/settings/stripe/payment-methods',
    path: '/settings/stripe/payment-methods',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeOnboardingRoute =
  AuthenticatedOrgIdSettingsStripeOnboardingRouteImport.update({
    id: '/settings/stripe/onboarding',
    path: '/settings/stripe/onboarding',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeDisputesRoute =
  AuthenticatedOrgIdSettingsStripeDisputesRouteImport.update({
    id: '/settings/stripe/disputes',
    path: '/settings/stripe/disputes',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeCardReadersRoute =
  AuthenticatedOrgIdSettingsStripeCardReadersRouteImport.update({
    id: '/settings/stripe/card-readers',
    path: '/settings/stripe/card-readers',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsStripeAccountManagementRoute =
  AuthenticatedOrgIdSettingsStripeAccountManagementRouteImport.update({
    id: '/settings/stripe/account-management',
    path: '/settings/stripe/account-management',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsNotificationsCreateRoute =
  AuthenticatedOrgIdSettingsNotificationsCreateRouteImport.update({
    id: '/settings/notifications/create',
    path: '/settings/notifications/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute =
  AuthenticatedOrgIdSettingsNotificationsRecipientIdRouteImport.update({
    id: '/settings/notifications/$recipientId',
    path: '/settings/notifications/$recipientId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsCreateRoute =
  AuthenticatedOrgIdSettingsLocationsCreateRouteImport.update({
    id: '/settings/locations/create',
    path: '/settings/locations/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsLocationIdRoute =
  AuthenticatedOrgIdSettingsLocationsLocationIdRouteImport.update({
    id: '/settings/locations/$locationId',
    path: '/settings/locations/$locationId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsFeesHistoryRoute =
  AuthenticatedOrgIdSettingsFeesHistoryRouteImport.update({
    id: '/settings/fees/history',
    path: '/settings/fees/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsDomainsCreateRoute =
  AuthenticatedOrgIdSettingsDomainsCreateRouteImport.update({
    id: '/settings/domains/create',
    path: '/settings/domains/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsDomainsDomainIdRoute =
  AuthenticatedOrgIdSettingsDomainsDomainIdRouteImport.update({
    id: '/settings/domains/$domainId',
    path: '/settings/domains/$domainId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsCashDrawerHistoryRoute =
  AuthenticatedOrgIdSettingsCashDrawerHistoryRouteImport.update({
    id: '/settings/cash-drawer/history',
    path: '/settings/cash-drawer/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsBillingHistoryRoute =
  AuthenticatedOrgIdSettingsBillingHistoryRouteImport.update({
    id: '/settings/billing/history',
    path: '/settings/billing/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute =
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRouteImport.update({
    id: '/sales-orders/delivery-routes/create',
    path: '/sales-orders/delivery-routes/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute =
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteImport.update({
    id: '/sales-orders/delivery-routes/$deliveryShareId',
    path: '/sales-orders/delivery-routes/$deliveryShareId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute =
  AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRouteImport.update({
    id: '/sales-orders/$salesOrderId_/journal',
    path: '/sales-orders/$salesOrderId/journal',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute =
  AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRouteImport.update({
    id: '/sales-orders/$salesOrderId_/history',
    path: '/sales-orders/$salesOrderId/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute =
  AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRouteImport.update({
    id: '/sales-orders/$salesOrderId_/edit',
    path: '/sales-orders/$salesOrderId/edit',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesDateRoute =
  AuthenticatedOrgIdReportsSalesDateRouteImport.update({
    id: '/reports/sales/$date',
    path: '/reports/sales/$date',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsSalesSummaryDateRoute =
  AuthenticatedOrgIdReportsSalesSummaryDateRouteImport.update({
    id: '/reports/sales-summary/$date',
    path: '/reports/sales-summary/$date',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdReportsDepositsDepositIdRoute =
  AuthenticatedOrgIdReportsDepositsDepositIdRouteImport.update({
    id: '/$depositId',
    path: '/$depositId',
    getParentRoute: () => AuthenticatedOrgIdReportsDepositsRoute,
  } as any)
const AuthenticatedOrgIdProductsPriceChangesCreateRoute =
  AuthenticatedOrgIdProductsPriceChangesCreateRouteImport.update({
    id: '/products/price-changes/create',
    path: '/products/price-changes/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute =
  AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRouteImport.update({
    id: '/products/price-changes/$priceAdjustmentId',
    path: '/products/price-changes/$priceAdjustmentId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCollectionsImportRoute =
  AuthenticatedOrgIdProductsCollectionsImportRouteImport.update({
    id: '/products/collections/import',
    path: '/products/collections/import',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCollectionsCreateRoute =
  AuthenticatedOrgIdProductsCollectionsCreateRouteImport.update({
    id: '/products/collections/create',
    path: '/products/collections/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsCollectionsCollectionIdRoute =
  AuthenticatedOrgIdProductsCollectionsCollectionIdRouteImport.update({
    id: '/products/collections/$collectionId',
    path: '/products/collections/$collectionId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnsCreateRoute =
  AuthenticatedOrgIdProductsAddOnsCreateRouteImport.update({
    id: '/products/add-ons/create',
    path: '/products/add-ons/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnsAddOnIdRoute =
  AuthenticatedOrgIdProductsAddOnsAddOnIdRouteImport.update({
    id: '/products/add-ons/$addOnId',
    path: '/products/add-ons/$addOnId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnSetsCreateRoute =
  AuthenticatedOrgIdProductsAddOnSetsCreateRouteImport.update({
    id: '/products/add-on-sets/create',
    path: '/products/add-on-sets/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute =
  AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRouteImport.update({
    id: '/products/add-on-sets/$addOnSetId',
    path: '/products/add-on-sets/$addOnSetId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdProductsProductIdHistoryRoute =
  AuthenticatedOrgIdProductsProductIdHistoryRouteImport.update({
    id: '/products/$productId_/history',
    path: '/products/$productId/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMoneySalesDateRoute =
  AuthenticatedOrgIdMoneySalesDateRouteImport.update({
    id: '/sales/$date',
    path: '/sales/$date',
    getParentRoute: () => AuthenticatedOrgIdMoneyRoute,
  } as any)
const AuthenticatedOrgIdGalleryAlbumCreateRoute =
  AuthenticatedOrgIdGalleryAlbumCreateRouteImport.update({
    id: '/gallery/album/create',
    path: '/gallery/album/create',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdGalleryAlbumAlbumIdRoute =
  AuthenticatedOrgIdGalleryAlbumAlbumIdRouteImport.update({
    id: '/gallery/album/$albumId',
    path: '/gallery/album/$albumId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdDesignsDesignIdHistoryRoute =
  AuthenticatedOrgIdDesignsDesignIdHistoryRouteImport.update({
    id: '/designs/$designId_/history',
    path: '/designs/$designId/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCustomersCustomerIdHistoryRoute =
  AuthenticatedOrgIdCustomersCustomerIdHistoryRouteImport.update({
    id: '/customers/$customerId_/history',
    path: '/customers/$customerId/history',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute =
  AuthenticatedOrgIdSettingsLocationsLocationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRouteImport.update({
    id: '/snapdragon/',
    path: '/snapdragon/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRouteImport.update({
    id: '/meta-pixel/',
    path: '/meta-pixel/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRouteImport.update(
    {
      id: '/google-tag-manager/',
      path: '/google-tag-manager/',
      getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
    } as any,
  )
const AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRouteImport.update({
    id: '/google-analytics/',
    path: '/google-analytics/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRouteImport.update({
    id: '/fsn-network/',
    path: '/fsn-network/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute =
  AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRouteImport.update({
    id: '/condolences/',
    path: '/condolences/',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute =
  AuthenticatedOrgIdUsersUserIdRolesRoleIdRouteImport.update({
    id: '/users/$userId/roles/$roleId',
    path: '/users/$userId/roles/$roleId',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute =
  AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthenticatedOrgIdSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute =
  AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRouteImport.update({
    id: '/snapdragon/history',
    path: '/snapdragon/history',
    getParentRoute: () => AuthenticatedOrgIdSettingsIntegrationsRoute,
  } as any)
const AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute =
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute,
    } as any,
  )
const AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute =
  AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRouteImport.update({
    id: '/hours/',
    path: '/hours/',
    getParentRoute: () => AuthenticatedOrgIdSettingsLocationsLocationIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute =
  AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRouteImport.update(
    {
      id: '/deliveries/',
      path: '/deliveries/',
      getParentRoute: () => AuthenticatedOrgIdSettingsLocationsLocationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/$orgId': typeof AuthenticatedOrgIdRouteWithChildren
  '/stripe-connect': typeof AuthenticatedStripeConnectRoute
  '/reset-password/$token': typeof authResetPasswordTokenRoute
  '/$orgId/activity': typeof AuthenticatedOrgIdActivityRoute
  '/$orgId/admin': typeof AuthenticatedOrgIdAdminRoute
  '/$orgId/imports': typeof AuthenticatedOrgIdImportsRouteWithChildren
  '/$orgId/money': typeof AuthenticatedOrgIdMoneyRouteWithChildren
  '/$orgId/notications-center': typeof AuthenticatedOrgIdNoticationsCenterRoute
  '/$orgId/website': typeof AuthenticatedOrgIdWebsiteRouteWithChildren
  '/$orgId/contracts/create': typeof AuthenticatedOrgIdContractsCreateRoute
  '/$orgId/customer-reviews/$customerReviewId': typeof AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute
  '/$orgId/customers/$customerId': typeof AuthenticatedOrgIdCustomersCustomerIdRoute
  '/$orgId/customers/create': typeof AuthenticatedOrgIdCustomersCreateRoute
  '/$orgId/designs/$designId': typeof AuthenticatedOrgIdDesignsDesignIdRoute
  '/$orgId/designs/create': typeof AuthenticatedOrgIdDesignsCreateRoute
  '/$orgId/imports/customer-import': typeof AuthenticatedOrgIdImportsCustomerImportRoute
  '/$orgId/imports/fsn-import': typeof AuthenticatedOrgIdImportsFsnImportRoute
  '/$orgId/imports/product-import': typeof AuthenticatedOrgIdImportsProductImportRoute
  '/$orgId/messages/$messageId': typeof AuthenticatedOrgIdMessagesMessageIdRoute
  '/$orgId/messages/create': typeof AuthenticatedOrgIdMessagesCreateRoute
  '/$orgId/money/cash-drawer-balancing': typeof AuthenticatedOrgIdMoneyCashDrawerBalancingRoute
  '/$orgId/money/customer-balances': typeof AuthenticatedOrgIdMoneyCustomerBalancesRouteWithChildren
  '/$orgId/organizations/$organizationId': typeof AuthenticatedOrgIdOrganizationsOrganizationIdRouteWithChildren
  '/$orgId/organizations/create': typeof AuthenticatedOrgIdOrganizationsCreateRoute
  '/$orgId/pricing/create': typeof AuthenticatedOrgIdPricingCreateRoute
  '/$orgId/products/$productId': typeof AuthenticatedOrgIdProductsProductIdRoute
  '/$orgId/products/all-products': typeof AuthenticatedOrgIdProductsAllProductsRoute
  '/$orgId/products/catalog-builder': typeof AuthenticatedOrgIdProductsCatalogBuilderRoute
  '/$orgId/products/create': typeof AuthenticatedOrgIdProductsCreateRoute
  '/$orgId/products/inventory': typeof AuthenticatedOrgIdProductsInventoryRoute
  '/$orgId/reports/accounting-journal': typeof AuthenticatedOrgIdReportsAccountingJournalRouteWithChildren
  '/$orgId/reports/cash-drawer': typeof AuthenticatedOrgIdReportsCashDrawerRouteWithChildren
  '/$orgId/reports/closed-days': typeof AuthenticatedOrgIdReportsClosedDaysRouteWithChildren
  '/$orgId/reports/customer-balances': typeof AuthenticatedOrgIdReportsCustomerBalancesRoute
  '/$orgId/reports/deposits': typeof AuthenticatedOrgIdReportsDepositsRouteWithChildren
  '/$orgId/reports/external-orders': typeof AuthenticatedOrgIdReportsExternalOrdersRoute
  '/$orgId/reports/phone-clicks': typeof AuthenticatedOrgIdReportsPhoneClicksRouteWithChildren
  '/$orgId/reports/platform-ledger': typeof AuthenticatedOrgIdReportsPlatformLedgerRouteWithChildren
  '/$orgId/reports/sales-statistics': typeof AuthenticatedOrgIdReportsSalesStatisticsRouteWithChildren
  '/$orgId/reports/sales-tax': typeof AuthenticatedOrgIdReportsSalesTaxRouteWithChildren
  '/$orgId/reports/wired-orders': typeof AuthenticatedOrgIdReportsWiredOrdersRoute
  '/$orgId/sales-orders/$salesOrderId': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute
  '/$orgId/sales-orders/create': typeof AuthenticatedOrgIdSalesOrdersCreateRoute
  '/$orgId/sales-orders/drafts': typeof AuthenticatedOrgIdSalesOrdersDraftsRoute
  '/$orgId/sales-orders/wire-in': typeof AuthenticatedOrgIdSalesOrdersWireInRoute
  '/$orgId/seasonal-content/$seasonalDesignId': typeof AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute
  '/$orgId/seasonal-content/create': typeof AuthenticatedOrgIdSeasonalContentCreateRoute
  '/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsRouteWithChildren
  '/$orgId/stock-images/$stockImageId': typeof AuthenticatedOrgIdStockImagesStockImageIdRoute
  '/$orgId/stock-images/create': typeof AuthenticatedOrgIdStockImagesCreateRoute
  '/$orgId/subscriptions/$flowerSubscriptionId': typeof AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute
  '/$orgId/users/create': typeof AuthenticatedOrgIdUsersCreateRoute
  '/$orgId/website/builder': typeof AuthenticatedOrgIdWebsiteBuilderRoute
  '/$orgId/website/domain-launch': typeof AuthenticatedOrgIdWebsiteDomainLaunchRoute
  '/$orgId/website/overview': typeof AuthenticatedOrgIdWebsiteOverviewRoute
  '/$orgId/whats-new/$appUpdateId': typeof AuthenticatedOrgIdWhatsNewAppUpdateIdRoute
  '/$orgId/whats-new/create': typeof AuthenticatedOrgIdWhatsNewCreateRoute
  '/$orgId/api-tokens/': typeof AuthenticatedOrgIdApiTokensIndexRoute
  '/$orgId/availability/': typeof AuthenticatedOrgIdAvailabilityIndexRoute
  '/$orgId/contracts/': typeof AuthenticatedOrgIdContractsIndexRoute
  '/$orgId/customer-reviews/': typeof AuthenticatedOrgIdCustomerReviewsIndexRoute
  '/$orgId/customers/': typeof AuthenticatedOrgIdCustomersIndexRoute
  '/$orgId/designs/': typeof AuthenticatedOrgIdDesignsIndexRoute
  '/$orgId/imports/': typeof AuthenticatedOrgIdImportsIndexRoute
  '/$orgId/marketing/': typeof AuthenticatedOrgIdMarketingIndexRoute
  '/$orgId/messages/': typeof AuthenticatedOrgIdMessagesIndexRoute
  '/$orgId/money/': typeof AuthenticatedOrgIdMoneyIndexRoute
  '/$orgId/organizations/': typeof AuthenticatedOrgIdOrganizationsIndexRoute
  '/$orgId/pricing/': typeof AuthenticatedOrgIdPricingIndexRoute
  '/$orgId/products/': typeof AuthenticatedOrgIdProductsIndexRoute
  '/$orgId/reports/': typeof AuthenticatedOrgIdReportsIndexRoute
  '/$orgId/sales-orders/': typeof AuthenticatedOrgIdSalesOrdersIndexRoute
  '/$orgId/seasonal-content/': typeof AuthenticatedOrgIdSeasonalContentIndexRoute
  '/$orgId/settings/': typeof AuthenticatedOrgIdSettingsIndexRoute
  '/$orgId/stock-images/': typeof AuthenticatedOrgIdStockImagesIndexRoute
  '/$orgId/subscriptions/': typeof AuthenticatedOrgIdSubscriptionsIndexRoute
  '/$orgId/users/': typeof AuthenticatedOrgIdUsersIndexRoute
  '/$orgId/website/': typeof AuthenticatedOrgIdWebsiteIndexRoute
  '/$orgId/whats-new/': typeof AuthenticatedOrgIdWhatsNewIndexRoute
  '/$orgId/customers/$customerId/history': typeof AuthenticatedOrgIdCustomersCustomerIdHistoryRoute
  '/$orgId/designs/$designId/history': typeof AuthenticatedOrgIdDesignsDesignIdHistoryRoute
  '/$orgId/gallery/album/$albumId': typeof AuthenticatedOrgIdGalleryAlbumAlbumIdRoute
  '/$orgId/gallery/album/create': typeof AuthenticatedOrgIdGalleryAlbumCreateRoute
  '/$orgId/money/sales/$date': typeof AuthenticatedOrgIdMoneySalesDateRoute
  '/$orgId/products/$productId/history': typeof AuthenticatedOrgIdProductsProductIdHistoryRoute
  '/$orgId/products/add-on-sets/$addOnSetId': typeof AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute
  '/$orgId/products/add-on-sets/create': typeof AuthenticatedOrgIdProductsAddOnSetsCreateRoute
  '/$orgId/products/add-ons/$addOnId': typeof AuthenticatedOrgIdProductsAddOnsAddOnIdRoute
  '/$orgId/products/add-ons/create': typeof AuthenticatedOrgIdProductsAddOnsCreateRoute
  '/$orgId/products/collections/$collectionId': typeof AuthenticatedOrgIdProductsCollectionsCollectionIdRoute
  '/$orgId/products/collections/create': typeof AuthenticatedOrgIdProductsCollectionsCreateRoute
  '/$orgId/products/collections/import': typeof AuthenticatedOrgIdProductsCollectionsImportRoute
  '/$orgId/products/price-changes/$priceAdjustmentId': typeof AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute
  '/$orgId/products/price-changes/create': typeof AuthenticatedOrgIdProductsPriceChangesCreateRoute
  '/$orgId/reports/deposits/$depositId': typeof AuthenticatedOrgIdReportsDepositsDepositIdRoute
  '/$orgId/reports/sales-summary/$date': typeof AuthenticatedOrgIdReportsSalesSummaryDateRoute
  '/$orgId/reports/sales/$date': typeof AuthenticatedOrgIdReportsSalesDateRoute
  '/$orgId/sales-orders/$salesOrderId/edit': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute
  '/$orgId/sales-orders/$salesOrderId/history': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute
  '/$orgId/sales-orders/$salesOrderId/journal': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute
  '/$orgId/sales-orders/delivery-routes/$deliveryShareId': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren
  '/$orgId/sales-orders/delivery-routes/create': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute
  '/$orgId/settings/billing/history': typeof AuthenticatedOrgIdSettingsBillingHistoryRoute
  '/$orgId/settings/cash-drawer/history': typeof AuthenticatedOrgIdSettingsCashDrawerHistoryRoute
  '/$orgId/settings/domains/$domainId': typeof AuthenticatedOrgIdSettingsDomainsDomainIdRoute
  '/$orgId/settings/domains/create': typeof AuthenticatedOrgIdSettingsDomainsCreateRoute
  '/$orgId/settings/fees/history': typeof AuthenticatedOrgIdSettingsFeesHistoryRoute
  '/$orgId/settings/locations/$locationId': typeof AuthenticatedOrgIdSettingsLocationsLocationIdRouteWithChildren
  '/$orgId/settings/locations/create': typeof AuthenticatedOrgIdSettingsLocationsCreateRoute
  '/$orgId/settings/notifications/$recipientId': typeof AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute
  '/$orgId/settings/notifications/create': typeof AuthenticatedOrgIdSettingsNotificationsCreateRoute
  '/$orgId/settings/stripe/account-management': typeof AuthenticatedOrgIdSettingsStripeAccountManagementRoute
  '/$orgId/settings/stripe/card-readers': typeof AuthenticatedOrgIdSettingsStripeCardReadersRoute
  '/$orgId/settings/stripe/disputes': typeof AuthenticatedOrgIdSettingsStripeDisputesRoute
  '/$orgId/settings/stripe/onboarding': typeof AuthenticatedOrgIdSettingsStripeOnboardingRoute
  '/$orgId/settings/stripe/payment-methods': typeof AuthenticatedOrgIdSettingsStripePaymentMethodsRoute
  '/$orgId/settings/stripe/payments': typeof AuthenticatedOrgIdSettingsStripePaymentsRoute
  '/$orgId/settings/stripe/payouts': typeof AuthenticatedOrgIdSettingsStripePayoutsRoute
  '/$orgId/settings/stripe/upgrade': typeof AuthenticatedOrgIdSettingsStripeUpgradeRoute
  '/$orgId/settings/taxes/history': typeof AuthenticatedOrgIdSettingsTaxesHistoryRoute
  '/$orgId/settings/terminals/$terminalId': typeof AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute
  '/$orgId/settings/terminals/create': typeof AuthenticatedOrgIdSettingsTerminalsCreateRoute
  '/$orgId/users/$userId/history': typeof AuthenticatedOrgIdUsersUserIdHistoryRoute
  '/$orgId/website/custom-pages/$customPageId': typeof AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute
  '/$orgId/website/custom-pages/create': typeof AuthenticatedOrgIdWebsiteCustomPagesCreateRoute
  '/$orgId/website/domains/$domainId': typeof AuthenticatedOrgIdWebsiteDomainsDomainIdRoute
  '/$orgId/website/domains/create': typeof AuthenticatedOrgIdWebsiteDomainsCreateRoute
  '/$orgId/website/url-redirects/flower-shop-network': typeof AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute
  '/$orgId/marketing/discounts/': typeof AuthenticatedOrgIdMarketingDiscountsIndexRoute
  '/$orgId/money/customer-balances/': typeof AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute
  '/$orgId/money/sales/': typeof AuthenticatedOrgIdMoneySalesIndexRoute
  '/$orgId/money/statements/': typeof AuthenticatedOrgIdMoneyStatementsIndexRoute
  '/$orgId/organizations/$organizationId/': typeof AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute
  '/$orgId/products/add-on-sets/': typeof AuthenticatedOrgIdProductsAddOnSetsIndexRoute
  '/$orgId/products/add-ons/': typeof AuthenticatedOrgIdProductsAddOnsIndexRoute
  '/$orgId/products/collections/': typeof AuthenticatedOrgIdProductsCollectionsIndexRoute
  '/$orgId/products/price-changes/': typeof AuthenticatedOrgIdProductsPriceChangesIndexRoute
  '/$orgId/reports/accounting-journal/': typeof AuthenticatedOrgIdReportsAccountingJournalIndexRoute
  '/$orgId/reports/cash-drawer/': typeof AuthenticatedOrgIdReportsCashDrawerIndexRoute
  '/$orgId/reports/closed-days/': typeof AuthenticatedOrgIdReportsClosedDaysIndexRoute
  '/$orgId/reports/deposits/': typeof AuthenticatedOrgIdReportsDepositsIndexRoute
  '/$orgId/reports/florist-performance/': typeof AuthenticatedOrgIdReportsFloristPerformanceIndexRoute
  '/$orgId/reports/phone-clicks/': typeof AuthenticatedOrgIdReportsPhoneClicksIndexRoute
  '/$orgId/reports/platform-ledger/': typeof AuthenticatedOrgIdReportsPlatformLedgerIndexRoute
  '/$orgId/reports/sales-statistics/': typeof AuthenticatedOrgIdReportsSalesStatisticsIndexRoute
  '/$orgId/reports/sales-summary/': typeof AuthenticatedOrgIdReportsSalesSummaryIndexRoute
  '/$orgId/reports/sales-tax/': typeof AuthenticatedOrgIdReportsSalesTaxIndexRoute
  '/$orgId/reports/sales/': typeof AuthenticatedOrgIdReportsSalesIndexRoute
  '/$orgId/reports/tips/': typeof AuthenticatedOrgIdReportsTipsIndexRoute
  '/$orgId/sales-orders/delivery-routes/': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute
  '/$orgId/settings/billing/': typeof AuthenticatedOrgIdSettingsBillingIndexRoute
  '/$orgId/settings/cash-drawer/': typeof AuthenticatedOrgIdSettingsCashDrawerIndexRoute
  '/$orgId/settings/checkout/': typeof AuthenticatedOrgIdSettingsCheckoutIndexRoute
  '/$orgId/settings/condolences/': typeof AuthenticatedOrgIdSettingsCondolencesIndexRoute
  '/$orgId/settings/domains/': typeof AuthenticatedOrgIdSettingsDomainsIndexRoute
  '/$orgId/settings/email-marketing/': typeof AuthenticatedOrgIdSettingsEmailMarketingIndexRoute
  '/$orgId/settings/fees/': typeof AuthenticatedOrgIdSettingsFeesIndexRoute
  '/$orgId/settings/fsn-network/': typeof AuthenticatedOrgIdSettingsFsnNetworkIndexRoute
  '/$orgId/settings/integrations/': typeof AuthenticatedOrgIdSettingsIntegrationsIndexRoute
  '/$orgId/settings/locations/': typeof AuthenticatedOrgIdSettingsLocationsIndexRoute
  '/$orgId/settings/notifications/': typeof AuthenticatedOrgIdSettingsNotificationsIndexRoute
  '/$orgId/settings/snapdragon/': typeof AuthenticatedOrgIdSettingsSnapdragonIndexRoute
  '/$orgId/settings/stripe/': typeof AuthenticatedOrgIdSettingsStripeIndexRoute
  '/$orgId/settings/subscriptions/': typeof AuthenticatedOrgIdSettingsSubscriptionsIndexRoute
  '/$orgId/settings/supertickets/': typeof AuthenticatedOrgIdSettingsSuperticketsIndexRoute
  '/$orgId/settings/taxes/': typeof AuthenticatedOrgIdSettingsTaxesIndexRoute
  '/$orgId/settings/terminals/': typeof AuthenticatedOrgIdSettingsTerminalsIndexRoute
  '/$orgId/users/$userId/': typeof AuthenticatedOrgIdUsersUserIdIndexRoute
  '/$orgId/website/custom-pages/': typeof AuthenticatedOrgIdWebsiteCustomPagesIndexRoute
  '/$orgId/website/domains/': typeof AuthenticatedOrgIdWebsiteDomainsIndexRoute
  '/$orgId/website/url-redirects/': typeof AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute
  '/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute
  '/$orgId/settings/integrations/snapdragon/history': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute
  '/$orgId/settings/locations/$locationId/history': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute
  '/$orgId/users/$userId/roles/$roleId': typeof AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute
  '/$orgId/settings/integrations/condolences/': typeof AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute
  '/$orgId/settings/integrations/fsn-network/': typeof AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute
  '/$orgId/settings/integrations/google-analytics/': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute
  '/$orgId/settings/integrations/google-tag-manager/': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute
  '/$orgId/settings/integrations/meta-pixel/': typeof AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute
  '/$orgId/settings/integrations/snapdragon/': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute
  '/$orgId/settings/locations/$locationId/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute
  '/$orgId/settings/locations/$locationId/deliveries/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute
  '/$orgId/settings/locations/$locationId/hours/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/$orgId': typeof AuthenticatedOrgIdRouteWithChildren
  '/stripe-connect': typeof AuthenticatedStripeConnectRoute
  '/reset-password/$token': typeof authResetPasswordTokenRoute
  '/$orgId/activity': typeof AuthenticatedOrgIdActivityRoute
  '/$orgId/admin': typeof AuthenticatedOrgIdAdminRoute
  '/$orgId/notications-center': typeof AuthenticatedOrgIdNoticationsCenterRoute
  '/$orgId/contracts/create': typeof AuthenticatedOrgIdContractsCreateRoute
  '/$orgId/customer-reviews/$customerReviewId': typeof AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute
  '/$orgId/customers/$customerId': typeof AuthenticatedOrgIdCustomersCustomerIdRoute
  '/$orgId/customers/create': typeof AuthenticatedOrgIdCustomersCreateRoute
  '/$orgId/designs/$designId': typeof AuthenticatedOrgIdDesignsDesignIdRoute
  '/$orgId/designs/create': typeof AuthenticatedOrgIdDesignsCreateRoute
  '/$orgId/imports/customer-import': typeof AuthenticatedOrgIdImportsCustomerImportRoute
  '/$orgId/imports/fsn-import': typeof AuthenticatedOrgIdImportsFsnImportRoute
  '/$orgId/imports/product-import': typeof AuthenticatedOrgIdImportsProductImportRoute
  '/$orgId/messages/$messageId': typeof AuthenticatedOrgIdMessagesMessageIdRoute
  '/$orgId/messages/create': typeof AuthenticatedOrgIdMessagesCreateRoute
  '/$orgId/money/cash-drawer-balancing': typeof AuthenticatedOrgIdMoneyCashDrawerBalancingRoute
  '/$orgId/organizations/create': typeof AuthenticatedOrgIdOrganizationsCreateRoute
  '/$orgId/pricing/create': typeof AuthenticatedOrgIdPricingCreateRoute
  '/$orgId/products/$productId': typeof AuthenticatedOrgIdProductsProductIdRoute
  '/$orgId/products/all-products': typeof AuthenticatedOrgIdProductsAllProductsRoute
  '/$orgId/products/catalog-builder': typeof AuthenticatedOrgIdProductsCatalogBuilderRoute
  '/$orgId/products/create': typeof AuthenticatedOrgIdProductsCreateRoute
  '/$orgId/products/inventory': typeof AuthenticatedOrgIdProductsInventoryRoute
  '/$orgId/reports/customer-balances': typeof AuthenticatedOrgIdReportsCustomerBalancesRoute
  '/$orgId/reports/external-orders': typeof AuthenticatedOrgIdReportsExternalOrdersRoute
  '/$orgId/reports/wired-orders': typeof AuthenticatedOrgIdReportsWiredOrdersRoute
  '/$orgId/sales-orders/$salesOrderId': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute
  '/$orgId/sales-orders/create': typeof AuthenticatedOrgIdSalesOrdersCreateRoute
  '/$orgId/sales-orders/drafts': typeof AuthenticatedOrgIdSalesOrdersDraftsRoute
  '/$orgId/sales-orders/wire-in': typeof AuthenticatedOrgIdSalesOrdersWireInRoute
  '/$orgId/seasonal-content/$seasonalDesignId': typeof AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute
  '/$orgId/seasonal-content/create': typeof AuthenticatedOrgIdSeasonalContentCreateRoute
  '/$orgId/stock-images/$stockImageId': typeof AuthenticatedOrgIdStockImagesStockImageIdRoute
  '/$orgId/stock-images/create': typeof AuthenticatedOrgIdStockImagesCreateRoute
  '/$orgId/subscriptions/$flowerSubscriptionId': typeof AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute
  '/$orgId/users/create': typeof AuthenticatedOrgIdUsersCreateRoute
  '/$orgId/website/builder': typeof AuthenticatedOrgIdWebsiteBuilderRoute
  '/$orgId/website/domain-launch': typeof AuthenticatedOrgIdWebsiteDomainLaunchRoute
  '/$orgId/website/overview': typeof AuthenticatedOrgIdWebsiteOverviewRoute
  '/$orgId/whats-new/$appUpdateId': typeof AuthenticatedOrgIdWhatsNewAppUpdateIdRoute
  '/$orgId/whats-new/create': typeof AuthenticatedOrgIdWhatsNewCreateRoute
  '/$orgId/api-tokens': typeof AuthenticatedOrgIdApiTokensIndexRoute
  '/$orgId/availability': typeof AuthenticatedOrgIdAvailabilityIndexRoute
  '/$orgId/contracts': typeof AuthenticatedOrgIdContractsIndexRoute
  '/$orgId/customer-reviews': typeof AuthenticatedOrgIdCustomerReviewsIndexRoute
  '/$orgId/customers': typeof AuthenticatedOrgIdCustomersIndexRoute
  '/$orgId/designs': typeof AuthenticatedOrgIdDesignsIndexRoute
  '/$orgId/imports': typeof AuthenticatedOrgIdImportsIndexRoute
  '/$orgId/marketing': typeof AuthenticatedOrgIdMarketingIndexRoute
  '/$orgId/messages': typeof AuthenticatedOrgIdMessagesIndexRoute
  '/$orgId/money': typeof AuthenticatedOrgIdMoneyIndexRoute
  '/$orgId/organizations': typeof AuthenticatedOrgIdOrganizationsIndexRoute
  '/$orgId/pricing': typeof AuthenticatedOrgIdPricingIndexRoute
  '/$orgId/products': typeof AuthenticatedOrgIdProductsIndexRoute
  '/$orgId/reports': typeof AuthenticatedOrgIdReportsIndexRoute
  '/$orgId/sales-orders': typeof AuthenticatedOrgIdSalesOrdersIndexRoute
  '/$orgId/seasonal-content': typeof AuthenticatedOrgIdSeasonalContentIndexRoute
  '/$orgId/settings': typeof AuthenticatedOrgIdSettingsIndexRoute
  '/$orgId/stock-images': typeof AuthenticatedOrgIdStockImagesIndexRoute
  '/$orgId/subscriptions': typeof AuthenticatedOrgIdSubscriptionsIndexRoute
  '/$orgId/users': typeof AuthenticatedOrgIdUsersIndexRoute
  '/$orgId/website': typeof AuthenticatedOrgIdWebsiteIndexRoute
  '/$orgId/whats-new': typeof AuthenticatedOrgIdWhatsNewIndexRoute
  '/$orgId/customers/$customerId/history': typeof AuthenticatedOrgIdCustomersCustomerIdHistoryRoute
  '/$orgId/designs/$designId/history': typeof AuthenticatedOrgIdDesignsDesignIdHistoryRoute
  '/$orgId/gallery/album/$albumId': typeof AuthenticatedOrgIdGalleryAlbumAlbumIdRoute
  '/$orgId/gallery/album/create': typeof AuthenticatedOrgIdGalleryAlbumCreateRoute
  '/$orgId/money/sales/$date': typeof AuthenticatedOrgIdMoneySalesDateRoute
  '/$orgId/products/$productId/history': typeof AuthenticatedOrgIdProductsProductIdHistoryRoute
  '/$orgId/products/add-on-sets/$addOnSetId': typeof AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute
  '/$orgId/products/add-on-sets/create': typeof AuthenticatedOrgIdProductsAddOnSetsCreateRoute
  '/$orgId/products/add-ons/$addOnId': typeof AuthenticatedOrgIdProductsAddOnsAddOnIdRoute
  '/$orgId/products/add-ons/create': typeof AuthenticatedOrgIdProductsAddOnsCreateRoute
  '/$orgId/products/collections/$collectionId': typeof AuthenticatedOrgIdProductsCollectionsCollectionIdRoute
  '/$orgId/products/collections/create': typeof AuthenticatedOrgIdProductsCollectionsCreateRoute
  '/$orgId/products/collections/import': typeof AuthenticatedOrgIdProductsCollectionsImportRoute
  '/$orgId/products/price-changes/$priceAdjustmentId': typeof AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute
  '/$orgId/products/price-changes/create': typeof AuthenticatedOrgIdProductsPriceChangesCreateRoute
  '/$orgId/reports/deposits/$depositId': typeof AuthenticatedOrgIdReportsDepositsDepositIdRoute
  '/$orgId/reports/sales-summary/$date': typeof AuthenticatedOrgIdReportsSalesSummaryDateRoute
  '/$orgId/reports/sales/$date': typeof AuthenticatedOrgIdReportsSalesDateRoute
  '/$orgId/sales-orders/$salesOrderId/edit': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute
  '/$orgId/sales-orders/$salesOrderId/history': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute
  '/$orgId/sales-orders/$salesOrderId/journal': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute
  '/$orgId/sales-orders/delivery-routes/$deliveryShareId': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren
  '/$orgId/sales-orders/delivery-routes/create': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute
  '/$orgId/settings/billing/history': typeof AuthenticatedOrgIdSettingsBillingHistoryRoute
  '/$orgId/settings/cash-drawer/history': typeof AuthenticatedOrgIdSettingsCashDrawerHistoryRoute
  '/$orgId/settings/domains/$domainId': typeof AuthenticatedOrgIdSettingsDomainsDomainIdRoute
  '/$orgId/settings/domains/create': typeof AuthenticatedOrgIdSettingsDomainsCreateRoute
  '/$orgId/settings/fees/history': typeof AuthenticatedOrgIdSettingsFeesHistoryRoute
  '/$orgId/settings/locations/create': typeof AuthenticatedOrgIdSettingsLocationsCreateRoute
  '/$orgId/settings/notifications/$recipientId': typeof AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute
  '/$orgId/settings/notifications/create': typeof AuthenticatedOrgIdSettingsNotificationsCreateRoute
  '/$orgId/settings/stripe/account-management': typeof AuthenticatedOrgIdSettingsStripeAccountManagementRoute
  '/$orgId/settings/stripe/card-readers': typeof AuthenticatedOrgIdSettingsStripeCardReadersRoute
  '/$orgId/settings/stripe/disputes': typeof AuthenticatedOrgIdSettingsStripeDisputesRoute
  '/$orgId/settings/stripe/onboarding': typeof AuthenticatedOrgIdSettingsStripeOnboardingRoute
  '/$orgId/settings/stripe/payment-methods': typeof AuthenticatedOrgIdSettingsStripePaymentMethodsRoute
  '/$orgId/settings/stripe/payments': typeof AuthenticatedOrgIdSettingsStripePaymentsRoute
  '/$orgId/settings/stripe/payouts': typeof AuthenticatedOrgIdSettingsStripePayoutsRoute
  '/$orgId/settings/stripe/upgrade': typeof AuthenticatedOrgIdSettingsStripeUpgradeRoute
  '/$orgId/settings/taxes/history': typeof AuthenticatedOrgIdSettingsTaxesHistoryRoute
  '/$orgId/settings/terminals/$terminalId': typeof AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute
  '/$orgId/settings/terminals/create': typeof AuthenticatedOrgIdSettingsTerminalsCreateRoute
  '/$orgId/users/$userId/history': typeof AuthenticatedOrgIdUsersUserIdHistoryRoute
  '/$orgId/website/custom-pages/$customPageId': typeof AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute
  '/$orgId/website/custom-pages/create': typeof AuthenticatedOrgIdWebsiteCustomPagesCreateRoute
  '/$orgId/website/domains/$domainId': typeof AuthenticatedOrgIdWebsiteDomainsDomainIdRoute
  '/$orgId/website/domains/create': typeof AuthenticatedOrgIdWebsiteDomainsCreateRoute
  '/$orgId/website/url-redirects/flower-shop-network': typeof AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute
  '/$orgId/marketing/discounts': typeof AuthenticatedOrgIdMarketingDiscountsIndexRoute
  '/$orgId/money/customer-balances': typeof AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute
  '/$orgId/money/sales': typeof AuthenticatedOrgIdMoneySalesIndexRoute
  '/$orgId/money/statements': typeof AuthenticatedOrgIdMoneyStatementsIndexRoute
  '/$orgId/organizations/$organizationId': typeof AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute
  '/$orgId/products/add-on-sets': typeof AuthenticatedOrgIdProductsAddOnSetsIndexRoute
  '/$orgId/products/add-ons': typeof AuthenticatedOrgIdProductsAddOnsIndexRoute
  '/$orgId/products/collections': typeof AuthenticatedOrgIdProductsCollectionsIndexRoute
  '/$orgId/products/price-changes': typeof AuthenticatedOrgIdProductsPriceChangesIndexRoute
  '/$orgId/reports/accounting-journal': typeof AuthenticatedOrgIdReportsAccountingJournalIndexRoute
  '/$orgId/reports/cash-drawer': typeof AuthenticatedOrgIdReportsCashDrawerIndexRoute
  '/$orgId/reports/closed-days': typeof AuthenticatedOrgIdReportsClosedDaysIndexRoute
  '/$orgId/reports/deposits': typeof AuthenticatedOrgIdReportsDepositsIndexRoute
  '/$orgId/reports/florist-performance': typeof AuthenticatedOrgIdReportsFloristPerformanceIndexRoute
  '/$orgId/reports/phone-clicks': typeof AuthenticatedOrgIdReportsPhoneClicksIndexRoute
  '/$orgId/reports/platform-ledger': typeof AuthenticatedOrgIdReportsPlatformLedgerIndexRoute
  '/$orgId/reports/sales-statistics': typeof AuthenticatedOrgIdReportsSalesStatisticsIndexRoute
  '/$orgId/reports/sales-summary': typeof AuthenticatedOrgIdReportsSalesSummaryIndexRoute
  '/$orgId/reports/sales-tax': typeof AuthenticatedOrgIdReportsSalesTaxIndexRoute
  '/$orgId/reports/sales': typeof AuthenticatedOrgIdReportsSalesIndexRoute
  '/$orgId/reports/tips': typeof AuthenticatedOrgIdReportsTipsIndexRoute
  '/$orgId/sales-orders/delivery-routes': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute
  '/$orgId/settings/billing': typeof AuthenticatedOrgIdSettingsBillingIndexRoute
  '/$orgId/settings/cash-drawer': typeof AuthenticatedOrgIdSettingsCashDrawerIndexRoute
  '/$orgId/settings/checkout': typeof AuthenticatedOrgIdSettingsCheckoutIndexRoute
  '/$orgId/settings/condolences': typeof AuthenticatedOrgIdSettingsCondolencesIndexRoute
  '/$orgId/settings/domains': typeof AuthenticatedOrgIdSettingsDomainsIndexRoute
  '/$orgId/settings/email-marketing': typeof AuthenticatedOrgIdSettingsEmailMarketingIndexRoute
  '/$orgId/settings/fees': typeof AuthenticatedOrgIdSettingsFeesIndexRoute
  '/$orgId/settings/fsn-network': typeof AuthenticatedOrgIdSettingsFsnNetworkIndexRoute
  '/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsIndexRoute
  '/$orgId/settings/locations': typeof AuthenticatedOrgIdSettingsLocationsIndexRoute
  '/$orgId/settings/notifications': typeof AuthenticatedOrgIdSettingsNotificationsIndexRoute
  '/$orgId/settings/snapdragon': typeof AuthenticatedOrgIdSettingsSnapdragonIndexRoute
  '/$orgId/settings/stripe': typeof AuthenticatedOrgIdSettingsStripeIndexRoute
  '/$orgId/settings/subscriptions': typeof AuthenticatedOrgIdSettingsSubscriptionsIndexRoute
  '/$orgId/settings/supertickets': typeof AuthenticatedOrgIdSettingsSuperticketsIndexRoute
  '/$orgId/settings/taxes': typeof AuthenticatedOrgIdSettingsTaxesIndexRoute
  '/$orgId/settings/terminals': typeof AuthenticatedOrgIdSettingsTerminalsIndexRoute
  '/$orgId/users/$userId': typeof AuthenticatedOrgIdUsersUserIdIndexRoute
  '/$orgId/website/custom-pages': typeof AuthenticatedOrgIdWebsiteCustomPagesIndexRoute
  '/$orgId/website/domains': typeof AuthenticatedOrgIdWebsiteDomainsIndexRoute
  '/$orgId/website/url-redirects': typeof AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute
  '/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute
  '/$orgId/settings/integrations/snapdragon/history': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute
  '/$orgId/settings/locations/$locationId/history': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute
  '/$orgId/users/$userId/roles/$roleId': typeof AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute
  '/$orgId/settings/integrations/condolences': typeof AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute
  '/$orgId/settings/integrations/fsn-network': typeof AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute
  '/$orgId/settings/integrations/google-analytics': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute
  '/$orgId/settings/integrations/google-tag-manager': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute
  '/$orgId/settings/integrations/meta-pixel': typeof AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute
  '/$orgId/settings/integrations/snapdragon': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute
  '/$orgId/settings/locations/$locationId': typeof AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute
  '/$orgId/settings/locations/$locationId/deliveries': typeof AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute
  '/$orgId/settings/locations/$locationId/hours': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/_authenticated/$orgId': typeof AuthenticatedOrgIdRouteWithChildren
  '/_authenticated/stripe-connect': typeof AuthenticatedStripeConnectRoute
  '/(auth)/reset-password/$token': typeof authResetPasswordTokenRoute
  '/_authenticated/$orgId/activity': typeof AuthenticatedOrgIdActivityRoute
  '/_authenticated/$orgId/admin': typeof AuthenticatedOrgIdAdminRoute
  '/_authenticated/$orgId/imports': typeof AuthenticatedOrgIdImportsRouteWithChildren
  '/_authenticated/$orgId/money': typeof AuthenticatedOrgIdMoneyRouteWithChildren
  '/_authenticated/$orgId/notications-center': typeof AuthenticatedOrgIdNoticationsCenterRoute
  '/_authenticated/$orgId/website': typeof AuthenticatedOrgIdWebsiteRouteWithChildren
  '/_authenticated/$orgId/contracts/create': typeof AuthenticatedOrgIdContractsCreateRoute
  '/_authenticated/$orgId/customer-reviews/$customerReviewId': typeof AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute
  '/_authenticated/$orgId/customers/$customerId': typeof AuthenticatedOrgIdCustomersCustomerIdRoute
  '/_authenticated/$orgId/customers/create': typeof AuthenticatedOrgIdCustomersCreateRoute
  '/_authenticated/$orgId/designs/$designId': typeof AuthenticatedOrgIdDesignsDesignIdRoute
  '/_authenticated/$orgId/designs/create': typeof AuthenticatedOrgIdDesignsCreateRoute
  '/_authenticated/$orgId/imports/customer-import': typeof AuthenticatedOrgIdImportsCustomerImportRoute
  '/_authenticated/$orgId/imports/fsn-import': typeof AuthenticatedOrgIdImportsFsnImportRoute
  '/_authenticated/$orgId/imports/product-import': typeof AuthenticatedOrgIdImportsProductImportRoute
  '/_authenticated/$orgId/messages/$messageId': typeof AuthenticatedOrgIdMessagesMessageIdRoute
  '/_authenticated/$orgId/messages/create': typeof AuthenticatedOrgIdMessagesCreateRoute
  '/_authenticated/$orgId/money/cash-drawer-balancing': typeof AuthenticatedOrgIdMoneyCashDrawerBalancingRoute
  '/_authenticated/$orgId/money/customer-balances': typeof AuthenticatedOrgIdMoneyCustomerBalancesRouteWithChildren
  '/_authenticated/$orgId/organizations/$organizationId': typeof AuthenticatedOrgIdOrganizationsOrganizationIdRouteWithChildren
  '/_authenticated/$orgId/organizations/create': typeof AuthenticatedOrgIdOrganizationsCreateRoute
  '/_authenticated/$orgId/pricing/create': typeof AuthenticatedOrgIdPricingCreateRoute
  '/_authenticated/$orgId/products/$productId': typeof AuthenticatedOrgIdProductsProductIdRoute
  '/_authenticated/$orgId/products/all-products': typeof AuthenticatedOrgIdProductsAllProductsRoute
  '/_authenticated/$orgId/products/catalog-builder': typeof AuthenticatedOrgIdProductsCatalogBuilderRoute
  '/_authenticated/$orgId/products/create': typeof AuthenticatedOrgIdProductsCreateRoute
  '/_authenticated/$orgId/products/inventory': typeof AuthenticatedOrgIdProductsInventoryRoute
  '/_authenticated/$orgId/reports/accounting-journal': typeof AuthenticatedOrgIdReportsAccountingJournalRouteWithChildren
  '/_authenticated/$orgId/reports/cash-drawer': typeof AuthenticatedOrgIdReportsCashDrawerRouteWithChildren
  '/_authenticated/$orgId/reports/closed-days': typeof AuthenticatedOrgIdReportsClosedDaysRouteWithChildren
  '/_authenticated/$orgId/reports/customer-balances': typeof AuthenticatedOrgIdReportsCustomerBalancesRoute
  '/_authenticated/$orgId/reports/deposits': typeof AuthenticatedOrgIdReportsDepositsRouteWithChildren
  '/_authenticated/$orgId/reports/external-orders': typeof AuthenticatedOrgIdReportsExternalOrdersRoute
  '/_authenticated/$orgId/reports/phone-clicks': typeof AuthenticatedOrgIdReportsPhoneClicksRouteWithChildren
  '/_authenticated/$orgId/reports/platform-ledger': typeof AuthenticatedOrgIdReportsPlatformLedgerRouteWithChildren
  '/_authenticated/$orgId/reports/sales-statistics': typeof AuthenticatedOrgIdReportsSalesStatisticsRouteWithChildren
  '/_authenticated/$orgId/reports/sales-tax': typeof AuthenticatedOrgIdReportsSalesTaxRouteWithChildren
  '/_authenticated/$orgId/reports/wired-orders': typeof AuthenticatedOrgIdReportsWiredOrdersRoute
  '/_authenticated/$orgId/sales-orders/$salesOrderId': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute
  '/_authenticated/$orgId/sales-orders/create': typeof AuthenticatedOrgIdSalesOrdersCreateRoute
  '/_authenticated/$orgId/sales-orders/drafts': typeof AuthenticatedOrgIdSalesOrdersDraftsRoute
  '/_authenticated/$orgId/sales-orders/wire-in': typeof AuthenticatedOrgIdSalesOrdersWireInRoute
  '/_authenticated/$orgId/seasonal-content/$seasonalDesignId': typeof AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute
  '/_authenticated/$orgId/seasonal-content/create': typeof AuthenticatedOrgIdSeasonalContentCreateRoute
  '/_authenticated/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsRouteWithChildren
  '/_authenticated/$orgId/stock-images/$stockImageId': typeof AuthenticatedOrgIdStockImagesStockImageIdRoute
  '/_authenticated/$orgId/stock-images/create': typeof AuthenticatedOrgIdStockImagesCreateRoute
  '/_authenticated/$orgId/subscriptions/$flowerSubscriptionId': typeof AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute
  '/_authenticated/$orgId/users/create': typeof AuthenticatedOrgIdUsersCreateRoute
  '/_authenticated/$orgId/website/builder': typeof AuthenticatedOrgIdWebsiteBuilderRoute
  '/_authenticated/$orgId/website/domain-launch': typeof AuthenticatedOrgIdWebsiteDomainLaunchRoute
  '/_authenticated/$orgId/website/overview': typeof AuthenticatedOrgIdWebsiteOverviewRoute
  '/_authenticated/$orgId/whats-new/$appUpdateId': typeof AuthenticatedOrgIdWhatsNewAppUpdateIdRoute
  '/_authenticated/$orgId/whats-new/create': typeof AuthenticatedOrgIdWhatsNewCreateRoute
  '/_authenticated/$orgId/api-tokens/': typeof AuthenticatedOrgIdApiTokensIndexRoute
  '/_authenticated/$orgId/availability/': typeof AuthenticatedOrgIdAvailabilityIndexRoute
  '/_authenticated/$orgId/contracts/': typeof AuthenticatedOrgIdContractsIndexRoute
  '/_authenticated/$orgId/customer-reviews/': typeof AuthenticatedOrgIdCustomerReviewsIndexRoute
  '/_authenticated/$orgId/customers/': typeof AuthenticatedOrgIdCustomersIndexRoute
  '/_authenticated/$orgId/designs/': typeof AuthenticatedOrgIdDesignsIndexRoute
  '/_authenticated/$orgId/imports/': typeof AuthenticatedOrgIdImportsIndexRoute
  '/_authenticated/$orgId/marketing/': typeof AuthenticatedOrgIdMarketingIndexRoute
  '/_authenticated/$orgId/messages/': typeof AuthenticatedOrgIdMessagesIndexRoute
  '/_authenticated/$orgId/money/': typeof AuthenticatedOrgIdMoneyIndexRoute
  '/_authenticated/$orgId/organizations/': typeof AuthenticatedOrgIdOrganizationsIndexRoute
  '/_authenticated/$orgId/pricing/': typeof AuthenticatedOrgIdPricingIndexRoute
  '/_authenticated/$orgId/products/': typeof AuthenticatedOrgIdProductsIndexRoute
  '/_authenticated/$orgId/reports/': typeof AuthenticatedOrgIdReportsIndexRoute
  '/_authenticated/$orgId/sales-orders/': typeof AuthenticatedOrgIdSalesOrdersIndexRoute
  '/_authenticated/$orgId/seasonal-content/': typeof AuthenticatedOrgIdSeasonalContentIndexRoute
  '/_authenticated/$orgId/settings/': typeof AuthenticatedOrgIdSettingsIndexRoute
  '/_authenticated/$orgId/stock-images/': typeof AuthenticatedOrgIdStockImagesIndexRoute
  '/_authenticated/$orgId/subscriptions/': typeof AuthenticatedOrgIdSubscriptionsIndexRoute
  '/_authenticated/$orgId/users/': typeof AuthenticatedOrgIdUsersIndexRoute
  '/_authenticated/$orgId/website/': typeof AuthenticatedOrgIdWebsiteIndexRoute
  '/_authenticated/$orgId/whats-new/': typeof AuthenticatedOrgIdWhatsNewIndexRoute
  '/_authenticated/$orgId/customers/$customerId_/history': typeof AuthenticatedOrgIdCustomersCustomerIdHistoryRoute
  '/_authenticated/$orgId/designs/$designId_/history': typeof AuthenticatedOrgIdDesignsDesignIdHistoryRoute
  '/_authenticated/$orgId/gallery/album/$albumId': typeof AuthenticatedOrgIdGalleryAlbumAlbumIdRoute
  '/_authenticated/$orgId/gallery/album/create': typeof AuthenticatedOrgIdGalleryAlbumCreateRoute
  '/_authenticated/$orgId/money/sales/$date': typeof AuthenticatedOrgIdMoneySalesDateRoute
  '/_authenticated/$orgId/products/$productId_/history': typeof AuthenticatedOrgIdProductsProductIdHistoryRoute
  '/_authenticated/$orgId/products/add-on-sets/$addOnSetId': typeof AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute
  '/_authenticated/$orgId/products/add-on-sets/create': typeof AuthenticatedOrgIdProductsAddOnSetsCreateRoute
  '/_authenticated/$orgId/products/add-ons/$addOnId': typeof AuthenticatedOrgIdProductsAddOnsAddOnIdRoute
  '/_authenticated/$orgId/products/add-ons/create': typeof AuthenticatedOrgIdProductsAddOnsCreateRoute
  '/_authenticated/$orgId/products/collections/$collectionId': typeof AuthenticatedOrgIdProductsCollectionsCollectionIdRoute
  '/_authenticated/$orgId/products/collections/create': typeof AuthenticatedOrgIdProductsCollectionsCreateRoute
  '/_authenticated/$orgId/products/collections/import': typeof AuthenticatedOrgIdProductsCollectionsImportRoute
  '/_authenticated/$orgId/products/price-changes/$priceAdjustmentId': typeof AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute
  '/_authenticated/$orgId/products/price-changes/create': typeof AuthenticatedOrgIdProductsPriceChangesCreateRoute
  '/_authenticated/$orgId/reports/deposits/$depositId': typeof AuthenticatedOrgIdReportsDepositsDepositIdRoute
  '/_authenticated/$orgId/reports/sales-summary/$date': typeof AuthenticatedOrgIdReportsSalesSummaryDateRoute
  '/_authenticated/$orgId/reports/sales/$date': typeof AuthenticatedOrgIdReportsSalesDateRoute
  '/_authenticated/$orgId/sales-orders/$salesOrderId_/edit': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute
  '/_authenticated/$orgId/sales-orders/$salesOrderId_/history': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute
  '/_authenticated/$orgId/sales-orders/$salesOrderId_/journal': typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute
  '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren
  '/_authenticated/$orgId/sales-orders/delivery-routes/create': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute
  '/_authenticated/$orgId/settings/billing/history': typeof AuthenticatedOrgIdSettingsBillingHistoryRoute
  '/_authenticated/$orgId/settings/cash-drawer/history': typeof AuthenticatedOrgIdSettingsCashDrawerHistoryRoute
  '/_authenticated/$orgId/settings/domains/$domainId': typeof AuthenticatedOrgIdSettingsDomainsDomainIdRoute
  '/_authenticated/$orgId/settings/domains/create': typeof AuthenticatedOrgIdSettingsDomainsCreateRoute
  '/_authenticated/$orgId/settings/fees/history': typeof AuthenticatedOrgIdSettingsFeesHistoryRoute
  '/_authenticated/$orgId/settings/locations/$locationId': typeof AuthenticatedOrgIdSettingsLocationsLocationIdRouteWithChildren
  '/_authenticated/$orgId/settings/locations/create': typeof AuthenticatedOrgIdSettingsLocationsCreateRoute
  '/_authenticated/$orgId/settings/notifications/$recipientId': typeof AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute
  '/_authenticated/$orgId/settings/notifications/create': typeof AuthenticatedOrgIdSettingsNotificationsCreateRoute
  '/_authenticated/$orgId/settings/stripe/account-management': typeof AuthenticatedOrgIdSettingsStripeAccountManagementRoute
  '/_authenticated/$orgId/settings/stripe/card-readers': typeof AuthenticatedOrgIdSettingsStripeCardReadersRoute
  '/_authenticated/$orgId/settings/stripe/disputes': typeof AuthenticatedOrgIdSettingsStripeDisputesRoute
  '/_authenticated/$orgId/settings/stripe/onboarding': typeof AuthenticatedOrgIdSettingsStripeOnboardingRoute
  '/_authenticated/$orgId/settings/stripe/payment-methods': typeof AuthenticatedOrgIdSettingsStripePaymentMethodsRoute
  '/_authenticated/$orgId/settings/stripe/payments': typeof AuthenticatedOrgIdSettingsStripePaymentsRoute
  '/_authenticated/$orgId/settings/stripe/payouts': typeof AuthenticatedOrgIdSettingsStripePayoutsRoute
  '/_authenticated/$orgId/settings/stripe/upgrade': typeof AuthenticatedOrgIdSettingsStripeUpgradeRoute
  '/_authenticated/$orgId/settings/taxes/history': typeof AuthenticatedOrgIdSettingsTaxesHistoryRoute
  '/_authenticated/$orgId/settings/terminals/$terminalId': typeof AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute
  '/_authenticated/$orgId/settings/terminals/create': typeof AuthenticatedOrgIdSettingsTerminalsCreateRoute
  '/_authenticated/$orgId/users/$userId/history': typeof AuthenticatedOrgIdUsersUserIdHistoryRoute
  '/_authenticated/$orgId/website/custom-pages/$customPageId': typeof AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute
  '/_authenticated/$orgId/website/custom-pages/create': typeof AuthenticatedOrgIdWebsiteCustomPagesCreateRoute
  '/_authenticated/$orgId/website/domains/$domainId': typeof AuthenticatedOrgIdWebsiteDomainsDomainIdRoute
  '/_authenticated/$orgId/website/domains/create': typeof AuthenticatedOrgIdWebsiteDomainsCreateRoute
  '/_authenticated/$orgId/website/url-redirects/flower-shop-network': typeof AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute
  '/_authenticated/$orgId/marketing/discounts/': typeof AuthenticatedOrgIdMarketingDiscountsIndexRoute
  '/_authenticated/$orgId/money/customer-balances/': typeof AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute
  '/_authenticated/$orgId/money/sales/': typeof AuthenticatedOrgIdMoneySalesIndexRoute
  '/_authenticated/$orgId/money/statements/': typeof AuthenticatedOrgIdMoneyStatementsIndexRoute
  '/_authenticated/$orgId/organizations/$organizationId/': typeof AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute
  '/_authenticated/$orgId/products/add-on-sets/': typeof AuthenticatedOrgIdProductsAddOnSetsIndexRoute
  '/_authenticated/$orgId/products/add-ons/': typeof AuthenticatedOrgIdProductsAddOnsIndexRoute
  '/_authenticated/$orgId/products/collections/': typeof AuthenticatedOrgIdProductsCollectionsIndexRoute
  '/_authenticated/$orgId/products/price-changes/': typeof AuthenticatedOrgIdProductsPriceChangesIndexRoute
  '/_authenticated/$orgId/reports/accounting-journal/': typeof AuthenticatedOrgIdReportsAccountingJournalIndexRoute
  '/_authenticated/$orgId/reports/cash-drawer/': typeof AuthenticatedOrgIdReportsCashDrawerIndexRoute
  '/_authenticated/$orgId/reports/closed-days/': typeof AuthenticatedOrgIdReportsClosedDaysIndexRoute
  '/_authenticated/$orgId/reports/deposits/': typeof AuthenticatedOrgIdReportsDepositsIndexRoute
  '/_authenticated/$orgId/reports/florist-performance/': typeof AuthenticatedOrgIdReportsFloristPerformanceIndexRoute
  '/_authenticated/$orgId/reports/phone-clicks/': typeof AuthenticatedOrgIdReportsPhoneClicksIndexRoute
  '/_authenticated/$orgId/reports/platform-ledger/': typeof AuthenticatedOrgIdReportsPlatformLedgerIndexRoute
  '/_authenticated/$orgId/reports/sales-statistics/': typeof AuthenticatedOrgIdReportsSalesStatisticsIndexRoute
  '/_authenticated/$orgId/reports/sales-summary/': typeof AuthenticatedOrgIdReportsSalesSummaryIndexRoute
  '/_authenticated/$orgId/reports/sales-tax/': typeof AuthenticatedOrgIdReportsSalesTaxIndexRoute
  '/_authenticated/$orgId/reports/sales/': typeof AuthenticatedOrgIdReportsSalesIndexRoute
  '/_authenticated/$orgId/reports/tips/': typeof AuthenticatedOrgIdReportsTipsIndexRoute
  '/_authenticated/$orgId/sales-orders/delivery-routes/': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute
  '/_authenticated/$orgId/settings/billing/': typeof AuthenticatedOrgIdSettingsBillingIndexRoute
  '/_authenticated/$orgId/settings/cash-drawer/': typeof AuthenticatedOrgIdSettingsCashDrawerIndexRoute
  '/_authenticated/$orgId/settings/checkout/': typeof AuthenticatedOrgIdSettingsCheckoutIndexRoute
  '/_authenticated/$orgId/settings/condolences/': typeof AuthenticatedOrgIdSettingsCondolencesIndexRoute
  '/_authenticated/$orgId/settings/domains/': typeof AuthenticatedOrgIdSettingsDomainsIndexRoute
  '/_authenticated/$orgId/settings/email-marketing/': typeof AuthenticatedOrgIdSettingsEmailMarketingIndexRoute
  '/_authenticated/$orgId/settings/fees/': typeof AuthenticatedOrgIdSettingsFeesIndexRoute
  '/_authenticated/$orgId/settings/fsn-network/': typeof AuthenticatedOrgIdSettingsFsnNetworkIndexRoute
  '/_authenticated/$orgId/settings/integrations/': typeof AuthenticatedOrgIdSettingsIntegrationsIndexRoute
  '/_authenticated/$orgId/settings/locations/': typeof AuthenticatedOrgIdSettingsLocationsIndexRoute
  '/_authenticated/$orgId/settings/notifications/': typeof AuthenticatedOrgIdSettingsNotificationsIndexRoute
  '/_authenticated/$orgId/settings/snapdragon/': typeof AuthenticatedOrgIdSettingsSnapdragonIndexRoute
  '/_authenticated/$orgId/settings/stripe/': typeof AuthenticatedOrgIdSettingsStripeIndexRoute
  '/_authenticated/$orgId/settings/subscriptions/': typeof AuthenticatedOrgIdSettingsSubscriptionsIndexRoute
  '/_authenticated/$orgId/settings/supertickets/': typeof AuthenticatedOrgIdSettingsSuperticketsIndexRoute
  '/_authenticated/$orgId/settings/taxes/': typeof AuthenticatedOrgIdSettingsTaxesIndexRoute
  '/_authenticated/$orgId/settings/terminals/': typeof AuthenticatedOrgIdSettingsTerminalsIndexRoute
  '/_authenticated/$orgId/users/$userId/': typeof AuthenticatedOrgIdUsersUserIdIndexRoute
  '/_authenticated/$orgId/website/custom-pages/': typeof AuthenticatedOrgIdWebsiteCustomPagesIndexRoute
  '/_authenticated/$orgId/website/domains/': typeof AuthenticatedOrgIdWebsiteDomainsIndexRoute
  '/_authenticated/$orgId/website/url-redirects/': typeof AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute
  '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit': typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute
  '/_authenticated/$orgId/settings/integrations/snapdragon/history': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute
  '/_authenticated/$orgId/settings/locations/$locationId/history': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute
  '/_authenticated/$orgId/users/$userId/roles/$roleId': typeof AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute
  '/_authenticated/$orgId/settings/integrations/condolences/': typeof AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute
  '/_authenticated/$orgId/settings/integrations/fsn-network/': typeof AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute
  '/_authenticated/$orgId/settings/integrations/google-analytics/': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute
  '/_authenticated/$orgId/settings/integrations/google-tag-manager/': typeof AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute
  '/_authenticated/$orgId/settings/integrations/meta-pixel/': typeof AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute
  '/_authenticated/$orgId/settings/integrations/snapdragon/': typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute
  '/_authenticated/$orgId/settings/locations/$locationId/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute
  '/_authenticated/$orgId/settings/locations/$locationId/deliveries/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute
  '/_authenticated/$orgId/settings/locations/$locationId/hours/': typeof AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-up'
    | '/verify-email'
    | '/$orgId'
    | '/stripe-connect'
    | '/reset-password/$token'
    | '/$orgId/activity'
    | '/$orgId/admin'
    | '/$orgId/imports'
    | '/$orgId/money'
    | '/$orgId/notications-center'
    | '/$orgId/website'
    | '/$orgId/contracts/create'
    | '/$orgId/customer-reviews/$customerReviewId'
    | '/$orgId/customers/$customerId'
    | '/$orgId/customers/create'
    | '/$orgId/designs/$designId'
    | '/$orgId/designs/create'
    | '/$orgId/imports/customer-import'
    | '/$orgId/imports/fsn-import'
    | '/$orgId/imports/product-import'
    | '/$orgId/messages/$messageId'
    | '/$orgId/messages/create'
    | '/$orgId/money/cash-drawer-balancing'
    | '/$orgId/money/customer-balances'
    | '/$orgId/organizations/$organizationId'
    | '/$orgId/organizations/create'
    | '/$orgId/pricing/create'
    | '/$orgId/products/$productId'
    | '/$orgId/products/all-products'
    | '/$orgId/products/catalog-builder'
    | '/$orgId/products/create'
    | '/$orgId/products/inventory'
    | '/$orgId/reports/accounting-journal'
    | '/$orgId/reports/cash-drawer'
    | '/$orgId/reports/closed-days'
    | '/$orgId/reports/customer-balances'
    | '/$orgId/reports/deposits'
    | '/$orgId/reports/external-orders'
    | '/$orgId/reports/phone-clicks'
    | '/$orgId/reports/platform-ledger'
    | '/$orgId/reports/sales-statistics'
    | '/$orgId/reports/sales-tax'
    | '/$orgId/reports/wired-orders'
    | '/$orgId/sales-orders/$salesOrderId'
    | '/$orgId/sales-orders/create'
    | '/$orgId/sales-orders/drafts'
    | '/$orgId/sales-orders/wire-in'
    | '/$orgId/seasonal-content/$seasonalDesignId'
    | '/$orgId/seasonal-content/create'
    | '/$orgId/settings/integrations'
    | '/$orgId/stock-images/$stockImageId'
    | '/$orgId/stock-images/create'
    | '/$orgId/subscriptions/$flowerSubscriptionId'
    | '/$orgId/users/create'
    | '/$orgId/website/builder'
    | '/$orgId/website/domain-launch'
    | '/$orgId/website/overview'
    | '/$orgId/whats-new/$appUpdateId'
    | '/$orgId/whats-new/create'
    | '/$orgId/api-tokens/'
    | '/$orgId/availability/'
    | '/$orgId/contracts/'
    | '/$orgId/customer-reviews/'
    | '/$orgId/customers/'
    | '/$orgId/designs/'
    | '/$orgId/imports/'
    | '/$orgId/marketing/'
    | '/$orgId/messages/'
    | '/$orgId/money/'
    | '/$orgId/organizations/'
    | '/$orgId/pricing/'
    | '/$orgId/products/'
    | '/$orgId/reports/'
    | '/$orgId/sales-orders/'
    | '/$orgId/seasonal-content/'
    | '/$orgId/settings/'
    | '/$orgId/stock-images/'
    | '/$orgId/subscriptions/'
    | '/$orgId/users/'
    | '/$orgId/website/'
    | '/$orgId/whats-new/'
    | '/$orgId/customers/$customerId/history'
    | '/$orgId/designs/$designId/history'
    | '/$orgId/gallery/album/$albumId'
    | '/$orgId/gallery/album/create'
    | '/$orgId/money/sales/$date'
    | '/$orgId/products/$productId/history'
    | '/$orgId/products/add-on-sets/$addOnSetId'
    | '/$orgId/products/add-on-sets/create'
    | '/$orgId/products/add-ons/$addOnId'
    | '/$orgId/products/add-ons/create'
    | '/$orgId/products/collections/$collectionId'
    | '/$orgId/products/collections/create'
    | '/$orgId/products/collections/import'
    | '/$orgId/products/price-changes/$priceAdjustmentId'
    | '/$orgId/products/price-changes/create'
    | '/$orgId/reports/deposits/$depositId'
    | '/$orgId/reports/sales-summary/$date'
    | '/$orgId/reports/sales/$date'
    | '/$orgId/sales-orders/$salesOrderId/edit'
    | '/$orgId/sales-orders/$salesOrderId/history'
    | '/$orgId/sales-orders/$salesOrderId/journal'
    | '/$orgId/sales-orders/delivery-routes/$deliveryShareId'
    | '/$orgId/sales-orders/delivery-routes/create'
    | '/$orgId/settings/billing/history'
    | '/$orgId/settings/cash-drawer/history'
    | '/$orgId/settings/domains/$domainId'
    | '/$orgId/settings/domains/create'
    | '/$orgId/settings/fees/history'
    | '/$orgId/settings/locations/$locationId'
    | '/$orgId/settings/locations/create'
    | '/$orgId/settings/notifications/$recipientId'
    | '/$orgId/settings/notifications/create'
    | '/$orgId/settings/stripe/account-management'
    | '/$orgId/settings/stripe/card-readers'
    | '/$orgId/settings/stripe/disputes'
    | '/$orgId/settings/stripe/onboarding'
    | '/$orgId/settings/stripe/payment-methods'
    | '/$orgId/settings/stripe/payments'
    | '/$orgId/settings/stripe/payouts'
    | '/$orgId/settings/stripe/upgrade'
    | '/$orgId/settings/taxes/history'
    | '/$orgId/settings/terminals/$terminalId'
    | '/$orgId/settings/terminals/create'
    | '/$orgId/users/$userId/history'
    | '/$orgId/website/custom-pages/$customPageId'
    | '/$orgId/website/custom-pages/create'
    | '/$orgId/website/domains/$domainId'
    | '/$orgId/website/domains/create'
    | '/$orgId/website/url-redirects/flower-shop-network'
    | '/$orgId/marketing/discounts/'
    | '/$orgId/money/customer-balances/'
    | '/$orgId/money/sales/'
    | '/$orgId/money/statements/'
    | '/$orgId/organizations/$organizationId/'
    | '/$orgId/products/add-on-sets/'
    | '/$orgId/products/add-ons/'
    | '/$orgId/products/collections/'
    | '/$orgId/products/price-changes/'
    | '/$orgId/reports/accounting-journal/'
    | '/$orgId/reports/cash-drawer/'
    | '/$orgId/reports/closed-days/'
    | '/$orgId/reports/deposits/'
    | '/$orgId/reports/florist-performance/'
    | '/$orgId/reports/phone-clicks/'
    | '/$orgId/reports/platform-ledger/'
    | '/$orgId/reports/sales-statistics/'
    | '/$orgId/reports/sales-summary/'
    | '/$orgId/reports/sales-tax/'
    | '/$orgId/reports/sales/'
    | '/$orgId/reports/tips/'
    | '/$orgId/sales-orders/delivery-routes/'
    | '/$orgId/settings/billing/'
    | '/$orgId/settings/cash-drawer/'
    | '/$orgId/settings/checkout/'
    | '/$orgId/settings/condolences/'
    | '/$orgId/settings/domains/'
    | '/$orgId/settings/email-marketing/'
    | '/$orgId/settings/fees/'
    | '/$orgId/settings/fsn-network/'
    | '/$orgId/settings/integrations/'
    | '/$orgId/settings/locations/'
    | '/$orgId/settings/notifications/'
    | '/$orgId/settings/snapdragon/'
    | '/$orgId/settings/stripe/'
    | '/$orgId/settings/subscriptions/'
    | '/$orgId/settings/supertickets/'
    | '/$orgId/settings/taxes/'
    | '/$orgId/settings/terminals/'
    | '/$orgId/users/$userId/'
    | '/$orgId/website/custom-pages/'
    | '/$orgId/website/domains/'
    | '/$orgId/website/url-redirects/'
    | '/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
    | '/$orgId/settings/integrations/snapdragon/history'
    | '/$orgId/settings/locations/$locationId/history'
    | '/$orgId/users/$userId/roles/$roleId'
    | '/$orgId/settings/integrations/condolences/'
    | '/$orgId/settings/integrations/fsn-network/'
    | '/$orgId/settings/integrations/google-analytics/'
    | '/$orgId/settings/integrations/google-tag-manager/'
    | '/$orgId/settings/integrations/meta-pixel/'
    | '/$orgId/settings/integrations/snapdragon/'
    | '/$orgId/settings/locations/$locationId/'
    | '/$orgId/settings/locations/$locationId/deliveries/'
    | '/$orgId/settings/locations/$locationId/hours/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-up'
    | '/verify-email'
    | '/$orgId'
    | '/stripe-connect'
    | '/reset-password/$token'
    | '/$orgId/activity'
    | '/$orgId/admin'
    | '/$orgId/notications-center'
    | '/$orgId/contracts/create'
    | '/$orgId/customer-reviews/$customerReviewId'
    | '/$orgId/customers/$customerId'
    | '/$orgId/customers/create'
    | '/$orgId/designs/$designId'
    | '/$orgId/designs/create'
    | '/$orgId/imports/customer-import'
    | '/$orgId/imports/fsn-import'
    | '/$orgId/imports/product-import'
    | '/$orgId/messages/$messageId'
    | '/$orgId/messages/create'
    | '/$orgId/money/cash-drawer-balancing'
    | '/$orgId/organizations/create'
    | '/$orgId/pricing/create'
    | '/$orgId/products/$productId'
    | '/$orgId/products/all-products'
    | '/$orgId/products/catalog-builder'
    | '/$orgId/products/create'
    | '/$orgId/products/inventory'
    | '/$orgId/reports/customer-balances'
    | '/$orgId/reports/external-orders'
    | '/$orgId/reports/wired-orders'
    | '/$orgId/sales-orders/$salesOrderId'
    | '/$orgId/sales-orders/create'
    | '/$orgId/sales-orders/drafts'
    | '/$orgId/sales-orders/wire-in'
    | '/$orgId/seasonal-content/$seasonalDesignId'
    | '/$orgId/seasonal-content/create'
    | '/$orgId/stock-images/$stockImageId'
    | '/$orgId/stock-images/create'
    | '/$orgId/subscriptions/$flowerSubscriptionId'
    | '/$orgId/users/create'
    | '/$orgId/website/builder'
    | '/$orgId/website/domain-launch'
    | '/$orgId/website/overview'
    | '/$orgId/whats-new/$appUpdateId'
    | '/$orgId/whats-new/create'
    | '/$orgId/api-tokens'
    | '/$orgId/availability'
    | '/$orgId/contracts'
    | '/$orgId/customer-reviews'
    | '/$orgId/customers'
    | '/$orgId/designs'
    | '/$orgId/imports'
    | '/$orgId/marketing'
    | '/$orgId/messages'
    | '/$orgId/money'
    | '/$orgId/organizations'
    | '/$orgId/pricing'
    | '/$orgId/products'
    | '/$orgId/reports'
    | '/$orgId/sales-orders'
    | '/$orgId/seasonal-content'
    | '/$orgId/settings'
    | '/$orgId/stock-images'
    | '/$orgId/subscriptions'
    | '/$orgId/users'
    | '/$orgId/website'
    | '/$orgId/whats-new'
    | '/$orgId/customers/$customerId/history'
    | '/$orgId/designs/$designId/history'
    | '/$orgId/gallery/album/$albumId'
    | '/$orgId/gallery/album/create'
    | '/$orgId/money/sales/$date'
    | '/$orgId/products/$productId/history'
    | '/$orgId/products/add-on-sets/$addOnSetId'
    | '/$orgId/products/add-on-sets/create'
    | '/$orgId/products/add-ons/$addOnId'
    | '/$orgId/products/add-ons/create'
    | '/$orgId/products/collections/$collectionId'
    | '/$orgId/products/collections/create'
    | '/$orgId/products/collections/import'
    | '/$orgId/products/price-changes/$priceAdjustmentId'
    | '/$orgId/products/price-changes/create'
    | '/$orgId/reports/deposits/$depositId'
    | '/$orgId/reports/sales-summary/$date'
    | '/$orgId/reports/sales/$date'
    | '/$orgId/sales-orders/$salesOrderId/edit'
    | '/$orgId/sales-orders/$salesOrderId/history'
    | '/$orgId/sales-orders/$salesOrderId/journal'
    | '/$orgId/sales-orders/delivery-routes/$deliveryShareId'
    | '/$orgId/sales-orders/delivery-routes/create'
    | '/$orgId/settings/billing/history'
    | '/$orgId/settings/cash-drawer/history'
    | '/$orgId/settings/domains/$domainId'
    | '/$orgId/settings/domains/create'
    | '/$orgId/settings/fees/history'
    | '/$orgId/settings/locations/create'
    | '/$orgId/settings/notifications/$recipientId'
    | '/$orgId/settings/notifications/create'
    | '/$orgId/settings/stripe/account-management'
    | '/$orgId/settings/stripe/card-readers'
    | '/$orgId/settings/stripe/disputes'
    | '/$orgId/settings/stripe/onboarding'
    | '/$orgId/settings/stripe/payment-methods'
    | '/$orgId/settings/stripe/payments'
    | '/$orgId/settings/stripe/payouts'
    | '/$orgId/settings/stripe/upgrade'
    | '/$orgId/settings/taxes/history'
    | '/$orgId/settings/terminals/$terminalId'
    | '/$orgId/settings/terminals/create'
    | '/$orgId/users/$userId/history'
    | '/$orgId/website/custom-pages/$customPageId'
    | '/$orgId/website/custom-pages/create'
    | '/$orgId/website/domains/$domainId'
    | '/$orgId/website/domains/create'
    | '/$orgId/website/url-redirects/flower-shop-network'
    | '/$orgId/marketing/discounts'
    | '/$orgId/money/customer-balances'
    | '/$orgId/money/sales'
    | '/$orgId/money/statements'
    | '/$orgId/organizations/$organizationId'
    | '/$orgId/products/add-on-sets'
    | '/$orgId/products/add-ons'
    | '/$orgId/products/collections'
    | '/$orgId/products/price-changes'
    | '/$orgId/reports/accounting-journal'
    | '/$orgId/reports/cash-drawer'
    | '/$orgId/reports/closed-days'
    | '/$orgId/reports/deposits'
    | '/$orgId/reports/florist-performance'
    | '/$orgId/reports/phone-clicks'
    | '/$orgId/reports/platform-ledger'
    | '/$orgId/reports/sales-statistics'
    | '/$orgId/reports/sales-summary'
    | '/$orgId/reports/sales-tax'
    | '/$orgId/reports/sales'
    | '/$orgId/reports/tips'
    | '/$orgId/sales-orders/delivery-routes'
    | '/$orgId/settings/billing'
    | '/$orgId/settings/cash-drawer'
    | '/$orgId/settings/checkout'
    | '/$orgId/settings/condolences'
    | '/$orgId/settings/domains'
    | '/$orgId/settings/email-marketing'
    | '/$orgId/settings/fees'
    | '/$orgId/settings/fsn-network'
    | '/$orgId/settings/integrations'
    | '/$orgId/settings/locations'
    | '/$orgId/settings/notifications'
    | '/$orgId/settings/snapdragon'
    | '/$orgId/settings/stripe'
    | '/$orgId/settings/subscriptions'
    | '/$orgId/settings/supertickets'
    | '/$orgId/settings/taxes'
    | '/$orgId/settings/terminals'
    | '/$orgId/users/$userId'
    | '/$orgId/website/custom-pages'
    | '/$orgId/website/domains'
    | '/$orgId/website/url-redirects'
    | '/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
    | '/$orgId/settings/integrations/snapdragon/history'
    | '/$orgId/settings/locations/$locationId/history'
    | '/$orgId/users/$userId/roles/$roleId'
    | '/$orgId/settings/integrations/condolences'
    | '/$orgId/settings/integrations/fsn-network'
    | '/$orgId/settings/integrations/google-analytics'
    | '/$orgId/settings/integrations/google-tag-manager'
    | '/$orgId/settings/integrations/meta-pixel'
    | '/$orgId/settings/integrations/snapdragon'
    | '/$orgId/settings/locations/$locationId'
    | '/$orgId/settings/locations/$locationId/deliveries'
    | '/$orgId/settings/locations/$locationId/hours'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/sign-up'
    | '/(auth)/verify-email'
    | '/_authenticated/$orgId'
    | '/_authenticated/stripe-connect'
    | '/(auth)/reset-password/$token'
    | '/_authenticated/$orgId/activity'
    | '/_authenticated/$orgId/admin'
    | '/_authenticated/$orgId/imports'
    | '/_authenticated/$orgId/money'
    | '/_authenticated/$orgId/notications-center'
    | '/_authenticated/$orgId/website'
    | '/_authenticated/$orgId/contracts/create'
    | '/_authenticated/$orgId/customer-reviews/$customerReviewId'
    | '/_authenticated/$orgId/customers/$customerId'
    | '/_authenticated/$orgId/customers/create'
    | '/_authenticated/$orgId/designs/$designId'
    | '/_authenticated/$orgId/designs/create'
    | '/_authenticated/$orgId/imports/customer-import'
    | '/_authenticated/$orgId/imports/fsn-import'
    | '/_authenticated/$orgId/imports/product-import'
    | '/_authenticated/$orgId/messages/$messageId'
    | '/_authenticated/$orgId/messages/create'
    | '/_authenticated/$orgId/money/cash-drawer-balancing'
    | '/_authenticated/$orgId/money/customer-balances'
    | '/_authenticated/$orgId/organizations/$organizationId'
    | '/_authenticated/$orgId/organizations/create'
    | '/_authenticated/$orgId/pricing/create'
    | '/_authenticated/$orgId/products/$productId'
    | '/_authenticated/$orgId/products/all-products'
    | '/_authenticated/$orgId/products/catalog-builder'
    | '/_authenticated/$orgId/products/create'
    | '/_authenticated/$orgId/products/inventory'
    | '/_authenticated/$orgId/reports/accounting-journal'
    | '/_authenticated/$orgId/reports/cash-drawer'
    | '/_authenticated/$orgId/reports/closed-days'
    | '/_authenticated/$orgId/reports/customer-balances'
    | '/_authenticated/$orgId/reports/deposits'
    | '/_authenticated/$orgId/reports/external-orders'
    | '/_authenticated/$orgId/reports/phone-clicks'
    | '/_authenticated/$orgId/reports/platform-ledger'
    | '/_authenticated/$orgId/reports/sales-statistics'
    | '/_authenticated/$orgId/reports/sales-tax'
    | '/_authenticated/$orgId/reports/wired-orders'
    | '/_authenticated/$orgId/sales-orders/$salesOrderId'
    | '/_authenticated/$orgId/sales-orders/create'
    | '/_authenticated/$orgId/sales-orders/drafts'
    | '/_authenticated/$orgId/sales-orders/wire-in'
    | '/_authenticated/$orgId/seasonal-content/$seasonalDesignId'
    | '/_authenticated/$orgId/seasonal-content/create'
    | '/_authenticated/$orgId/settings/integrations'
    | '/_authenticated/$orgId/stock-images/$stockImageId'
    | '/_authenticated/$orgId/stock-images/create'
    | '/_authenticated/$orgId/subscriptions/$flowerSubscriptionId'
    | '/_authenticated/$orgId/users/create'
    | '/_authenticated/$orgId/website/builder'
    | '/_authenticated/$orgId/website/domain-launch'
    | '/_authenticated/$orgId/website/overview'
    | '/_authenticated/$orgId/whats-new/$appUpdateId'
    | '/_authenticated/$orgId/whats-new/create'
    | '/_authenticated/$orgId/api-tokens/'
    | '/_authenticated/$orgId/availability/'
    | '/_authenticated/$orgId/contracts/'
    | '/_authenticated/$orgId/customer-reviews/'
    | '/_authenticated/$orgId/customers/'
    | '/_authenticated/$orgId/designs/'
    | '/_authenticated/$orgId/imports/'
    | '/_authenticated/$orgId/marketing/'
    | '/_authenticated/$orgId/messages/'
    | '/_authenticated/$orgId/money/'
    | '/_authenticated/$orgId/organizations/'
    | '/_authenticated/$orgId/pricing/'
    | '/_authenticated/$orgId/products/'
    | '/_authenticated/$orgId/reports/'
    | '/_authenticated/$orgId/sales-orders/'
    | '/_authenticated/$orgId/seasonal-content/'
    | '/_authenticated/$orgId/settings/'
    | '/_authenticated/$orgId/stock-images/'
    | '/_authenticated/$orgId/subscriptions/'
    | '/_authenticated/$orgId/users/'
    | '/_authenticated/$orgId/website/'
    | '/_authenticated/$orgId/whats-new/'
    | '/_authenticated/$orgId/customers/$customerId_/history'
    | '/_authenticated/$orgId/designs/$designId_/history'
    | '/_authenticated/$orgId/gallery/album/$albumId'
    | '/_authenticated/$orgId/gallery/album/create'
    | '/_authenticated/$orgId/money/sales/$date'
    | '/_authenticated/$orgId/products/$productId_/history'
    | '/_authenticated/$orgId/products/add-on-sets/$addOnSetId'
    | '/_authenticated/$orgId/products/add-on-sets/create'
    | '/_authenticated/$orgId/products/add-ons/$addOnId'
    | '/_authenticated/$orgId/products/add-ons/create'
    | '/_authenticated/$orgId/products/collections/$collectionId'
    | '/_authenticated/$orgId/products/collections/create'
    | '/_authenticated/$orgId/products/collections/import'
    | '/_authenticated/$orgId/products/price-changes/$priceAdjustmentId'
    | '/_authenticated/$orgId/products/price-changes/create'
    | '/_authenticated/$orgId/reports/deposits/$depositId'
    | '/_authenticated/$orgId/reports/sales-summary/$date'
    | '/_authenticated/$orgId/reports/sales/$date'
    | '/_authenticated/$orgId/sales-orders/$salesOrderId_/edit'
    | '/_authenticated/$orgId/sales-orders/$salesOrderId_/history'
    | '/_authenticated/$orgId/sales-orders/$salesOrderId_/journal'
    | '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId'
    | '/_authenticated/$orgId/sales-orders/delivery-routes/create'
    | '/_authenticated/$orgId/settings/billing/history'
    | '/_authenticated/$orgId/settings/cash-drawer/history'
    | '/_authenticated/$orgId/settings/domains/$domainId'
    | '/_authenticated/$orgId/settings/domains/create'
    | '/_authenticated/$orgId/settings/fees/history'
    | '/_authenticated/$orgId/settings/locations/$locationId'
    | '/_authenticated/$orgId/settings/locations/create'
    | '/_authenticated/$orgId/settings/notifications/$recipientId'
    | '/_authenticated/$orgId/settings/notifications/create'
    | '/_authenticated/$orgId/settings/stripe/account-management'
    | '/_authenticated/$orgId/settings/stripe/card-readers'
    | '/_authenticated/$orgId/settings/stripe/disputes'
    | '/_authenticated/$orgId/settings/stripe/onboarding'
    | '/_authenticated/$orgId/settings/stripe/payment-methods'
    | '/_authenticated/$orgId/settings/stripe/payments'
    | '/_authenticated/$orgId/settings/stripe/payouts'
    | '/_authenticated/$orgId/settings/stripe/upgrade'
    | '/_authenticated/$orgId/settings/taxes/history'
    | '/_authenticated/$orgId/settings/terminals/$terminalId'
    | '/_authenticated/$orgId/settings/terminals/create'
    | '/_authenticated/$orgId/users/$userId/history'
    | '/_authenticated/$orgId/website/custom-pages/$customPageId'
    | '/_authenticated/$orgId/website/custom-pages/create'
    | '/_authenticated/$orgId/website/domains/$domainId'
    | '/_authenticated/$orgId/website/domains/create'
    | '/_authenticated/$orgId/website/url-redirects/flower-shop-network'
    | '/_authenticated/$orgId/marketing/discounts/'
    | '/_authenticated/$orgId/money/customer-balances/'
    | '/_authenticated/$orgId/money/sales/'
    | '/_authenticated/$orgId/money/statements/'
    | '/_authenticated/$orgId/organizations/$organizationId/'
    | '/_authenticated/$orgId/products/add-on-sets/'
    | '/_authenticated/$orgId/products/add-ons/'
    | '/_authenticated/$orgId/products/collections/'
    | '/_authenticated/$orgId/products/price-changes/'
    | '/_authenticated/$orgId/reports/accounting-journal/'
    | '/_authenticated/$orgId/reports/cash-drawer/'
    | '/_authenticated/$orgId/reports/closed-days/'
    | '/_authenticated/$orgId/reports/deposits/'
    | '/_authenticated/$orgId/reports/florist-performance/'
    | '/_authenticated/$orgId/reports/phone-clicks/'
    | '/_authenticated/$orgId/reports/platform-ledger/'
    | '/_authenticated/$orgId/reports/sales-statistics/'
    | '/_authenticated/$orgId/reports/sales-summary/'
    | '/_authenticated/$orgId/reports/sales-tax/'
    | '/_authenticated/$orgId/reports/sales/'
    | '/_authenticated/$orgId/reports/tips/'
    | '/_authenticated/$orgId/sales-orders/delivery-routes/'
    | '/_authenticated/$orgId/settings/billing/'
    | '/_authenticated/$orgId/settings/cash-drawer/'
    | '/_authenticated/$orgId/settings/checkout/'
    | '/_authenticated/$orgId/settings/condolences/'
    | '/_authenticated/$orgId/settings/domains/'
    | '/_authenticated/$orgId/settings/email-marketing/'
    | '/_authenticated/$orgId/settings/fees/'
    | '/_authenticated/$orgId/settings/fsn-network/'
    | '/_authenticated/$orgId/settings/integrations/'
    | '/_authenticated/$orgId/settings/locations/'
    | '/_authenticated/$orgId/settings/notifications/'
    | '/_authenticated/$orgId/settings/snapdragon/'
    | '/_authenticated/$orgId/settings/stripe/'
    | '/_authenticated/$orgId/settings/subscriptions/'
    | '/_authenticated/$orgId/settings/supertickets/'
    | '/_authenticated/$orgId/settings/taxes/'
    | '/_authenticated/$orgId/settings/terminals/'
    | '/_authenticated/$orgId/users/$userId/'
    | '/_authenticated/$orgId/website/custom-pages/'
    | '/_authenticated/$orgId/website/domains/'
    | '/_authenticated/$orgId/website/url-redirects/'
    | '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
    | '/_authenticated/$orgId/settings/integrations/snapdragon/history'
    | '/_authenticated/$orgId/settings/locations/$locationId/history'
    | '/_authenticated/$orgId/users/$userId/roles/$roleId'
    | '/_authenticated/$orgId/settings/integrations/condolences/'
    | '/_authenticated/$orgId/settings/integrations/fsn-network/'
    | '/_authenticated/$orgId/settings/integrations/google-analytics/'
    | '/_authenticated/$orgId/settings/integrations/google-tag-manager/'
    | '/_authenticated/$orgId/settings/integrations/meta-pixel/'
    | '/_authenticated/$orgId/settings/integrations/snapdragon/'
    | '/_authenticated/$orgId/settings/locations/$locationId/'
    | '/_authenticated/$orgId/settings/locations/$locationId/deliveries/'
    | '/_authenticated/$orgId/settings/locations/$locationId/hours/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authSignUpRoute: typeof authSignUpRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authResetPasswordTokenRoute: typeof authResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/stripe-connect': {
      id: '/_authenticated/stripe-connect'
      path: '/stripe-connect'
      fullPath: '/stripe-connect'
      preLoaderRoute: typeof AuthenticatedStripeConnectRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$orgId': {
      id: '/_authenticated/$orgId'
      path: '/$orgId'
      fullPath: '/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$orgId/website': {
      id: '/_authenticated/$orgId/website'
      path: '/website'
      fullPath: '/$orgId/website'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/notications-center': {
      id: '/_authenticated/$orgId/notications-center'
      path: '/notications-center'
      fullPath: '/$orgId/notications-center'
      preLoaderRoute: typeof AuthenticatedOrgIdNoticationsCenterRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/money': {
      id: '/_authenticated/$orgId/money'
      path: '/money'
      fullPath: '/$orgId/money'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/imports': {
      id: '/_authenticated/$orgId/imports'
      path: '/imports'
      fullPath: '/$orgId/imports'
      preLoaderRoute: typeof AuthenticatedOrgIdImportsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/admin': {
      id: '/_authenticated/$orgId/admin'
      path: '/admin'
      fullPath: '/$orgId/admin'
      preLoaderRoute: typeof AuthenticatedOrgIdAdminRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/activity': {
      id: '/_authenticated/$orgId/activity'
      path: '/activity'
      fullPath: '/$orgId/activity'
      preLoaderRoute: typeof AuthenticatedOrgIdActivityRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/(auth)/reset-password/$token': {
      id: '/(auth)/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof authResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$orgId/whats-new/': {
      id: '/_authenticated/$orgId/whats-new/'
      path: '/whats-new'
      fullPath: '/$orgId/whats-new/'
      preLoaderRoute: typeof AuthenticatedOrgIdWhatsNewIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/website/': {
      id: '/_authenticated/$orgId/website/'
      path: '/'
      fullPath: '/$orgId/website/'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/users/': {
      id: '/_authenticated/$orgId/users/'
      path: '/users'
      fullPath: '/$orgId/users/'
      preLoaderRoute: typeof AuthenticatedOrgIdUsersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/subscriptions/': {
      id: '/_authenticated/$orgId/subscriptions/'
      path: '/subscriptions'
      fullPath: '/$orgId/subscriptions/'
      preLoaderRoute: typeof AuthenticatedOrgIdSubscriptionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/stock-images/': {
      id: '/_authenticated/$orgId/stock-images/'
      path: '/stock-images'
      fullPath: '/$orgId/stock-images/'
      preLoaderRoute: typeof AuthenticatedOrgIdStockImagesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/': {
      id: '/_authenticated/$orgId/settings/'
      path: '/settings'
      fullPath: '/$orgId/settings/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/seasonal-content/': {
      id: '/_authenticated/$orgId/seasonal-content/'
      path: '/seasonal-content'
      fullPath: '/$orgId/seasonal-content/'
      preLoaderRoute: typeof AuthenticatedOrgIdSeasonalContentIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/': {
      id: '/_authenticated/$orgId/sales-orders/'
      path: '/sales-orders'
      fullPath: '/$orgId/sales-orders/'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/': {
      id: '/_authenticated/$orgId/reports/'
      path: '/reports'
      fullPath: '/$orgId/reports/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/': {
      id: '/_authenticated/$orgId/products/'
      path: '/products'
      fullPath: '/$orgId/products/'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/pricing/': {
      id: '/_authenticated/$orgId/pricing/'
      path: '/pricing'
      fullPath: '/$orgId/pricing/'
      preLoaderRoute: typeof AuthenticatedOrgIdPricingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/organizations/': {
      id: '/_authenticated/$orgId/organizations/'
      path: '/organizations'
      fullPath: '/$orgId/organizations/'
      preLoaderRoute: typeof AuthenticatedOrgIdOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/money/': {
      id: '/_authenticated/$orgId/money/'
      path: '/'
      fullPath: '/$orgId/money/'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/messages/': {
      id: '/_authenticated/$orgId/messages/'
      path: '/messages'
      fullPath: '/$orgId/messages/'
      preLoaderRoute: typeof AuthenticatedOrgIdMessagesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/marketing/': {
      id: '/_authenticated/$orgId/marketing/'
      path: '/marketing'
      fullPath: '/$orgId/marketing/'
      preLoaderRoute: typeof AuthenticatedOrgIdMarketingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/imports/': {
      id: '/_authenticated/$orgId/imports/'
      path: '/'
      fullPath: '/$orgId/imports/'
      preLoaderRoute: typeof AuthenticatedOrgIdImportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdImportsRoute
    }
    '/_authenticated/$orgId/designs/': {
      id: '/_authenticated/$orgId/designs/'
      path: '/designs'
      fullPath: '/$orgId/designs/'
      preLoaderRoute: typeof AuthenticatedOrgIdDesignsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customers/': {
      id: '/_authenticated/$orgId/customers/'
      path: '/customers'
      fullPath: '/$orgId/customers/'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customer-reviews/': {
      id: '/_authenticated/$orgId/customer-reviews/'
      path: '/customer-reviews'
      fullPath: '/$orgId/customer-reviews/'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomerReviewsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/contracts/': {
      id: '/_authenticated/$orgId/contracts/'
      path: '/contracts'
      fullPath: '/$orgId/contracts/'
      preLoaderRoute: typeof AuthenticatedOrgIdContractsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/availability/': {
      id: '/_authenticated/$orgId/availability/'
      path: '/availability'
      fullPath: '/$orgId/availability/'
      preLoaderRoute: typeof AuthenticatedOrgIdAvailabilityIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/api-tokens/': {
      id: '/_authenticated/$orgId/api-tokens/'
      path: '/api-tokens'
      fullPath: '/$orgId/api-tokens/'
      preLoaderRoute: typeof AuthenticatedOrgIdApiTokensIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/whats-new/create': {
      id: '/_authenticated/$orgId/whats-new/create'
      path: '/whats-new/create'
      fullPath: '/$orgId/whats-new/create'
      preLoaderRoute: typeof AuthenticatedOrgIdWhatsNewCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/whats-new/$appUpdateId': {
      id: '/_authenticated/$orgId/whats-new/$appUpdateId'
      path: '/whats-new/$appUpdateId'
      fullPath: '/$orgId/whats-new/$appUpdateId'
      preLoaderRoute: typeof AuthenticatedOrgIdWhatsNewAppUpdateIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/website/overview': {
      id: '/_authenticated/$orgId/website/overview'
      path: '/overview'
      fullPath: '/$orgId/website/overview'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteOverviewRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/domain-launch': {
      id: '/_authenticated/$orgId/website/domain-launch'
      path: '/domain-launch'
      fullPath: '/$orgId/website/domain-launch'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteDomainLaunchRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/builder': {
      id: '/_authenticated/$orgId/website/builder'
      path: '/builder'
      fullPath: '/$orgId/website/builder'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteBuilderRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/users/create': {
      id: '/_authenticated/$orgId/users/create'
      path: '/users/create'
      fullPath: '/$orgId/users/create'
      preLoaderRoute: typeof AuthenticatedOrgIdUsersCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/subscriptions/$flowerSubscriptionId': {
      id: '/_authenticated/$orgId/subscriptions/$flowerSubscriptionId'
      path: '/subscriptions/$flowerSubscriptionId'
      fullPath: '/$orgId/subscriptions/$flowerSubscriptionId'
      preLoaderRoute: typeof AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/stock-images/create': {
      id: '/_authenticated/$orgId/stock-images/create'
      path: '/stock-images/create'
      fullPath: '/$orgId/stock-images/create'
      preLoaderRoute: typeof AuthenticatedOrgIdStockImagesCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/stock-images/$stockImageId': {
      id: '/_authenticated/$orgId/stock-images/$stockImageId'
      path: '/stock-images/$stockImageId'
      fullPath: '/$orgId/stock-images/$stockImageId'
      preLoaderRoute: typeof AuthenticatedOrgIdStockImagesStockImageIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/integrations': {
      id: '/_authenticated/$orgId/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/$orgId/settings/integrations'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/seasonal-content/create': {
      id: '/_authenticated/$orgId/seasonal-content/create'
      path: '/seasonal-content/create'
      fullPath: '/$orgId/seasonal-content/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSeasonalContentCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/seasonal-content/$seasonalDesignId': {
      id: '/_authenticated/$orgId/seasonal-content/$seasonalDesignId'
      path: '/seasonal-content/$seasonalDesignId'
      fullPath: '/$orgId/seasonal-content/$seasonalDesignId'
      preLoaderRoute: typeof AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/wire-in': {
      id: '/_authenticated/$orgId/sales-orders/wire-in'
      path: '/sales-orders/wire-in'
      fullPath: '/$orgId/sales-orders/wire-in'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersWireInRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/drafts': {
      id: '/_authenticated/$orgId/sales-orders/drafts'
      path: '/sales-orders/drafts'
      fullPath: '/$orgId/sales-orders/drafts'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersDraftsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/create': {
      id: '/_authenticated/$orgId/sales-orders/create'
      path: '/sales-orders/create'
      fullPath: '/$orgId/sales-orders/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/$salesOrderId': {
      id: '/_authenticated/$orgId/sales-orders/$salesOrderId'
      path: '/sales-orders/$salesOrderId'
      fullPath: '/$orgId/sales-orders/$salesOrderId'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/wired-orders': {
      id: '/_authenticated/$orgId/reports/wired-orders'
      path: '/reports/wired-orders'
      fullPath: '/$orgId/reports/wired-orders'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsWiredOrdersRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales-tax': {
      id: '/_authenticated/$orgId/reports/sales-tax'
      path: '/reports/sales-tax'
      fullPath: '/$orgId/reports/sales-tax'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesTaxRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales-statistics': {
      id: '/_authenticated/$orgId/reports/sales-statistics'
      path: '/reports/sales-statistics'
      fullPath: '/$orgId/reports/sales-statistics'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesStatisticsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/platform-ledger': {
      id: '/_authenticated/$orgId/reports/platform-ledger'
      path: '/reports/platform-ledger'
      fullPath: '/$orgId/reports/platform-ledger'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsPlatformLedgerRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/phone-clicks': {
      id: '/_authenticated/$orgId/reports/phone-clicks'
      path: '/reports/phone-clicks'
      fullPath: '/$orgId/reports/phone-clicks'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsPhoneClicksRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/external-orders': {
      id: '/_authenticated/$orgId/reports/external-orders'
      path: '/reports/external-orders'
      fullPath: '/$orgId/reports/external-orders'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsExternalOrdersRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/deposits': {
      id: '/_authenticated/$orgId/reports/deposits'
      path: '/reports/deposits'
      fullPath: '/$orgId/reports/deposits'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsDepositsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/customer-balances': {
      id: '/_authenticated/$orgId/reports/customer-balances'
      path: '/reports/customer-balances'
      fullPath: '/$orgId/reports/customer-balances'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsCustomerBalancesRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/closed-days': {
      id: '/_authenticated/$orgId/reports/closed-days'
      path: '/reports/closed-days'
      fullPath: '/$orgId/reports/closed-days'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsClosedDaysRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/cash-drawer': {
      id: '/_authenticated/$orgId/reports/cash-drawer'
      path: '/reports/cash-drawer'
      fullPath: '/$orgId/reports/cash-drawer'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsCashDrawerRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/accounting-journal': {
      id: '/_authenticated/$orgId/reports/accounting-journal'
      path: '/reports/accounting-journal'
      fullPath: '/$orgId/reports/accounting-journal'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsAccountingJournalRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/inventory': {
      id: '/_authenticated/$orgId/products/inventory'
      path: '/products/inventory'
      fullPath: '/$orgId/products/inventory'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsInventoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/create': {
      id: '/_authenticated/$orgId/products/create'
      path: '/products/create'
      fullPath: '/$orgId/products/create'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/catalog-builder': {
      id: '/_authenticated/$orgId/products/catalog-builder'
      path: '/products/catalog-builder'
      fullPath: '/$orgId/products/catalog-builder'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCatalogBuilderRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/all-products': {
      id: '/_authenticated/$orgId/products/all-products'
      path: '/products/all-products'
      fullPath: '/$orgId/products/all-products'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAllProductsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/$productId': {
      id: '/_authenticated/$orgId/products/$productId'
      path: '/products/$productId'
      fullPath: '/$orgId/products/$productId'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/pricing/create': {
      id: '/_authenticated/$orgId/pricing/create'
      path: '/pricing/create'
      fullPath: '/$orgId/pricing/create'
      preLoaderRoute: typeof AuthenticatedOrgIdPricingCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/organizations/create': {
      id: '/_authenticated/$orgId/organizations/create'
      path: '/organizations/create'
      fullPath: '/$orgId/organizations/create'
      preLoaderRoute: typeof AuthenticatedOrgIdOrganizationsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/organizations/$organizationId': {
      id: '/_authenticated/$orgId/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/$orgId/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrgIdOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/money/customer-balances': {
      id: '/_authenticated/$orgId/money/customer-balances'
      path: '/customer-balances'
      fullPath: '/$orgId/money/customer-balances'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyCustomerBalancesRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/money/cash-drawer-balancing': {
      id: '/_authenticated/$orgId/money/cash-drawer-balancing'
      path: '/cash-drawer-balancing'
      fullPath: '/$orgId/money/cash-drawer-balancing'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyCashDrawerBalancingRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/messages/create': {
      id: '/_authenticated/$orgId/messages/create'
      path: '/messages/create'
      fullPath: '/$orgId/messages/create'
      preLoaderRoute: typeof AuthenticatedOrgIdMessagesCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/messages/$messageId': {
      id: '/_authenticated/$orgId/messages/$messageId'
      path: '/messages/$messageId'
      fullPath: '/$orgId/messages/$messageId'
      preLoaderRoute: typeof AuthenticatedOrgIdMessagesMessageIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/imports/product-import': {
      id: '/_authenticated/$orgId/imports/product-import'
      path: '/product-import'
      fullPath: '/$orgId/imports/product-import'
      preLoaderRoute: typeof AuthenticatedOrgIdImportsProductImportRouteImport
      parentRoute: typeof AuthenticatedOrgIdImportsRoute
    }
    '/_authenticated/$orgId/imports/fsn-import': {
      id: '/_authenticated/$orgId/imports/fsn-import'
      path: '/fsn-import'
      fullPath: '/$orgId/imports/fsn-import'
      preLoaderRoute: typeof AuthenticatedOrgIdImportsFsnImportRouteImport
      parentRoute: typeof AuthenticatedOrgIdImportsRoute
    }
    '/_authenticated/$orgId/imports/customer-import': {
      id: '/_authenticated/$orgId/imports/customer-import'
      path: '/customer-import'
      fullPath: '/$orgId/imports/customer-import'
      preLoaderRoute: typeof AuthenticatedOrgIdImportsCustomerImportRouteImport
      parentRoute: typeof AuthenticatedOrgIdImportsRoute
    }
    '/_authenticated/$orgId/designs/create': {
      id: '/_authenticated/$orgId/designs/create'
      path: '/designs/create'
      fullPath: '/$orgId/designs/create'
      preLoaderRoute: typeof AuthenticatedOrgIdDesignsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/designs/$designId': {
      id: '/_authenticated/$orgId/designs/$designId'
      path: '/designs/$designId'
      fullPath: '/$orgId/designs/$designId'
      preLoaderRoute: typeof AuthenticatedOrgIdDesignsDesignIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customers/create': {
      id: '/_authenticated/$orgId/customers/create'
      path: '/customers/create'
      fullPath: '/$orgId/customers/create'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomersCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customers/$customerId': {
      id: '/_authenticated/$orgId/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/$orgId/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customer-reviews/$customerReviewId': {
      id: '/_authenticated/$orgId/customer-reviews/$customerReviewId'
      path: '/customer-reviews/$customerReviewId'
      fullPath: '/$orgId/customer-reviews/$customerReviewId'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/contracts/create': {
      id: '/_authenticated/$orgId/contracts/create'
      path: '/contracts/create'
      fullPath: '/$orgId/contracts/create'
      preLoaderRoute: typeof AuthenticatedOrgIdContractsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/website/url-redirects/': {
      id: '/_authenticated/$orgId/website/url-redirects/'
      path: '/url-redirects'
      fullPath: '/$orgId/website/url-redirects/'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteUrlRedirectsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/domains/': {
      id: '/_authenticated/$orgId/website/domains/'
      path: '/domains'
      fullPath: '/$orgId/website/domains/'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteDomainsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/custom-pages/': {
      id: '/_authenticated/$orgId/website/custom-pages/'
      path: '/custom-pages'
      fullPath: '/$orgId/website/custom-pages/'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/users/$userId/': {
      id: '/_authenticated/$orgId/users/$userId/'
      path: '/users/$userId'
      fullPath: '/$orgId/users/$userId/'
      preLoaderRoute: typeof AuthenticatedOrgIdUsersUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/terminals/': {
      id: '/_authenticated/$orgId/settings/terminals/'
      path: '/settings/terminals'
      fullPath: '/$orgId/settings/terminals/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsTerminalsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/taxes/': {
      id: '/_authenticated/$orgId/settings/taxes/'
      path: '/settings/taxes'
      fullPath: '/$orgId/settings/taxes/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsTaxesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/supertickets/': {
      id: '/_authenticated/$orgId/settings/supertickets/'
      path: '/settings/supertickets'
      fullPath: '/$orgId/settings/supertickets/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsSuperticketsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/subscriptions/': {
      id: '/_authenticated/$orgId/settings/subscriptions/'
      path: '/settings/subscriptions'
      fullPath: '/$orgId/settings/subscriptions/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsSubscriptionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/': {
      id: '/_authenticated/$orgId/settings/stripe/'
      path: '/settings/stripe'
      fullPath: '/$orgId/settings/stripe/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/snapdragon/': {
      id: '/_authenticated/$orgId/settings/snapdragon/'
      path: '/settings/snapdragon'
      fullPath: '/$orgId/settings/snapdragon/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsSnapdragonIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/notifications/': {
      id: '/_authenticated/$orgId/settings/notifications/'
      path: '/settings/notifications'
      fullPath: '/$orgId/settings/notifications/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/locations/': {
      id: '/_authenticated/$orgId/settings/locations/'
      path: '/settings/locations'
      fullPath: '/$orgId/settings/locations/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/integrations/': {
      id: '/_authenticated/$orgId/settings/integrations/'
      path: '/'
      fullPath: '/$orgId/settings/integrations/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/fsn-network/': {
      id: '/_authenticated/$orgId/settings/fsn-network/'
      path: '/settings/fsn-network'
      fullPath: '/$orgId/settings/fsn-network/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsFsnNetworkIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/fees/': {
      id: '/_authenticated/$orgId/settings/fees/'
      path: '/settings/fees'
      fullPath: '/$orgId/settings/fees/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsFeesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/email-marketing/': {
      id: '/_authenticated/$orgId/settings/email-marketing/'
      path: '/settings/email-marketing'
      fullPath: '/$orgId/settings/email-marketing/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsEmailMarketingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/domains/': {
      id: '/_authenticated/$orgId/settings/domains/'
      path: '/settings/domains'
      fullPath: '/$orgId/settings/domains/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsDomainsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/condolences/': {
      id: '/_authenticated/$orgId/settings/condolences/'
      path: '/settings/condolences'
      fullPath: '/$orgId/settings/condolences/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsCondolencesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/checkout/': {
      id: '/_authenticated/$orgId/settings/checkout/'
      path: '/settings/checkout'
      fullPath: '/$orgId/settings/checkout/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsCheckoutIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/cash-drawer/': {
      id: '/_authenticated/$orgId/settings/cash-drawer/'
      path: '/settings/cash-drawer'
      fullPath: '/$orgId/settings/cash-drawer/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsCashDrawerIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/billing/': {
      id: '/_authenticated/$orgId/settings/billing/'
      path: '/settings/billing'
      fullPath: '/$orgId/settings/billing/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/delivery-routes/': {
      id: '/_authenticated/$orgId/sales-orders/delivery-routes/'
      path: '/sales-orders/delivery-routes'
      fullPath: '/$orgId/sales-orders/delivery-routes/'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/tips/': {
      id: '/_authenticated/$orgId/reports/tips/'
      path: '/reports/tips'
      fullPath: '/$orgId/reports/tips/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsTipsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales/': {
      id: '/_authenticated/$orgId/reports/sales/'
      path: '/reports/sales'
      fullPath: '/$orgId/reports/sales/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales-tax/': {
      id: '/_authenticated/$orgId/reports/sales-tax/'
      path: '/'
      fullPath: '/$orgId/reports/sales-tax/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesTaxIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsSalesTaxRoute
    }
    '/_authenticated/$orgId/reports/sales-summary/': {
      id: '/_authenticated/$orgId/reports/sales-summary/'
      path: '/reports/sales-summary'
      fullPath: '/$orgId/reports/sales-summary/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesSummaryIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales-statistics/': {
      id: '/_authenticated/$orgId/reports/sales-statistics/'
      path: '/'
      fullPath: '/$orgId/reports/sales-statistics/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesStatisticsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsSalesStatisticsRoute
    }
    '/_authenticated/$orgId/reports/platform-ledger/': {
      id: '/_authenticated/$orgId/reports/platform-ledger/'
      path: '/'
      fullPath: '/$orgId/reports/platform-ledger/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsPlatformLedgerIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsPlatformLedgerRoute
    }
    '/_authenticated/$orgId/reports/phone-clicks/': {
      id: '/_authenticated/$orgId/reports/phone-clicks/'
      path: '/'
      fullPath: '/$orgId/reports/phone-clicks/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsPhoneClicksIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsPhoneClicksRoute
    }
    '/_authenticated/$orgId/reports/florist-performance/': {
      id: '/_authenticated/$orgId/reports/florist-performance/'
      path: '/reports/florist-performance'
      fullPath: '/$orgId/reports/florist-performance/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsFloristPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/deposits/': {
      id: '/_authenticated/$orgId/reports/deposits/'
      path: '/'
      fullPath: '/$orgId/reports/deposits/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsDepositsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsDepositsRoute
    }
    '/_authenticated/$orgId/reports/closed-days/': {
      id: '/_authenticated/$orgId/reports/closed-days/'
      path: '/'
      fullPath: '/$orgId/reports/closed-days/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsClosedDaysIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsClosedDaysRoute
    }
    '/_authenticated/$orgId/reports/cash-drawer/': {
      id: '/_authenticated/$orgId/reports/cash-drawer/'
      path: '/'
      fullPath: '/$orgId/reports/cash-drawer/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsCashDrawerIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsCashDrawerRoute
    }
    '/_authenticated/$orgId/reports/accounting-journal/': {
      id: '/_authenticated/$orgId/reports/accounting-journal/'
      path: '/'
      fullPath: '/$orgId/reports/accounting-journal/'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsAccountingJournalIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsAccountingJournalRoute
    }
    '/_authenticated/$orgId/products/price-changes/': {
      id: '/_authenticated/$orgId/products/price-changes/'
      path: '/products/price-changes'
      fullPath: '/$orgId/products/price-changes/'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsPriceChangesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/collections/': {
      id: '/_authenticated/$orgId/products/collections/'
      path: '/products/collections'
      fullPath: '/$orgId/products/collections/'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-ons/': {
      id: '/_authenticated/$orgId/products/add-ons/'
      path: '/products/add-ons'
      fullPath: '/$orgId/products/add-ons/'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-on-sets/': {
      id: '/_authenticated/$orgId/products/add-on-sets/'
      path: '/products/add-on-sets'
      fullPath: '/$orgId/products/add-on-sets/'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnSetsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/organizations/$organizationId/': {
      id: '/_authenticated/$orgId/organizations/$organizationId/'
      path: '/'
      fullPath: '/$orgId/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedOrgIdOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdOrganizationsOrganizationIdRoute
    }
    '/_authenticated/$orgId/money/statements/': {
      id: '/_authenticated/$orgId/money/statements/'
      path: '/statements'
      fullPath: '/$orgId/money/statements/'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyStatementsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/money/sales/': {
      id: '/_authenticated/$orgId/money/sales/'
      path: '/sales'
      fullPath: '/$orgId/money/sales/'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneySalesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/money/customer-balances/': {
      id: '/_authenticated/$orgId/money/customer-balances/'
      path: '/'
      fullPath: '/$orgId/money/customer-balances/'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneyCustomerBalancesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyCustomerBalancesRoute
    }
    '/_authenticated/$orgId/marketing/discounts/': {
      id: '/_authenticated/$orgId/marketing/discounts/'
      path: '/marketing/discounts'
      fullPath: '/$orgId/marketing/discounts/'
      preLoaderRoute: typeof AuthenticatedOrgIdMarketingDiscountsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/website/url-redirects/flower-shop-network': {
      id: '/_authenticated/$orgId/website/url-redirects/flower-shop-network'
      path: '/url-redirects/flower-shop-network'
      fullPath: '/$orgId/website/url-redirects/flower-shop-network'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/domains/create': {
      id: '/_authenticated/$orgId/website/domains/create'
      path: '/domains/create'
      fullPath: '/$orgId/website/domains/create'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteDomainsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/domains/$domainId': {
      id: '/_authenticated/$orgId/website/domains/$domainId'
      path: '/domains/$domainId'
      fullPath: '/$orgId/website/domains/$domainId'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteDomainsDomainIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/custom-pages/create': {
      id: '/_authenticated/$orgId/website/custom-pages/create'
      path: '/custom-pages/create'
      fullPath: '/$orgId/website/custom-pages/create'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/website/custom-pages/$customPageId': {
      id: '/_authenticated/$orgId/website/custom-pages/$customPageId'
      path: '/custom-pages/$customPageId'
      fullPath: '/$orgId/website/custom-pages/$customPageId'
      preLoaderRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdWebsiteRoute
    }
    '/_authenticated/$orgId/users/$userId/history': {
      id: '/_authenticated/$orgId/users/$userId/history'
      path: '/users/$userId/history'
      fullPath: '/$orgId/users/$userId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdUsersUserIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/terminals/create': {
      id: '/_authenticated/$orgId/settings/terminals/create'
      path: '/settings/terminals/create'
      fullPath: '/$orgId/settings/terminals/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsTerminalsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/terminals/$terminalId': {
      id: '/_authenticated/$orgId/settings/terminals/$terminalId'
      path: '/settings/terminals/$terminalId'
      fullPath: '/$orgId/settings/terminals/$terminalId'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsTerminalsTerminalIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/taxes/history': {
      id: '/_authenticated/$orgId/settings/taxes/history'
      path: '/settings/taxes/history'
      fullPath: '/$orgId/settings/taxes/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsTaxesHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/upgrade': {
      id: '/_authenticated/$orgId/settings/stripe/upgrade'
      path: '/settings/stripe/upgrade'
      fullPath: '/$orgId/settings/stripe/upgrade'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeUpgradeRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/payouts': {
      id: '/_authenticated/$orgId/settings/stripe/payouts'
      path: '/settings/stripe/payouts'
      fullPath: '/$orgId/settings/stripe/payouts'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripePayoutsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/payments': {
      id: '/_authenticated/$orgId/settings/stripe/payments'
      path: '/settings/stripe/payments'
      fullPath: '/$orgId/settings/stripe/payments'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripePaymentsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/payment-methods': {
      id: '/_authenticated/$orgId/settings/stripe/payment-methods'
      path: '/settings/stripe/payment-methods'
      fullPath: '/$orgId/settings/stripe/payment-methods'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripePaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/onboarding': {
      id: '/_authenticated/$orgId/settings/stripe/onboarding'
      path: '/settings/stripe/onboarding'
      fullPath: '/$orgId/settings/stripe/onboarding'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeOnboardingRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/disputes': {
      id: '/_authenticated/$orgId/settings/stripe/disputes'
      path: '/settings/stripe/disputes'
      fullPath: '/$orgId/settings/stripe/disputes'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeDisputesRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/card-readers': {
      id: '/_authenticated/$orgId/settings/stripe/card-readers'
      path: '/settings/stripe/card-readers'
      fullPath: '/$orgId/settings/stripe/card-readers'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeCardReadersRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/stripe/account-management': {
      id: '/_authenticated/$orgId/settings/stripe/account-management'
      path: '/settings/stripe/account-management'
      fullPath: '/$orgId/settings/stripe/account-management'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsStripeAccountManagementRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/notifications/create': {
      id: '/_authenticated/$orgId/settings/notifications/create'
      path: '/settings/notifications/create'
      fullPath: '/$orgId/settings/notifications/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsNotificationsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/notifications/$recipientId': {
      id: '/_authenticated/$orgId/settings/notifications/$recipientId'
      path: '/settings/notifications/$recipientId'
      fullPath: '/$orgId/settings/notifications/$recipientId'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsNotificationsRecipientIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/locations/create': {
      id: '/_authenticated/$orgId/settings/locations/create'
      path: '/settings/locations/create'
      fullPath: '/$orgId/settings/locations/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/locations/$locationId': {
      id: '/_authenticated/$orgId/settings/locations/$locationId'
      path: '/settings/locations/$locationId'
      fullPath: '/$orgId/settings/locations/$locationId'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/fees/history': {
      id: '/_authenticated/$orgId/settings/fees/history'
      path: '/settings/fees/history'
      fullPath: '/$orgId/settings/fees/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsFeesHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/domains/create': {
      id: '/_authenticated/$orgId/settings/domains/create'
      path: '/settings/domains/create'
      fullPath: '/$orgId/settings/domains/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsDomainsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/domains/$domainId': {
      id: '/_authenticated/$orgId/settings/domains/$domainId'
      path: '/settings/domains/$domainId'
      fullPath: '/$orgId/settings/domains/$domainId'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsDomainsDomainIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/cash-drawer/history': {
      id: '/_authenticated/$orgId/settings/cash-drawer/history'
      path: '/settings/cash-drawer/history'
      fullPath: '/$orgId/settings/cash-drawer/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsCashDrawerHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/billing/history': {
      id: '/_authenticated/$orgId/settings/billing/history'
      path: '/settings/billing/history'
      fullPath: '/$orgId/settings/billing/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsBillingHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/delivery-routes/create': {
      id: '/_authenticated/$orgId/sales-orders/delivery-routes/create'
      path: '/sales-orders/delivery-routes/create'
      fullPath: '/$orgId/sales-orders/delivery-routes/create'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId': {
      id: '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId'
      path: '/sales-orders/delivery-routes/$deliveryShareId'
      fullPath: '/$orgId/sales-orders/delivery-routes/$deliveryShareId'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/$salesOrderId_/journal': {
      id: '/_authenticated/$orgId/sales-orders/$salesOrderId_/journal'
      path: '/sales-orders/$salesOrderId/journal'
      fullPath: '/$orgId/sales-orders/$salesOrderId/journal'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/$salesOrderId_/history': {
      id: '/_authenticated/$orgId/sales-orders/$salesOrderId_/history'
      path: '/sales-orders/$salesOrderId/history'
      fullPath: '/$orgId/sales-orders/$salesOrderId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/sales-orders/$salesOrderId_/edit': {
      id: '/_authenticated/$orgId/sales-orders/$salesOrderId_/edit'
      path: '/sales-orders/$salesOrderId/edit'
      fullPath: '/$orgId/sales-orders/$salesOrderId/edit'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales/$date': {
      id: '/_authenticated/$orgId/reports/sales/$date'
      path: '/reports/sales/$date'
      fullPath: '/$orgId/reports/sales/$date'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesDateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/sales-summary/$date': {
      id: '/_authenticated/$orgId/reports/sales-summary/$date'
      path: '/reports/sales-summary/$date'
      fullPath: '/$orgId/reports/sales-summary/$date'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsSalesSummaryDateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/reports/deposits/$depositId': {
      id: '/_authenticated/$orgId/reports/deposits/$depositId'
      path: '/$depositId'
      fullPath: '/$orgId/reports/deposits/$depositId'
      preLoaderRoute: typeof AuthenticatedOrgIdReportsDepositsDepositIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdReportsDepositsRoute
    }
    '/_authenticated/$orgId/products/price-changes/create': {
      id: '/_authenticated/$orgId/products/price-changes/create'
      path: '/products/price-changes/create'
      fullPath: '/$orgId/products/price-changes/create'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsPriceChangesCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/price-changes/$priceAdjustmentId': {
      id: '/_authenticated/$orgId/products/price-changes/$priceAdjustmentId'
      path: '/products/price-changes/$priceAdjustmentId'
      fullPath: '/$orgId/products/price-changes/$priceAdjustmentId'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/collections/import': {
      id: '/_authenticated/$orgId/products/collections/import'
      path: '/products/collections/import'
      fullPath: '/$orgId/products/collections/import'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCollectionsImportRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/collections/create': {
      id: '/_authenticated/$orgId/products/collections/create'
      path: '/products/collections/create'
      fullPath: '/$orgId/products/collections/create'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCollectionsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/collections/$collectionId': {
      id: '/_authenticated/$orgId/products/collections/$collectionId'
      path: '/products/collections/$collectionId'
      fullPath: '/$orgId/products/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsCollectionsCollectionIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-ons/create': {
      id: '/_authenticated/$orgId/products/add-ons/create'
      path: '/products/add-ons/create'
      fullPath: '/$orgId/products/add-ons/create'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-ons/$addOnId': {
      id: '/_authenticated/$orgId/products/add-ons/$addOnId'
      path: '/products/add-ons/$addOnId'
      fullPath: '/$orgId/products/add-ons/$addOnId'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnsAddOnIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-on-sets/create': {
      id: '/_authenticated/$orgId/products/add-on-sets/create'
      path: '/products/add-on-sets/create'
      fullPath: '/$orgId/products/add-on-sets/create'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnSetsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/add-on-sets/$addOnSetId': {
      id: '/_authenticated/$orgId/products/add-on-sets/$addOnSetId'
      path: '/products/add-on-sets/$addOnSetId'
      fullPath: '/$orgId/products/add-on-sets/$addOnSetId'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/products/$productId_/history': {
      id: '/_authenticated/$orgId/products/$productId_/history'
      path: '/products/$productId/history'
      fullPath: '/$orgId/products/$productId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdProductsProductIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/money/sales/$date': {
      id: '/_authenticated/$orgId/money/sales/$date'
      path: '/sales/$date'
      fullPath: '/$orgId/money/sales/$date'
      preLoaderRoute: typeof AuthenticatedOrgIdMoneySalesDateRouteImport
      parentRoute: typeof AuthenticatedOrgIdMoneyRoute
    }
    '/_authenticated/$orgId/gallery/album/create': {
      id: '/_authenticated/$orgId/gallery/album/create'
      path: '/gallery/album/create'
      fullPath: '/$orgId/gallery/album/create'
      preLoaderRoute: typeof AuthenticatedOrgIdGalleryAlbumCreateRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/gallery/album/$albumId': {
      id: '/_authenticated/$orgId/gallery/album/$albumId'
      path: '/gallery/album/$albumId'
      fullPath: '/$orgId/gallery/album/$albumId'
      preLoaderRoute: typeof AuthenticatedOrgIdGalleryAlbumAlbumIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/designs/$designId_/history': {
      id: '/_authenticated/$orgId/designs/$designId_/history'
      path: '/designs/$designId/history'
      fullPath: '/$orgId/designs/$designId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdDesignsDesignIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/customers/$customerId_/history': {
      id: '/_authenticated/$orgId/customers/$customerId_/history'
      path: '/customers/$customerId/history'
      fullPath: '/$orgId/customers/$customerId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdCustomersCustomerIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/locations/$locationId/': {
      id: '/_authenticated/$orgId/settings/locations/$locationId/'
      path: '/'
      fullPath: '/$orgId/settings/locations/$locationId/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRoute
    }
    '/_authenticated/$orgId/settings/integrations/snapdragon/': {
      id: '/_authenticated/$orgId/settings/integrations/snapdragon/'
      path: '/snapdragon'
      fullPath: '/$orgId/settings/integrations/snapdragon/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/integrations/meta-pixel/': {
      id: '/_authenticated/$orgId/settings/integrations/meta-pixel/'
      path: '/meta-pixel'
      fullPath: '/$orgId/settings/integrations/meta-pixel/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/integrations/google-tag-manager/': {
      id: '/_authenticated/$orgId/settings/integrations/google-tag-manager/'
      path: '/google-tag-manager'
      fullPath: '/$orgId/settings/integrations/google-tag-manager/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/integrations/google-analytics/': {
      id: '/_authenticated/$orgId/settings/integrations/google-analytics/'
      path: '/google-analytics'
      fullPath: '/$orgId/settings/integrations/google-analytics/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/integrations/fsn-network/': {
      id: '/_authenticated/$orgId/settings/integrations/fsn-network/'
      path: '/fsn-network'
      fullPath: '/$orgId/settings/integrations/fsn-network/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/settings/integrations/condolences/': {
      id: '/_authenticated/$orgId/settings/integrations/condolences/'
      path: '/condolences'
      fullPath: '/$orgId/settings/integrations/condolences/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/users/$userId/roles/$roleId': {
      id: '/_authenticated/$orgId/users/$userId/roles/$roleId'
      path: '/users/$userId/roles/$roleId'
      fullPath: '/$orgId/users/$userId/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedOrgIdUsersUserIdRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/locations/$locationId/history': {
      id: '/_authenticated/$orgId/settings/locations/$locationId/history'
      path: '/history'
      fullPath: '/$orgId/settings/locations/$locationId/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRoute
    }
    '/_authenticated/$orgId/settings/integrations/snapdragon/history': {
      id: '/_authenticated/$orgId/settings/integrations/snapdragon/history'
      path: '/snapdragon/history'
      fullPath: '/$orgId/settings/integrations/snapdragon/history'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
    }
    '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit': {
      id: '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
      path: '/edit'
      fullPath: '/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
      preLoaderRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRouteImport
      parentRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute
    }
    '/_authenticated/$orgId/settings/locations/$locationId/hours/': {
      id: '/_authenticated/$orgId/settings/locations/$locationId/hours/'
      path: '/hours'
      fullPath: '/$orgId/settings/locations/$locationId/hours/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRoute
    }
    '/_authenticated/$orgId/settings/locations/$locationId/deliveries/': {
      id: '/_authenticated/$orgId/settings/locations/$locationId/deliveries/'
      path: '/deliveries'
      fullPath: '/$orgId/settings/locations/$locationId/deliveries/'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRoute
    }
  }
}

interface AuthenticatedOrgIdImportsRouteChildren {
  AuthenticatedOrgIdImportsCustomerImportRoute: typeof AuthenticatedOrgIdImportsCustomerImportRoute
  AuthenticatedOrgIdImportsFsnImportRoute: typeof AuthenticatedOrgIdImportsFsnImportRoute
  AuthenticatedOrgIdImportsProductImportRoute: typeof AuthenticatedOrgIdImportsProductImportRoute
  AuthenticatedOrgIdImportsIndexRoute: typeof AuthenticatedOrgIdImportsIndexRoute
}

const AuthenticatedOrgIdImportsRouteChildren: AuthenticatedOrgIdImportsRouteChildren =
  {
    AuthenticatedOrgIdImportsCustomerImportRoute:
      AuthenticatedOrgIdImportsCustomerImportRoute,
    AuthenticatedOrgIdImportsFsnImportRoute:
      AuthenticatedOrgIdImportsFsnImportRoute,
    AuthenticatedOrgIdImportsProductImportRoute:
      AuthenticatedOrgIdImportsProductImportRoute,
    AuthenticatedOrgIdImportsIndexRoute: AuthenticatedOrgIdImportsIndexRoute,
  }

const AuthenticatedOrgIdImportsRouteWithChildren =
  AuthenticatedOrgIdImportsRoute._addFileChildren(
    AuthenticatedOrgIdImportsRouteChildren,
  )

interface AuthenticatedOrgIdMoneyCustomerBalancesRouteChildren {
  AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute: typeof AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute
}

const AuthenticatedOrgIdMoneyCustomerBalancesRouteChildren: AuthenticatedOrgIdMoneyCustomerBalancesRouteChildren =
  {
    AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute:
      AuthenticatedOrgIdMoneyCustomerBalancesIndexRoute,
  }

const AuthenticatedOrgIdMoneyCustomerBalancesRouteWithChildren =
  AuthenticatedOrgIdMoneyCustomerBalancesRoute._addFileChildren(
    AuthenticatedOrgIdMoneyCustomerBalancesRouteChildren,
  )

interface AuthenticatedOrgIdMoneyRouteChildren {
  AuthenticatedOrgIdMoneyCashDrawerBalancingRoute: typeof AuthenticatedOrgIdMoneyCashDrawerBalancingRoute
  AuthenticatedOrgIdMoneyCustomerBalancesRoute: typeof AuthenticatedOrgIdMoneyCustomerBalancesRouteWithChildren
  AuthenticatedOrgIdMoneyIndexRoute: typeof AuthenticatedOrgIdMoneyIndexRoute
  AuthenticatedOrgIdMoneySalesDateRoute: typeof AuthenticatedOrgIdMoneySalesDateRoute
  AuthenticatedOrgIdMoneySalesIndexRoute: typeof AuthenticatedOrgIdMoneySalesIndexRoute
  AuthenticatedOrgIdMoneyStatementsIndexRoute: typeof AuthenticatedOrgIdMoneyStatementsIndexRoute
}

const AuthenticatedOrgIdMoneyRouteChildren: AuthenticatedOrgIdMoneyRouteChildren =
  {
    AuthenticatedOrgIdMoneyCashDrawerBalancingRoute:
      AuthenticatedOrgIdMoneyCashDrawerBalancingRoute,
    AuthenticatedOrgIdMoneyCustomerBalancesRoute:
      AuthenticatedOrgIdMoneyCustomerBalancesRouteWithChildren,
    AuthenticatedOrgIdMoneyIndexRoute: AuthenticatedOrgIdMoneyIndexRoute,
    AuthenticatedOrgIdMoneySalesDateRoute:
      AuthenticatedOrgIdMoneySalesDateRoute,
    AuthenticatedOrgIdMoneySalesIndexRoute:
      AuthenticatedOrgIdMoneySalesIndexRoute,
    AuthenticatedOrgIdMoneyStatementsIndexRoute:
      AuthenticatedOrgIdMoneyStatementsIndexRoute,
  }

const AuthenticatedOrgIdMoneyRouteWithChildren =
  AuthenticatedOrgIdMoneyRoute._addFileChildren(
    AuthenticatedOrgIdMoneyRouteChildren,
  )

interface AuthenticatedOrgIdWebsiteRouteChildren {
  AuthenticatedOrgIdWebsiteBuilderRoute: typeof AuthenticatedOrgIdWebsiteBuilderRoute
  AuthenticatedOrgIdWebsiteDomainLaunchRoute: typeof AuthenticatedOrgIdWebsiteDomainLaunchRoute
  AuthenticatedOrgIdWebsiteOverviewRoute: typeof AuthenticatedOrgIdWebsiteOverviewRoute
  AuthenticatedOrgIdWebsiteIndexRoute: typeof AuthenticatedOrgIdWebsiteIndexRoute
  AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute
  AuthenticatedOrgIdWebsiteCustomPagesCreateRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesCreateRoute
  AuthenticatedOrgIdWebsiteDomainsDomainIdRoute: typeof AuthenticatedOrgIdWebsiteDomainsDomainIdRoute
  AuthenticatedOrgIdWebsiteDomainsCreateRoute: typeof AuthenticatedOrgIdWebsiteDomainsCreateRoute
  AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute: typeof AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute
  AuthenticatedOrgIdWebsiteCustomPagesIndexRoute: typeof AuthenticatedOrgIdWebsiteCustomPagesIndexRoute
  AuthenticatedOrgIdWebsiteDomainsIndexRoute: typeof AuthenticatedOrgIdWebsiteDomainsIndexRoute
  AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute: typeof AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute
}

const AuthenticatedOrgIdWebsiteRouteChildren: AuthenticatedOrgIdWebsiteRouteChildren =
  {
    AuthenticatedOrgIdWebsiteBuilderRoute:
      AuthenticatedOrgIdWebsiteBuilderRoute,
    AuthenticatedOrgIdWebsiteDomainLaunchRoute:
      AuthenticatedOrgIdWebsiteDomainLaunchRoute,
    AuthenticatedOrgIdWebsiteOverviewRoute:
      AuthenticatedOrgIdWebsiteOverviewRoute,
    AuthenticatedOrgIdWebsiteIndexRoute: AuthenticatedOrgIdWebsiteIndexRoute,
    AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute:
      AuthenticatedOrgIdWebsiteCustomPagesCustomPageIdRoute,
    AuthenticatedOrgIdWebsiteCustomPagesCreateRoute:
      AuthenticatedOrgIdWebsiteCustomPagesCreateRoute,
    AuthenticatedOrgIdWebsiteDomainsDomainIdRoute:
      AuthenticatedOrgIdWebsiteDomainsDomainIdRoute,
    AuthenticatedOrgIdWebsiteDomainsCreateRoute:
      AuthenticatedOrgIdWebsiteDomainsCreateRoute,
    AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute:
      AuthenticatedOrgIdWebsiteUrlRedirectsFlowerShopNetworkRoute,
    AuthenticatedOrgIdWebsiteCustomPagesIndexRoute:
      AuthenticatedOrgIdWebsiteCustomPagesIndexRoute,
    AuthenticatedOrgIdWebsiteDomainsIndexRoute:
      AuthenticatedOrgIdWebsiteDomainsIndexRoute,
    AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute:
      AuthenticatedOrgIdWebsiteUrlRedirectsIndexRoute,
  }

const AuthenticatedOrgIdWebsiteRouteWithChildren =
  AuthenticatedOrgIdWebsiteRoute._addFileChildren(
    AuthenticatedOrgIdWebsiteRouteChildren,
  )

interface AuthenticatedOrgIdOrganizationsOrganizationIdRouteChildren {
  AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute
}

const AuthenticatedOrgIdOrganizationsOrganizationIdRouteChildren: AuthenticatedOrgIdOrganizationsOrganizationIdRouteChildren =
  {
    AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute:
      AuthenticatedOrgIdOrganizationsOrganizationIdIndexRoute,
  }

const AuthenticatedOrgIdOrganizationsOrganizationIdRouteWithChildren =
  AuthenticatedOrgIdOrganizationsOrganizationIdRoute._addFileChildren(
    AuthenticatedOrgIdOrganizationsOrganizationIdRouteChildren,
  )

interface AuthenticatedOrgIdReportsAccountingJournalRouteChildren {
  AuthenticatedOrgIdReportsAccountingJournalIndexRoute: typeof AuthenticatedOrgIdReportsAccountingJournalIndexRoute
}

const AuthenticatedOrgIdReportsAccountingJournalRouteChildren: AuthenticatedOrgIdReportsAccountingJournalRouteChildren =
  {
    AuthenticatedOrgIdReportsAccountingJournalIndexRoute:
      AuthenticatedOrgIdReportsAccountingJournalIndexRoute,
  }

const AuthenticatedOrgIdReportsAccountingJournalRouteWithChildren =
  AuthenticatedOrgIdReportsAccountingJournalRoute._addFileChildren(
    AuthenticatedOrgIdReportsAccountingJournalRouteChildren,
  )

interface AuthenticatedOrgIdReportsCashDrawerRouteChildren {
  AuthenticatedOrgIdReportsCashDrawerIndexRoute: typeof AuthenticatedOrgIdReportsCashDrawerIndexRoute
}

const AuthenticatedOrgIdReportsCashDrawerRouteChildren: AuthenticatedOrgIdReportsCashDrawerRouteChildren =
  {
    AuthenticatedOrgIdReportsCashDrawerIndexRoute:
      AuthenticatedOrgIdReportsCashDrawerIndexRoute,
  }

const AuthenticatedOrgIdReportsCashDrawerRouteWithChildren =
  AuthenticatedOrgIdReportsCashDrawerRoute._addFileChildren(
    AuthenticatedOrgIdReportsCashDrawerRouteChildren,
  )

interface AuthenticatedOrgIdReportsClosedDaysRouteChildren {
  AuthenticatedOrgIdReportsClosedDaysIndexRoute: typeof AuthenticatedOrgIdReportsClosedDaysIndexRoute
}

const AuthenticatedOrgIdReportsClosedDaysRouteChildren: AuthenticatedOrgIdReportsClosedDaysRouteChildren =
  {
    AuthenticatedOrgIdReportsClosedDaysIndexRoute:
      AuthenticatedOrgIdReportsClosedDaysIndexRoute,
  }

const AuthenticatedOrgIdReportsClosedDaysRouteWithChildren =
  AuthenticatedOrgIdReportsClosedDaysRoute._addFileChildren(
    AuthenticatedOrgIdReportsClosedDaysRouteChildren,
  )

interface AuthenticatedOrgIdReportsDepositsRouteChildren {
  AuthenticatedOrgIdReportsDepositsDepositIdRoute: typeof AuthenticatedOrgIdReportsDepositsDepositIdRoute
  AuthenticatedOrgIdReportsDepositsIndexRoute: typeof AuthenticatedOrgIdReportsDepositsIndexRoute
}

const AuthenticatedOrgIdReportsDepositsRouteChildren: AuthenticatedOrgIdReportsDepositsRouteChildren =
  {
    AuthenticatedOrgIdReportsDepositsDepositIdRoute:
      AuthenticatedOrgIdReportsDepositsDepositIdRoute,
    AuthenticatedOrgIdReportsDepositsIndexRoute:
      AuthenticatedOrgIdReportsDepositsIndexRoute,
  }

const AuthenticatedOrgIdReportsDepositsRouteWithChildren =
  AuthenticatedOrgIdReportsDepositsRoute._addFileChildren(
    AuthenticatedOrgIdReportsDepositsRouteChildren,
  )

interface AuthenticatedOrgIdReportsPhoneClicksRouteChildren {
  AuthenticatedOrgIdReportsPhoneClicksIndexRoute: typeof AuthenticatedOrgIdReportsPhoneClicksIndexRoute
}

const AuthenticatedOrgIdReportsPhoneClicksRouteChildren: AuthenticatedOrgIdReportsPhoneClicksRouteChildren =
  {
    AuthenticatedOrgIdReportsPhoneClicksIndexRoute:
      AuthenticatedOrgIdReportsPhoneClicksIndexRoute,
  }

const AuthenticatedOrgIdReportsPhoneClicksRouteWithChildren =
  AuthenticatedOrgIdReportsPhoneClicksRoute._addFileChildren(
    AuthenticatedOrgIdReportsPhoneClicksRouteChildren,
  )

interface AuthenticatedOrgIdReportsPlatformLedgerRouteChildren {
  AuthenticatedOrgIdReportsPlatformLedgerIndexRoute: typeof AuthenticatedOrgIdReportsPlatformLedgerIndexRoute
}

const AuthenticatedOrgIdReportsPlatformLedgerRouteChildren: AuthenticatedOrgIdReportsPlatformLedgerRouteChildren =
  {
    AuthenticatedOrgIdReportsPlatformLedgerIndexRoute:
      AuthenticatedOrgIdReportsPlatformLedgerIndexRoute,
  }

const AuthenticatedOrgIdReportsPlatformLedgerRouteWithChildren =
  AuthenticatedOrgIdReportsPlatformLedgerRoute._addFileChildren(
    AuthenticatedOrgIdReportsPlatformLedgerRouteChildren,
  )

interface AuthenticatedOrgIdReportsSalesStatisticsRouteChildren {
  AuthenticatedOrgIdReportsSalesStatisticsIndexRoute: typeof AuthenticatedOrgIdReportsSalesStatisticsIndexRoute
}

const AuthenticatedOrgIdReportsSalesStatisticsRouteChildren: AuthenticatedOrgIdReportsSalesStatisticsRouteChildren =
  {
    AuthenticatedOrgIdReportsSalesStatisticsIndexRoute:
      AuthenticatedOrgIdReportsSalesStatisticsIndexRoute,
  }

const AuthenticatedOrgIdReportsSalesStatisticsRouteWithChildren =
  AuthenticatedOrgIdReportsSalesStatisticsRoute._addFileChildren(
    AuthenticatedOrgIdReportsSalesStatisticsRouteChildren,
  )

interface AuthenticatedOrgIdReportsSalesTaxRouteChildren {
  AuthenticatedOrgIdReportsSalesTaxIndexRoute: typeof AuthenticatedOrgIdReportsSalesTaxIndexRoute
}

const AuthenticatedOrgIdReportsSalesTaxRouteChildren: AuthenticatedOrgIdReportsSalesTaxRouteChildren =
  {
    AuthenticatedOrgIdReportsSalesTaxIndexRoute:
      AuthenticatedOrgIdReportsSalesTaxIndexRoute,
  }

const AuthenticatedOrgIdReportsSalesTaxRouteWithChildren =
  AuthenticatedOrgIdReportsSalesTaxRoute._addFileChildren(
    AuthenticatedOrgIdReportsSalesTaxRouteChildren,
  )

interface AuthenticatedOrgIdSettingsIntegrationsRouteChildren {
  AuthenticatedOrgIdSettingsIntegrationsIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute: typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute
  AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute
  AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute: typeof AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute
}

const AuthenticatedOrgIdSettingsIntegrationsRouteChildren: AuthenticatedOrgIdSettingsIntegrationsRouteChildren =
  {
    AuthenticatedOrgIdSettingsIntegrationsIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute:
      AuthenticatedOrgIdSettingsIntegrationsSnapdragonHistoryRoute,
    AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsCondolencesIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsFsnNetworkIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsGoogleAnalyticsIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsGoogleTagManagerIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsMetaPixelIndexRoute,
    AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute:
      AuthenticatedOrgIdSettingsIntegrationsSnapdragonIndexRoute,
  }

const AuthenticatedOrgIdSettingsIntegrationsRouteWithChildren =
  AuthenticatedOrgIdSettingsIntegrationsRoute._addFileChildren(
    AuthenticatedOrgIdSettingsIntegrationsRouteChildren,
  )

interface AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteChildren {
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute
}

const AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteChildren: AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteChildren =
  {
    AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute:
      AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdEditRoute,
  }

const AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren =
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute._addFileChildren(
    AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteChildren,
  )

interface AuthenticatedOrgIdSettingsLocationsLocationIdRouteChildren {
  AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute
  AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute
  AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute
  AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute
}

const AuthenticatedOrgIdSettingsLocationsLocationIdRouteChildren: AuthenticatedOrgIdSettingsLocationsLocationIdRouteChildren =
  {
    AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute:
      AuthenticatedOrgIdSettingsLocationsLocationIdHistoryRoute,
    AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute:
      AuthenticatedOrgIdSettingsLocationsLocationIdIndexRoute,
    AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute:
      AuthenticatedOrgIdSettingsLocationsLocationIdDeliveriesIndexRoute,
    AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute:
      AuthenticatedOrgIdSettingsLocationsLocationIdHoursIndexRoute,
  }

const AuthenticatedOrgIdSettingsLocationsLocationIdRouteWithChildren =
  AuthenticatedOrgIdSettingsLocationsLocationIdRoute._addFileChildren(
    AuthenticatedOrgIdSettingsLocationsLocationIdRouteChildren,
  )

interface AuthenticatedOrgIdRouteChildren {
  AuthenticatedOrgIdActivityRoute: typeof AuthenticatedOrgIdActivityRoute
  AuthenticatedOrgIdAdminRoute: typeof AuthenticatedOrgIdAdminRoute
  AuthenticatedOrgIdImportsRoute: typeof AuthenticatedOrgIdImportsRouteWithChildren
  AuthenticatedOrgIdMoneyRoute: typeof AuthenticatedOrgIdMoneyRouteWithChildren
  AuthenticatedOrgIdNoticationsCenterRoute: typeof AuthenticatedOrgIdNoticationsCenterRoute
  AuthenticatedOrgIdWebsiteRoute: typeof AuthenticatedOrgIdWebsiteRouteWithChildren
  AuthenticatedOrgIdContractsCreateRoute: typeof AuthenticatedOrgIdContractsCreateRoute
  AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute: typeof AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute
  AuthenticatedOrgIdCustomersCustomerIdRoute: typeof AuthenticatedOrgIdCustomersCustomerIdRoute
  AuthenticatedOrgIdCustomersCreateRoute: typeof AuthenticatedOrgIdCustomersCreateRoute
  AuthenticatedOrgIdDesignsDesignIdRoute: typeof AuthenticatedOrgIdDesignsDesignIdRoute
  AuthenticatedOrgIdDesignsCreateRoute: typeof AuthenticatedOrgIdDesignsCreateRoute
  AuthenticatedOrgIdMessagesMessageIdRoute: typeof AuthenticatedOrgIdMessagesMessageIdRoute
  AuthenticatedOrgIdMessagesCreateRoute: typeof AuthenticatedOrgIdMessagesCreateRoute
  AuthenticatedOrgIdOrganizationsOrganizationIdRoute: typeof AuthenticatedOrgIdOrganizationsOrganizationIdRouteWithChildren
  AuthenticatedOrgIdOrganizationsCreateRoute: typeof AuthenticatedOrgIdOrganizationsCreateRoute
  AuthenticatedOrgIdPricingCreateRoute: typeof AuthenticatedOrgIdPricingCreateRoute
  AuthenticatedOrgIdProductsProductIdRoute: typeof AuthenticatedOrgIdProductsProductIdRoute
  AuthenticatedOrgIdProductsAllProductsRoute: typeof AuthenticatedOrgIdProductsAllProductsRoute
  AuthenticatedOrgIdProductsCatalogBuilderRoute: typeof AuthenticatedOrgIdProductsCatalogBuilderRoute
  AuthenticatedOrgIdProductsCreateRoute: typeof AuthenticatedOrgIdProductsCreateRoute
  AuthenticatedOrgIdProductsInventoryRoute: typeof AuthenticatedOrgIdProductsInventoryRoute
  AuthenticatedOrgIdReportsAccountingJournalRoute: typeof AuthenticatedOrgIdReportsAccountingJournalRouteWithChildren
  AuthenticatedOrgIdReportsCashDrawerRoute: typeof AuthenticatedOrgIdReportsCashDrawerRouteWithChildren
  AuthenticatedOrgIdReportsClosedDaysRoute: typeof AuthenticatedOrgIdReportsClosedDaysRouteWithChildren
  AuthenticatedOrgIdReportsCustomerBalancesRoute: typeof AuthenticatedOrgIdReportsCustomerBalancesRoute
  AuthenticatedOrgIdReportsDepositsRoute: typeof AuthenticatedOrgIdReportsDepositsRouteWithChildren
  AuthenticatedOrgIdReportsExternalOrdersRoute: typeof AuthenticatedOrgIdReportsExternalOrdersRoute
  AuthenticatedOrgIdReportsPhoneClicksRoute: typeof AuthenticatedOrgIdReportsPhoneClicksRouteWithChildren
  AuthenticatedOrgIdReportsPlatformLedgerRoute: typeof AuthenticatedOrgIdReportsPlatformLedgerRouteWithChildren
  AuthenticatedOrgIdReportsSalesStatisticsRoute: typeof AuthenticatedOrgIdReportsSalesStatisticsRouteWithChildren
  AuthenticatedOrgIdReportsSalesTaxRoute: typeof AuthenticatedOrgIdReportsSalesTaxRouteWithChildren
  AuthenticatedOrgIdReportsWiredOrdersRoute: typeof AuthenticatedOrgIdReportsWiredOrdersRoute
  AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute
  AuthenticatedOrgIdSalesOrdersCreateRoute: typeof AuthenticatedOrgIdSalesOrdersCreateRoute
  AuthenticatedOrgIdSalesOrdersDraftsRoute: typeof AuthenticatedOrgIdSalesOrdersDraftsRoute
  AuthenticatedOrgIdSalesOrdersWireInRoute: typeof AuthenticatedOrgIdSalesOrdersWireInRoute
  AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute: typeof AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute
  AuthenticatedOrgIdSeasonalContentCreateRoute: typeof AuthenticatedOrgIdSeasonalContentCreateRoute
  AuthenticatedOrgIdSettingsIntegrationsRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRouteWithChildren
  AuthenticatedOrgIdStockImagesStockImageIdRoute: typeof AuthenticatedOrgIdStockImagesStockImageIdRoute
  AuthenticatedOrgIdStockImagesCreateRoute: typeof AuthenticatedOrgIdStockImagesCreateRoute
  AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute: typeof AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute
  AuthenticatedOrgIdUsersCreateRoute: typeof AuthenticatedOrgIdUsersCreateRoute
  AuthenticatedOrgIdWhatsNewAppUpdateIdRoute: typeof AuthenticatedOrgIdWhatsNewAppUpdateIdRoute
  AuthenticatedOrgIdWhatsNewCreateRoute: typeof AuthenticatedOrgIdWhatsNewCreateRoute
  AuthenticatedOrgIdApiTokensIndexRoute: typeof AuthenticatedOrgIdApiTokensIndexRoute
  AuthenticatedOrgIdAvailabilityIndexRoute: typeof AuthenticatedOrgIdAvailabilityIndexRoute
  AuthenticatedOrgIdContractsIndexRoute: typeof AuthenticatedOrgIdContractsIndexRoute
  AuthenticatedOrgIdCustomerReviewsIndexRoute: typeof AuthenticatedOrgIdCustomerReviewsIndexRoute
  AuthenticatedOrgIdCustomersIndexRoute: typeof AuthenticatedOrgIdCustomersIndexRoute
  AuthenticatedOrgIdDesignsIndexRoute: typeof AuthenticatedOrgIdDesignsIndexRoute
  AuthenticatedOrgIdMarketingIndexRoute: typeof AuthenticatedOrgIdMarketingIndexRoute
  AuthenticatedOrgIdMessagesIndexRoute: typeof AuthenticatedOrgIdMessagesIndexRoute
  AuthenticatedOrgIdOrganizationsIndexRoute: typeof AuthenticatedOrgIdOrganizationsIndexRoute
  AuthenticatedOrgIdPricingIndexRoute: typeof AuthenticatedOrgIdPricingIndexRoute
  AuthenticatedOrgIdProductsIndexRoute: typeof AuthenticatedOrgIdProductsIndexRoute
  AuthenticatedOrgIdReportsIndexRoute: typeof AuthenticatedOrgIdReportsIndexRoute
  AuthenticatedOrgIdSalesOrdersIndexRoute: typeof AuthenticatedOrgIdSalesOrdersIndexRoute
  AuthenticatedOrgIdSeasonalContentIndexRoute: typeof AuthenticatedOrgIdSeasonalContentIndexRoute
  AuthenticatedOrgIdSettingsIndexRoute: typeof AuthenticatedOrgIdSettingsIndexRoute
  AuthenticatedOrgIdStockImagesIndexRoute: typeof AuthenticatedOrgIdStockImagesIndexRoute
  AuthenticatedOrgIdSubscriptionsIndexRoute: typeof AuthenticatedOrgIdSubscriptionsIndexRoute
  AuthenticatedOrgIdUsersIndexRoute: typeof AuthenticatedOrgIdUsersIndexRoute
  AuthenticatedOrgIdWhatsNewIndexRoute: typeof AuthenticatedOrgIdWhatsNewIndexRoute
  AuthenticatedOrgIdCustomersCustomerIdHistoryRoute: typeof AuthenticatedOrgIdCustomersCustomerIdHistoryRoute
  AuthenticatedOrgIdDesignsDesignIdHistoryRoute: typeof AuthenticatedOrgIdDesignsDesignIdHistoryRoute
  AuthenticatedOrgIdGalleryAlbumAlbumIdRoute: typeof AuthenticatedOrgIdGalleryAlbumAlbumIdRoute
  AuthenticatedOrgIdGalleryAlbumCreateRoute: typeof AuthenticatedOrgIdGalleryAlbumCreateRoute
  AuthenticatedOrgIdProductsProductIdHistoryRoute: typeof AuthenticatedOrgIdProductsProductIdHistoryRoute
  AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute: typeof AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute
  AuthenticatedOrgIdProductsAddOnSetsCreateRoute: typeof AuthenticatedOrgIdProductsAddOnSetsCreateRoute
  AuthenticatedOrgIdProductsAddOnsAddOnIdRoute: typeof AuthenticatedOrgIdProductsAddOnsAddOnIdRoute
  AuthenticatedOrgIdProductsAddOnsCreateRoute: typeof AuthenticatedOrgIdProductsAddOnsCreateRoute
  AuthenticatedOrgIdProductsCollectionsCollectionIdRoute: typeof AuthenticatedOrgIdProductsCollectionsCollectionIdRoute
  AuthenticatedOrgIdProductsCollectionsCreateRoute: typeof AuthenticatedOrgIdProductsCollectionsCreateRoute
  AuthenticatedOrgIdProductsCollectionsImportRoute: typeof AuthenticatedOrgIdProductsCollectionsImportRoute
  AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute: typeof AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute
  AuthenticatedOrgIdProductsPriceChangesCreateRoute: typeof AuthenticatedOrgIdProductsPriceChangesCreateRoute
  AuthenticatedOrgIdReportsSalesSummaryDateRoute: typeof AuthenticatedOrgIdReportsSalesSummaryDateRoute
  AuthenticatedOrgIdReportsSalesDateRoute: typeof AuthenticatedOrgIdReportsSalesDateRoute
  AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute
  AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute
  AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute: typeof AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute
  AuthenticatedOrgIdSettingsBillingHistoryRoute: typeof AuthenticatedOrgIdSettingsBillingHistoryRoute
  AuthenticatedOrgIdSettingsCashDrawerHistoryRoute: typeof AuthenticatedOrgIdSettingsCashDrawerHistoryRoute
  AuthenticatedOrgIdSettingsDomainsDomainIdRoute: typeof AuthenticatedOrgIdSettingsDomainsDomainIdRoute
  AuthenticatedOrgIdSettingsDomainsCreateRoute: typeof AuthenticatedOrgIdSettingsDomainsCreateRoute
  AuthenticatedOrgIdSettingsFeesHistoryRoute: typeof AuthenticatedOrgIdSettingsFeesHistoryRoute
  AuthenticatedOrgIdSettingsLocationsLocationIdRoute: typeof AuthenticatedOrgIdSettingsLocationsLocationIdRouteWithChildren
  AuthenticatedOrgIdSettingsLocationsCreateRoute: typeof AuthenticatedOrgIdSettingsLocationsCreateRoute
  AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute: typeof AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute
  AuthenticatedOrgIdSettingsNotificationsCreateRoute: typeof AuthenticatedOrgIdSettingsNotificationsCreateRoute
  AuthenticatedOrgIdSettingsStripeAccountManagementRoute: typeof AuthenticatedOrgIdSettingsStripeAccountManagementRoute
  AuthenticatedOrgIdSettingsStripeCardReadersRoute: typeof AuthenticatedOrgIdSettingsStripeCardReadersRoute
  AuthenticatedOrgIdSettingsStripeDisputesRoute: typeof AuthenticatedOrgIdSettingsStripeDisputesRoute
  AuthenticatedOrgIdSettingsStripeOnboardingRoute: typeof AuthenticatedOrgIdSettingsStripeOnboardingRoute
  AuthenticatedOrgIdSettingsStripePaymentMethodsRoute: typeof AuthenticatedOrgIdSettingsStripePaymentMethodsRoute
  AuthenticatedOrgIdSettingsStripePaymentsRoute: typeof AuthenticatedOrgIdSettingsStripePaymentsRoute
  AuthenticatedOrgIdSettingsStripePayoutsRoute: typeof AuthenticatedOrgIdSettingsStripePayoutsRoute
  AuthenticatedOrgIdSettingsStripeUpgradeRoute: typeof AuthenticatedOrgIdSettingsStripeUpgradeRoute
  AuthenticatedOrgIdSettingsTaxesHistoryRoute: typeof AuthenticatedOrgIdSettingsTaxesHistoryRoute
  AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute: typeof AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute
  AuthenticatedOrgIdSettingsTerminalsCreateRoute: typeof AuthenticatedOrgIdSettingsTerminalsCreateRoute
  AuthenticatedOrgIdUsersUserIdHistoryRoute: typeof AuthenticatedOrgIdUsersUserIdHistoryRoute
  AuthenticatedOrgIdMarketingDiscountsIndexRoute: typeof AuthenticatedOrgIdMarketingDiscountsIndexRoute
  AuthenticatedOrgIdProductsAddOnSetsIndexRoute: typeof AuthenticatedOrgIdProductsAddOnSetsIndexRoute
  AuthenticatedOrgIdProductsAddOnsIndexRoute: typeof AuthenticatedOrgIdProductsAddOnsIndexRoute
  AuthenticatedOrgIdProductsCollectionsIndexRoute: typeof AuthenticatedOrgIdProductsCollectionsIndexRoute
  AuthenticatedOrgIdProductsPriceChangesIndexRoute: typeof AuthenticatedOrgIdProductsPriceChangesIndexRoute
  AuthenticatedOrgIdReportsFloristPerformanceIndexRoute: typeof AuthenticatedOrgIdReportsFloristPerformanceIndexRoute
  AuthenticatedOrgIdReportsSalesSummaryIndexRoute: typeof AuthenticatedOrgIdReportsSalesSummaryIndexRoute
  AuthenticatedOrgIdReportsSalesIndexRoute: typeof AuthenticatedOrgIdReportsSalesIndexRoute
  AuthenticatedOrgIdReportsTipsIndexRoute: typeof AuthenticatedOrgIdReportsTipsIndexRoute
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute: typeof AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute
  AuthenticatedOrgIdSettingsBillingIndexRoute: typeof AuthenticatedOrgIdSettingsBillingIndexRoute
  AuthenticatedOrgIdSettingsCashDrawerIndexRoute: typeof AuthenticatedOrgIdSettingsCashDrawerIndexRoute
  AuthenticatedOrgIdSettingsCheckoutIndexRoute: typeof AuthenticatedOrgIdSettingsCheckoutIndexRoute
  AuthenticatedOrgIdSettingsCondolencesIndexRoute: typeof AuthenticatedOrgIdSettingsCondolencesIndexRoute
  AuthenticatedOrgIdSettingsDomainsIndexRoute: typeof AuthenticatedOrgIdSettingsDomainsIndexRoute
  AuthenticatedOrgIdSettingsEmailMarketingIndexRoute: typeof AuthenticatedOrgIdSettingsEmailMarketingIndexRoute
  AuthenticatedOrgIdSettingsFeesIndexRoute: typeof AuthenticatedOrgIdSettingsFeesIndexRoute
  AuthenticatedOrgIdSettingsFsnNetworkIndexRoute: typeof AuthenticatedOrgIdSettingsFsnNetworkIndexRoute
  AuthenticatedOrgIdSettingsLocationsIndexRoute: typeof AuthenticatedOrgIdSettingsLocationsIndexRoute
  AuthenticatedOrgIdSettingsNotificationsIndexRoute: typeof AuthenticatedOrgIdSettingsNotificationsIndexRoute
  AuthenticatedOrgIdSettingsSnapdragonIndexRoute: typeof AuthenticatedOrgIdSettingsSnapdragonIndexRoute
  AuthenticatedOrgIdSettingsStripeIndexRoute: typeof AuthenticatedOrgIdSettingsStripeIndexRoute
  AuthenticatedOrgIdSettingsSubscriptionsIndexRoute: typeof AuthenticatedOrgIdSettingsSubscriptionsIndexRoute
  AuthenticatedOrgIdSettingsSuperticketsIndexRoute: typeof AuthenticatedOrgIdSettingsSuperticketsIndexRoute
  AuthenticatedOrgIdSettingsTaxesIndexRoute: typeof AuthenticatedOrgIdSettingsTaxesIndexRoute
  AuthenticatedOrgIdSettingsTerminalsIndexRoute: typeof AuthenticatedOrgIdSettingsTerminalsIndexRoute
  AuthenticatedOrgIdUsersUserIdIndexRoute: typeof AuthenticatedOrgIdUsersUserIdIndexRoute
  AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute: typeof AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute
}

const AuthenticatedOrgIdRouteChildren: AuthenticatedOrgIdRouteChildren = {
  AuthenticatedOrgIdActivityRoute: AuthenticatedOrgIdActivityRoute,
  AuthenticatedOrgIdAdminRoute: AuthenticatedOrgIdAdminRoute,
  AuthenticatedOrgIdImportsRoute: AuthenticatedOrgIdImportsRouteWithChildren,
  AuthenticatedOrgIdMoneyRoute: AuthenticatedOrgIdMoneyRouteWithChildren,
  AuthenticatedOrgIdNoticationsCenterRoute:
    AuthenticatedOrgIdNoticationsCenterRoute,
  AuthenticatedOrgIdWebsiteRoute: AuthenticatedOrgIdWebsiteRouteWithChildren,
  AuthenticatedOrgIdContractsCreateRoute:
    AuthenticatedOrgIdContractsCreateRoute,
  AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute:
    AuthenticatedOrgIdCustomerReviewsCustomerReviewIdRoute,
  AuthenticatedOrgIdCustomersCustomerIdRoute:
    AuthenticatedOrgIdCustomersCustomerIdRoute,
  AuthenticatedOrgIdCustomersCreateRoute:
    AuthenticatedOrgIdCustomersCreateRoute,
  AuthenticatedOrgIdDesignsDesignIdRoute:
    AuthenticatedOrgIdDesignsDesignIdRoute,
  AuthenticatedOrgIdDesignsCreateRoute: AuthenticatedOrgIdDesignsCreateRoute,
  AuthenticatedOrgIdMessagesMessageIdRoute:
    AuthenticatedOrgIdMessagesMessageIdRoute,
  AuthenticatedOrgIdMessagesCreateRoute: AuthenticatedOrgIdMessagesCreateRoute,
  AuthenticatedOrgIdOrganizationsOrganizationIdRoute:
    AuthenticatedOrgIdOrganizationsOrganizationIdRouteWithChildren,
  AuthenticatedOrgIdOrganizationsCreateRoute:
    AuthenticatedOrgIdOrganizationsCreateRoute,
  AuthenticatedOrgIdPricingCreateRoute: AuthenticatedOrgIdPricingCreateRoute,
  AuthenticatedOrgIdProductsProductIdRoute:
    AuthenticatedOrgIdProductsProductIdRoute,
  AuthenticatedOrgIdProductsAllProductsRoute:
    AuthenticatedOrgIdProductsAllProductsRoute,
  AuthenticatedOrgIdProductsCatalogBuilderRoute:
    AuthenticatedOrgIdProductsCatalogBuilderRoute,
  AuthenticatedOrgIdProductsCreateRoute: AuthenticatedOrgIdProductsCreateRoute,
  AuthenticatedOrgIdProductsInventoryRoute:
    AuthenticatedOrgIdProductsInventoryRoute,
  AuthenticatedOrgIdReportsAccountingJournalRoute:
    AuthenticatedOrgIdReportsAccountingJournalRouteWithChildren,
  AuthenticatedOrgIdReportsCashDrawerRoute:
    AuthenticatedOrgIdReportsCashDrawerRouteWithChildren,
  AuthenticatedOrgIdReportsClosedDaysRoute:
    AuthenticatedOrgIdReportsClosedDaysRouteWithChildren,
  AuthenticatedOrgIdReportsCustomerBalancesRoute:
    AuthenticatedOrgIdReportsCustomerBalancesRoute,
  AuthenticatedOrgIdReportsDepositsRoute:
    AuthenticatedOrgIdReportsDepositsRouteWithChildren,
  AuthenticatedOrgIdReportsExternalOrdersRoute:
    AuthenticatedOrgIdReportsExternalOrdersRoute,
  AuthenticatedOrgIdReportsPhoneClicksRoute:
    AuthenticatedOrgIdReportsPhoneClicksRouteWithChildren,
  AuthenticatedOrgIdReportsPlatformLedgerRoute:
    AuthenticatedOrgIdReportsPlatformLedgerRouteWithChildren,
  AuthenticatedOrgIdReportsSalesStatisticsRoute:
    AuthenticatedOrgIdReportsSalesStatisticsRouteWithChildren,
  AuthenticatedOrgIdReportsSalesTaxRoute:
    AuthenticatedOrgIdReportsSalesTaxRouteWithChildren,
  AuthenticatedOrgIdReportsWiredOrdersRoute:
    AuthenticatedOrgIdReportsWiredOrdersRoute,
  AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute:
    AuthenticatedOrgIdSalesOrdersSalesOrderIdRoute,
  AuthenticatedOrgIdSalesOrdersCreateRoute:
    AuthenticatedOrgIdSalesOrdersCreateRoute,
  AuthenticatedOrgIdSalesOrdersDraftsRoute:
    AuthenticatedOrgIdSalesOrdersDraftsRoute,
  AuthenticatedOrgIdSalesOrdersWireInRoute:
    AuthenticatedOrgIdSalesOrdersWireInRoute,
  AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute:
    AuthenticatedOrgIdSeasonalContentSeasonalDesignIdRoute,
  AuthenticatedOrgIdSeasonalContentCreateRoute:
    AuthenticatedOrgIdSeasonalContentCreateRoute,
  AuthenticatedOrgIdSettingsIntegrationsRoute:
    AuthenticatedOrgIdSettingsIntegrationsRouteWithChildren,
  AuthenticatedOrgIdStockImagesStockImageIdRoute:
    AuthenticatedOrgIdStockImagesStockImageIdRoute,
  AuthenticatedOrgIdStockImagesCreateRoute:
    AuthenticatedOrgIdStockImagesCreateRoute,
  AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute:
    AuthenticatedOrgIdSubscriptionsFlowerSubscriptionIdRoute,
  AuthenticatedOrgIdUsersCreateRoute: AuthenticatedOrgIdUsersCreateRoute,
  AuthenticatedOrgIdWhatsNewAppUpdateIdRoute:
    AuthenticatedOrgIdWhatsNewAppUpdateIdRoute,
  AuthenticatedOrgIdWhatsNewCreateRoute: AuthenticatedOrgIdWhatsNewCreateRoute,
  AuthenticatedOrgIdApiTokensIndexRoute: AuthenticatedOrgIdApiTokensIndexRoute,
  AuthenticatedOrgIdAvailabilityIndexRoute:
    AuthenticatedOrgIdAvailabilityIndexRoute,
  AuthenticatedOrgIdContractsIndexRoute: AuthenticatedOrgIdContractsIndexRoute,
  AuthenticatedOrgIdCustomerReviewsIndexRoute:
    AuthenticatedOrgIdCustomerReviewsIndexRoute,
  AuthenticatedOrgIdCustomersIndexRoute: AuthenticatedOrgIdCustomersIndexRoute,
  AuthenticatedOrgIdDesignsIndexRoute: AuthenticatedOrgIdDesignsIndexRoute,
  AuthenticatedOrgIdMarketingIndexRoute: AuthenticatedOrgIdMarketingIndexRoute,
  AuthenticatedOrgIdMessagesIndexRoute: AuthenticatedOrgIdMessagesIndexRoute,
  AuthenticatedOrgIdOrganizationsIndexRoute:
    AuthenticatedOrgIdOrganizationsIndexRoute,
  AuthenticatedOrgIdPricingIndexRoute: AuthenticatedOrgIdPricingIndexRoute,
  AuthenticatedOrgIdProductsIndexRoute: AuthenticatedOrgIdProductsIndexRoute,
  AuthenticatedOrgIdReportsIndexRoute: AuthenticatedOrgIdReportsIndexRoute,
  AuthenticatedOrgIdSalesOrdersIndexRoute:
    AuthenticatedOrgIdSalesOrdersIndexRoute,
  AuthenticatedOrgIdSeasonalContentIndexRoute:
    AuthenticatedOrgIdSeasonalContentIndexRoute,
  AuthenticatedOrgIdSettingsIndexRoute: AuthenticatedOrgIdSettingsIndexRoute,
  AuthenticatedOrgIdStockImagesIndexRoute:
    AuthenticatedOrgIdStockImagesIndexRoute,
  AuthenticatedOrgIdSubscriptionsIndexRoute:
    AuthenticatedOrgIdSubscriptionsIndexRoute,
  AuthenticatedOrgIdUsersIndexRoute: AuthenticatedOrgIdUsersIndexRoute,
  AuthenticatedOrgIdWhatsNewIndexRoute: AuthenticatedOrgIdWhatsNewIndexRoute,
  AuthenticatedOrgIdCustomersCustomerIdHistoryRoute:
    AuthenticatedOrgIdCustomersCustomerIdHistoryRoute,
  AuthenticatedOrgIdDesignsDesignIdHistoryRoute:
    AuthenticatedOrgIdDesignsDesignIdHistoryRoute,
  AuthenticatedOrgIdGalleryAlbumAlbumIdRoute:
    AuthenticatedOrgIdGalleryAlbumAlbumIdRoute,
  AuthenticatedOrgIdGalleryAlbumCreateRoute:
    AuthenticatedOrgIdGalleryAlbumCreateRoute,
  AuthenticatedOrgIdProductsProductIdHistoryRoute:
    AuthenticatedOrgIdProductsProductIdHistoryRoute,
  AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute:
    AuthenticatedOrgIdProductsAddOnSetsAddOnSetIdRoute,
  AuthenticatedOrgIdProductsAddOnSetsCreateRoute:
    AuthenticatedOrgIdProductsAddOnSetsCreateRoute,
  AuthenticatedOrgIdProductsAddOnsAddOnIdRoute:
    AuthenticatedOrgIdProductsAddOnsAddOnIdRoute,
  AuthenticatedOrgIdProductsAddOnsCreateRoute:
    AuthenticatedOrgIdProductsAddOnsCreateRoute,
  AuthenticatedOrgIdProductsCollectionsCollectionIdRoute:
    AuthenticatedOrgIdProductsCollectionsCollectionIdRoute,
  AuthenticatedOrgIdProductsCollectionsCreateRoute:
    AuthenticatedOrgIdProductsCollectionsCreateRoute,
  AuthenticatedOrgIdProductsCollectionsImportRoute:
    AuthenticatedOrgIdProductsCollectionsImportRoute,
  AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute:
    AuthenticatedOrgIdProductsPriceChangesPriceAdjustmentIdRoute,
  AuthenticatedOrgIdProductsPriceChangesCreateRoute:
    AuthenticatedOrgIdProductsPriceChangesCreateRoute,
  AuthenticatedOrgIdReportsSalesSummaryDateRoute:
    AuthenticatedOrgIdReportsSalesSummaryDateRoute,
  AuthenticatedOrgIdReportsSalesDateRoute:
    AuthenticatedOrgIdReportsSalesDateRoute,
  AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute:
    AuthenticatedOrgIdSalesOrdersSalesOrderIdEditRoute,
  AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute:
    AuthenticatedOrgIdSalesOrdersSalesOrderIdHistoryRoute,
  AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute:
    AuthenticatedOrgIdSalesOrdersSalesOrderIdJournalRoute,
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRoute:
    AuthenticatedOrgIdSalesOrdersDeliveryRoutesDeliveryShareIdRouteWithChildren,
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute:
    AuthenticatedOrgIdSalesOrdersDeliveryRoutesCreateRoute,
  AuthenticatedOrgIdSettingsBillingHistoryRoute:
    AuthenticatedOrgIdSettingsBillingHistoryRoute,
  AuthenticatedOrgIdSettingsCashDrawerHistoryRoute:
    AuthenticatedOrgIdSettingsCashDrawerHistoryRoute,
  AuthenticatedOrgIdSettingsDomainsDomainIdRoute:
    AuthenticatedOrgIdSettingsDomainsDomainIdRoute,
  AuthenticatedOrgIdSettingsDomainsCreateRoute:
    AuthenticatedOrgIdSettingsDomainsCreateRoute,
  AuthenticatedOrgIdSettingsFeesHistoryRoute:
    AuthenticatedOrgIdSettingsFeesHistoryRoute,
  AuthenticatedOrgIdSettingsLocationsLocationIdRoute:
    AuthenticatedOrgIdSettingsLocationsLocationIdRouteWithChildren,
  AuthenticatedOrgIdSettingsLocationsCreateRoute:
    AuthenticatedOrgIdSettingsLocationsCreateRoute,
  AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute:
    AuthenticatedOrgIdSettingsNotificationsRecipientIdRoute,
  AuthenticatedOrgIdSettingsNotificationsCreateRoute:
    AuthenticatedOrgIdSettingsNotificationsCreateRoute,
  AuthenticatedOrgIdSettingsStripeAccountManagementRoute:
    AuthenticatedOrgIdSettingsStripeAccountManagementRoute,
  AuthenticatedOrgIdSettingsStripeCardReadersRoute:
    AuthenticatedOrgIdSettingsStripeCardReadersRoute,
  AuthenticatedOrgIdSettingsStripeDisputesRoute:
    AuthenticatedOrgIdSettingsStripeDisputesRoute,
  AuthenticatedOrgIdSettingsStripeOnboardingRoute:
    AuthenticatedOrgIdSettingsStripeOnboardingRoute,
  AuthenticatedOrgIdSettingsStripePaymentMethodsRoute:
    AuthenticatedOrgIdSettingsStripePaymentMethodsRoute,
  AuthenticatedOrgIdSettingsStripePaymentsRoute:
    AuthenticatedOrgIdSettingsStripePaymentsRoute,
  AuthenticatedOrgIdSettingsStripePayoutsRoute:
    AuthenticatedOrgIdSettingsStripePayoutsRoute,
  AuthenticatedOrgIdSettingsStripeUpgradeRoute:
    AuthenticatedOrgIdSettingsStripeUpgradeRoute,
  AuthenticatedOrgIdSettingsTaxesHistoryRoute:
    AuthenticatedOrgIdSettingsTaxesHistoryRoute,
  AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute:
    AuthenticatedOrgIdSettingsTerminalsTerminalIdRoute,
  AuthenticatedOrgIdSettingsTerminalsCreateRoute:
    AuthenticatedOrgIdSettingsTerminalsCreateRoute,
  AuthenticatedOrgIdUsersUserIdHistoryRoute:
    AuthenticatedOrgIdUsersUserIdHistoryRoute,
  AuthenticatedOrgIdMarketingDiscountsIndexRoute:
    AuthenticatedOrgIdMarketingDiscountsIndexRoute,
  AuthenticatedOrgIdProductsAddOnSetsIndexRoute:
    AuthenticatedOrgIdProductsAddOnSetsIndexRoute,
  AuthenticatedOrgIdProductsAddOnsIndexRoute:
    AuthenticatedOrgIdProductsAddOnsIndexRoute,
  AuthenticatedOrgIdProductsCollectionsIndexRoute:
    AuthenticatedOrgIdProductsCollectionsIndexRoute,
  AuthenticatedOrgIdProductsPriceChangesIndexRoute:
    AuthenticatedOrgIdProductsPriceChangesIndexRoute,
  AuthenticatedOrgIdReportsFloristPerformanceIndexRoute:
    AuthenticatedOrgIdReportsFloristPerformanceIndexRoute,
  AuthenticatedOrgIdReportsSalesSummaryIndexRoute:
    AuthenticatedOrgIdReportsSalesSummaryIndexRoute,
  AuthenticatedOrgIdReportsSalesIndexRoute:
    AuthenticatedOrgIdReportsSalesIndexRoute,
  AuthenticatedOrgIdReportsTipsIndexRoute:
    AuthenticatedOrgIdReportsTipsIndexRoute,
  AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute:
    AuthenticatedOrgIdSalesOrdersDeliveryRoutesIndexRoute,
  AuthenticatedOrgIdSettingsBillingIndexRoute:
    AuthenticatedOrgIdSettingsBillingIndexRoute,
  AuthenticatedOrgIdSettingsCashDrawerIndexRoute:
    AuthenticatedOrgIdSettingsCashDrawerIndexRoute,
  AuthenticatedOrgIdSettingsCheckoutIndexRoute:
    AuthenticatedOrgIdSettingsCheckoutIndexRoute,
  AuthenticatedOrgIdSettingsCondolencesIndexRoute:
    AuthenticatedOrgIdSettingsCondolencesIndexRoute,
  AuthenticatedOrgIdSettingsDomainsIndexRoute:
    AuthenticatedOrgIdSettingsDomainsIndexRoute,
  AuthenticatedOrgIdSettingsEmailMarketingIndexRoute:
    AuthenticatedOrgIdSettingsEmailMarketingIndexRoute,
  AuthenticatedOrgIdSettingsFeesIndexRoute:
    AuthenticatedOrgIdSettingsFeesIndexRoute,
  AuthenticatedOrgIdSettingsFsnNetworkIndexRoute:
    AuthenticatedOrgIdSettingsFsnNetworkIndexRoute,
  AuthenticatedOrgIdSettingsLocationsIndexRoute:
    AuthenticatedOrgIdSettingsLocationsIndexRoute,
  AuthenticatedOrgIdSettingsNotificationsIndexRoute:
    AuthenticatedOrgIdSettingsNotificationsIndexRoute,
  AuthenticatedOrgIdSettingsSnapdragonIndexRoute:
    AuthenticatedOrgIdSettingsSnapdragonIndexRoute,
  AuthenticatedOrgIdSettingsStripeIndexRoute:
    AuthenticatedOrgIdSettingsStripeIndexRoute,
  AuthenticatedOrgIdSettingsSubscriptionsIndexRoute:
    AuthenticatedOrgIdSettingsSubscriptionsIndexRoute,
  AuthenticatedOrgIdSettingsSuperticketsIndexRoute:
    AuthenticatedOrgIdSettingsSuperticketsIndexRoute,
  AuthenticatedOrgIdSettingsTaxesIndexRoute:
    AuthenticatedOrgIdSettingsTaxesIndexRoute,
  AuthenticatedOrgIdSettingsTerminalsIndexRoute:
    AuthenticatedOrgIdSettingsTerminalsIndexRoute,
  AuthenticatedOrgIdUsersUserIdIndexRoute:
    AuthenticatedOrgIdUsersUserIdIndexRoute,
  AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute:
    AuthenticatedOrgIdUsersUserIdRolesRoleIdRoute,
}

const AuthenticatedOrgIdRouteWithChildren =
  AuthenticatedOrgIdRoute._addFileChildren(AuthenticatedOrgIdRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedOrgIdRoute: typeof AuthenticatedOrgIdRouteWithChildren
  AuthenticatedStripeConnectRoute: typeof AuthenticatedStripeConnectRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrgIdRoute: AuthenticatedOrgIdRouteWithChildren,
  AuthenticatedStripeConnectRoute: AuthenticatedStripeConnectRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authSignUpRoute: authSignUpRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authResetPasswordTokenRoute: authResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
